/*
* @描述: 自定义表单移动端
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2024-11-06 10:19:35
*/
<template>
    <div class="custom_form_wrap" :class="{'overflow_hidden':showRadioPicker}" v-loading="loading">
        <van-form ref="customForm"
                  input-align="right"
                  label-width="10em"
                  error-message-align="right"
                  scroll-to-error>
            <div v-for="field in formInfoList.filter(field=>!field.initial_display)"
                 :key="field.field_key"
                 :class="field.field_type==='form_module'?'':'field_outer_wrap'">
                <div v-if="field.field_type==='form_module'" class="form_module_title">
                    <span class="field_name" v-text="field.field_name"></span>
                    <el-link v-if="field.has_parse_address&&customForm.is_deliver&&customForm.is_deliver.value"
                             :underline="false"
                             type="primary"
                             @click="handleClickParseInfo">
                        <i class="iconfont icon-shibiewenzi"></i> 粘贴信息识别
                    </el-link>
                    <el-link v-if="field.field_key==='goods_information'"
                             :disabled="order_procurement_show"
                             :underline="false"
                             type="primary"
                             @click="order_procurement_show=true">
                        <i class="el-icon-plus"></i> 订单代采
                    </el-link>
                    <el-link v-if="field.field_key==='basic_information'&&pk_id===0"
                             @click="handleClickImportQuotation"
                             :underline="false"
                             type="primary">
                        <i class="iconfont icon-daochu"></i> 导入报价单
                    </el-link>
                </div>
                <div v-else-if="field.field_type==='input'">

                    <van-popover v-if="field.field_key == 'supplier_name'" v-model="supplierNamePopoverShow"
                                 :get-container="getContainerPurchaseDetails" :offset="[30,0]"
                                 :show-arrow="false" placement="bottom-start" style="right: 0 !important;display: block"
                                 trigger="click">
                        <div v-if="supplierList.length>0" class="productItemBox">
                            <div v-for="list in supplierList" class="product_item flex_js_wrap"
                                 @click="handleClickSelectSupplierName(field,customForm,list)">
                                <div class="product_name ellipsis">{{ list.name }}</div>
                            </div>
                        </div>
                        <template #reference>
                            <van-field v-model="customForm[field.field_key].value"
                                       :disabled="field.field_disabled"
                                       :label="field.field_name"
                                       :placeholder="field.placeholder"
                                       :required="field.is_required===1"
                                       :rules="customFormRules[field.field_key]"
                                       error-message-align="right"
                                       @input="handleInputSupplierName(customForm[field.field_key].value)"></van-field>
                        </template>
                    </van-popover>

                    <van-field v-else
                               v-model="customForm[field.field_key].value"
                               :label="field.field_name"
                               :disabled="field.field_disabled"
                               :placeholder="field.placeholder"
                               :required="field.is_required===1"
                               :rules="customFormRules[field.field_key]"
                               error-message-align="right">
                    </van-field>
                </div>
                <div v-else-if="field.field_type==='textarea'" class="vertical_input_wrap">
                    <van-field v-model="customForm[field.field_key].value"
                               :label="field.field_name"
                               :name="field.field_key"
                               :placeholder="field.placeholder"
                               :required="field.is_required===1"
                               :rules="customFormRules[field.field_key]"
                               :disabled="field.field_disabled"
                               maxlength="600"
                               type="textarea">
                    </van-field>
                </div>
                <van-field v-else-if="field.field_type==='number'"
                           v-model="customForm[field.field_key].value"
                           :label="field.field_name"
                           :name="field.field_key"
                           :placeholder="field.placeholder"
                           :required="field.is_required===1"
                           type="number"
                           @blur="handleNumberInputBlur(field,customForm,formInfoList)"
                           :disabled="field.field_disabled"
                           :rules="customFormRules[field.field_key]"
                           error-message-align="right">
                    <template #button>
                        <span v-text="field.unit"></span>
                    </template>
                </van-field>
                <van-field v-else-if="field.field_type==='money'"
                           v-model="customForm[field.field_key].text"
                           :label="field.field_name"
                           :name="field.field_key"
                           :placeholder="field.placeholder"
                           :required="field.is_required===1"
                           type="number"
                           @blur="handlePriceInputBlur(field,customForm,formInfoList)"
                           :disabled="field.field_disabled"
                           :rules="customFormRules[field.field_key]"
                           error-message-align="right">
                </van-field>
                <van-field v-else-if="field.field_type==='compute_mode'"
                           v-model="customForm[field.field_key].value"
                           :label="field.field_name"
                           :name="field.field_key"
                           :required="field.is_required===1"
                           :rules="customFormRules[field.field_key]"
                           disabled
                           placeholder="系统自动计算"
                           readonly>
                </van-field>
                <div v-else-if="field.field_type==='order_amount_compute_mode'">
                    <van-field v-if="field.filling_method==='1'"
                               v-model="customForm[field.field_key].text"
                               :label="field.field_name"
                               :name="field.field_key"
                               :required="field.is_required===1"
                               :rules="customFormRules[field.field_key]"
                               placeholder="自动算出"
                               readonly>
                        <template #label>
                            <div class="flex_wrap">
                                <span v-text="field.field_name"></span>
                                <span class="handle_icon_wrap" @click="handleClickShowFormula(field.formula)">
                                <i class="iconfont icon-yiwen"></i>
                            </span>
                            </div>
                        </template>
                    </van-field>
                    <van-field v-else
                               v-model="customForm[field.field_key].text"
                               :label="field.field_name"
                               :name="field.field_key"
                               :placeholder="'请输入'+field.field_name"
                               :rules="customFormRules[field.field_key]">
                    </van-field>
                </div>
                <div v-else-if="field.field_type==='telephone'">
                    <van-field :name="field.field_key"
                               :required="field.is_required===1"
                               label="电话类型"
                               v-if="field.phone_type==='3'">
                        <template #input>
                            <van-radio-group
                                    :disabled="field.field_disabled"
                                    @change="handleTelPhoneTypeChange($event,customForm,field.field_key)"
                                    direction="horizontal"
                                    v-model="customForm[field.field_key].phone_type">
                                <van-radio name="1">手机</van-radio>
                                <van-radio name="2">固话</van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>
                    <van-field :name="field.field_key"
                               :placeholder="field.placeholder"
                               :readonly="customForm[field.field_key].phone_type==='1'"
                               v-model="customForm[field.field_key].prefix"
                               :rules="customFormRules[field.field_key].prefix"
                               :type="customForm[field.field_key].phone_type==='2'?'digit':''"
                               :disabled="field.field_disabled"
                               label="区号"
                               maxlength="4"
                               v-if="customForm[field.field_key].phone_type==='2'"
                               :required="field.is_required===1"
                               error-message-align="right">
                    </van-field>
                    <van-field
                            :label="customForm[field.field_key].phone_type==='1'?field.field_name+'（+86）':field.field_name"
                            :name="field.field_key"
                            :placeholder="field.placeholder"
                            v-model="customForm[field.field_key].value"
                            :rules="customFormRules[field.field_key].value"
                            :disabled="(pk_id!==0&&field.hasOwnProperty('can_not_edit'))|| field.field_disabled "
                            :required="field.is_required===1"
                            error-message-align="right">
                    </van-field>
                </div>
                <van-field v-else-if="field.field_type==='radio'"
                           v-model="customForm[field.field_key].text"
                           :label="field.field_name"
                           :name="field.field_key"
                           :placeholder="field.placeholder"
                           :required="field.is_required===1"
                           :rules="customFormRules[field.field_key]"
                           :disabled="field.field_disabled"
                           @click="handleClickRadioFieldLink(field,customForm,formInfoList)"
                           is-link
                           error-message-align="right"
                           readonly>
                </van-field>
                <div v-else-if="field.field_type==='radio_project_stage'">
                    <van-field v-model="customForm[field.field_key].text"
                               :disabled="field.field_disabled||pk_id!==0&&is_release===1"
                               :label="field.field_name"
                               :name="field.field_key"
                               :placeholder="field.placeholder"
                               :required="field.is_required===1"
                               :rules="customFormRules[field.field_key]"
                               error-message-align="right"
                               is-link
                               readonly
                               @click="handleClickRadioProjectStageFieldLink(field,customForm)">
                    </van-field>
                    <p v-if="pk_id!==0&&is_release===1&&old_project_group_id!==customForm.project_group_id"
                       class="project_group_id_change">因字段内容修改，商机阶段有变更</p>
                </div>
                <van-field v-else-if="field.field_type==='radio_customer'"
                           v-model="customForm[field.field_key].text"
                           :disabled="field.field_disabled"
                           :label="field.field_name"
                           :name="field.field_key"
                           :placeholder="field.placeholder"
                           :required="field.is_required===1"
                           :rules="customFormRules[field.field_key]"
                           @click="handleClickRelateCustom(field,customForm)"
                           error-message-align="right"
                           readonly>
                    <template #right-icon>
                        <div class="flex_wrap">
                            <van-icon name="arrow"/>
                            <van-icon class="link-label" name="add"
                                      @click.stop="handleClickAddRelateForm(field,customForm,'customers')"/>
                        </div>
                    </template>
                </van-field>
                <van-field v-else-if="field.field_type==='radio_project'"
                           v-model="customForm[field.field_key].text"
                           :disabled="field.field_disabled"
                           :label="field.field_name"
                           :name="field.field_key"
                           :placeholder="field.placeholder"
                           :required="field.is_required===1"
                           :rules="customFormRules[field.field_key]"
                           @click="handleClickRelateProject(field,customForm)"
                           error-message-align="right"
                           readonly>
                    <template #right-icon>
                        <div class="flex_wrap">
                            <van-icon name="arrow"/>
                            <van-icon class="link-label" name="add"
                                      @click.stop="handleClickAddRelateForm(field,customForm,'projects')"/>
                        </div>
                    </template>
                </van-field>
                <van-field v-else-if="field.field_type==='radio_order'"
                           v-model="customForm[field.field_key].text"
                           :disabled="field.field_disabled"
                           :label="field.field_name"
                           :name="field.field_key"
                           :placeholder="field.placeholder"
                           :required="field.is_required===1"
                           :rules="customFormRules[field.field_key]"
                           readonly
                           error-message-align="right"
                           @click="handleClickRelateOrder(field,customForm)">
                    <template #right-icon>
                        <div class="flex_wrap">
                            <van-icon name="arrow"/>
                            <van-icon name="add" @click.stop="handleClickAddRelateForm(field,customForm,'orders')"/>
                        </div>
                    </template>
                </van-field>
                <van-field v-else-if="field.field_type==='customer_contact'"
                           :disabled="field.field_disabled"
                           :label="field.field_name"
                           :name="field.field_key"
                           :placeholder="field.placeholder"
                           :required="field.is_required===1"
                           :rules="customFormRules[field.field_key]"
                           :value="customForm[field.field_key].value&&customForm[field.field_key].value.length?customForm[field.field_key].value.join():''"
                           error-message-align="right"
                           readonly
                           @click="handleClickRelateCustomContact(field,customForm)">
                    <template #input>
                        <div v-if="customForm[field.field_key] && customForm[field.field_key].text.length>0"
                             class="crm_contact_box">
                            <van-tag v-for="(contact,index) in customForm[field.field_key].text"
                                     closeable
                                     size="large"
                                     type="primary"
                                     @click.stop="handleClickEditCrmContact(field,customForm,contact)"
                                     @close.stop="handleClickCloseCrmContactTag(field.field_key,contact,index)">
                                {{ contact.name }}
                            </van-tag>
                        </div>
                    </template>
                    <template #right-icon>
                        <div class="flex_wrap">
                            <van-icon name="arrow"/>
                            <van-icon class="link-label" name="add"
                                      @click.stop="handleClickAddRelateForm(field,customForm,'customer_contacts')"/>
                        </div>
                    </template>
                </van-field>
                <van-field v-else-if="field.field_type==='checkbox'"
                           :label="field.field_name"
                           :name="field.field_key"
                           :placeholder="field.placeholder"
                           :required="field.is_required===1"
                           :rules="customFormRules[field.field_key]"
                           :value="customForm[field.field_key].text.join()"
                           :disabled="field.field_disabled"
                           @click="handleClickCheckboxFieldLink(field,customForm,formInfoList)"
                           is-link
                           error-message-align="right"
                           readonly>
                </van-field>
                <van-field v-else-if="field.field_type==='checkbox_user_tag'"
                           :label="field.field_name"
                           :name="field.field_key"
                           :placeholder="field.placeholder"
                           :required="field.is_required===1"
                           :rules="customFormRules[field.field_key]"
                           :value="customForm[field.field_key].text.join()"
                           :disabled="field.field_disabled"
                           @click="handleClickCheckboxFieldLink(field,customForm,formInfoList)"
                           is-link
                           error-message-align="right"
                           readonly>
                </van-field>
                <van-field v-else-if="field.field_type==='checkbox_quotation'"
                           :disabled="field.field_disabled"
                           :label="field.field_name"
                           :name="field.field_key"
                           :placeholder="field.placeholder"
                           :required="field.is_required===1"
                           :rules="customFormRules[field.field_key]"
                           :value="customForm[field.field_key].text.map(item=>item.name).join()"
                           error-message-align="right"
                           is-link
                           readonly
                           @click="handleClickCheckboxFieldLink(field,customForm,formInfoList)">
                </van-field>
                <van-field v-else-if="field.field_type==='cascader'"
                           :label="field.field_name"
                           :name="field.field_key"
                           :placeholder="field.placeholder"
                           :required="field.is_required===1"
                           :rules="customFormRules[field.field_key]"
                           :value="customForm[field.field_key].text"
                           :disabled="field.field_disabled"
                           @click="handleClickCascaderFieldLink(field,customForm)"
                           is-link
                           error-message-align="right"
                           readonly>
                </van-field>
                <van-field v-else-if="field.field_type==='department'"
                           :label="field.field_name"
                           :name="field.field_key"
                           :placeholder="field.placeholder"
                           :required="field.is_required===1"
                           :rules="customFormRules[field.field_key]"
                           :disabled="field.default||field.field_disabled"
                           :value="customForm[field.field_key].titles.join()"
                           @click="handleClickCascaderFieldLink(field,customForm)"
                           :is-link="!field.default"
                           error-message-align="right"
                           readonly>
                </van-field>
                <van-field v-else-if="field.field_type==='contact'"
                           :label="field.field_name"
                           :name="field.field_key"
                           :placeholder="field.placeholder"
                           :required="field.is_required===1"
                           :rules="customFormRules[field.field_key]"
                           :disabled="(field.default&&field.default_can_edit==='2')||field.field_disabled"
                           :value="customForm[field.field_key].text.map(user=>user.name).join()"
                           @click="handleClickContactFieldLink(field,customForm)"
                           :is-link="field.default&&field.default_can_edit==='1'"
                           error-message-align="right"
                           readonly>
                </van-field>
                <van-field v-else-if="field.field_type==='date'"
                           :label="field.field_name"
                           :name="field.field_key"
                           :placeholder="field.default?'由系统提供时间':field.placeholder"
                           :required="field.is_required===1"
                           :rules="customFormRules[field.field_key]"
                           :value="customForm[field.field_key].value"
                           :disabled="field.default||field.field_disabled"
                           @click="handleClickDateFieldLink(field,customForm,formInfoList)"
                           :is-link="!field.default"
                           error-message-align="right"
                           readonly>
                </van-field>
                <div v-else-if="field.field_type==='address'">
                    <van-field :label="field.field_name"
                               :name="field.field_key"
                               :placeholder="field.area_accuracy_placeholder"
                               :required="field.is_required===1"
                               :rules="customFormRules[field.field_key]?customFormRules[field.field_key].value:[]"
                               :value="customForm[field.field_key].text"
                               :disabled="field.field_disabled"
                               @click="handleClickCascaderFieldLink(field,customForm)"
                               is-link
                               error-message-align="right"
                               readonly>
                    </van-field>
                    <div class="vertical_input_wrap">
                        <van-field :name="field.field_key"
                                   style="margin-top: 0"
                                   :placeholder="field.detail_address_placeholder"
                                   :rules="customFormRules[field.field_key]?customFormRules[field.field_key].detail_address:[]"
                                   maxlength="30"
                                   type="textarea"
                                   v-if="field.is_show_detail_address"
                                   v-model="customForm[field.field_key].detail_address">
                        </van-field>
                    </div>
                </div>
                <div v-else-if="field.field_type==='date_range'">
                    <van-field :label="field.field_name"
                               :name="field.field_key"
                               :placeholder="'请选择'+field.field_name"
                               :required="field.is_required===1"
                               :rules="customFormRules[field.field_key]"
                               :value="customForm[field.field_key].text"
                               :disabled="field.field_disabled"
                               @click="handleClickDateRangeFieldLink(field,customForm)"
                               error-message-align="right"
                               is-link
                               readonly>
                    </van-field>
                    <van-field label="时长"
                               v-if="field.auto_computed"
                               :name="field.field_key"
                               placeholder="自动计算"
                               disabled
                               :value="customForm[field.field_key].duration"
                               readonly>
                        <template #button>
                            <span>天</span>
                        </template>
                    </van-field>
                </div>
                <div v-else-if="field.field_type==='explain'" class="explain_wrap" v-text="field.explain"></div>
                <div v-else-if="field.field_type==='image'" class="vertical_input_wrap">
                    <van-field :label="field.field_name"
                               :name="field.field_key"
                               :required="field.is_required===1"
                               :rules="customFormRules[field.field_key]"
                               :disabled="field.field_disabled"
                               readonly>
                        <template #input>
                            <div class="image_outer_wrap">
                                <div v-if="is_preview_mode" class="image_upload_wrap"
                                     @click="handleClickPreviewModeBtn">
                                    <i class="el-icon-plus"></i>
                                </div>
                                <ul v-else class="upload_image_list">
                                    <li v-for="item in customForm[field.field_key]"
                                        :key="item.file_path"
                                        class="upload_image_item">
                                        <el-image
                                                :preview-src-list="customForm[field.field_key].map(img=>img.file_path)"
                                                :src="item.file_path"
                                                fit="cover">
                                        </el-image>
                                        <i class="el-icon-error"
                                           @click="customForm[field.field_key].splice(index,1)"></i>
                                    </li>
                                    <li class="image_upload_wrap">
                                        <input accept="image/*"
                                               class="upload_input"
                                               multiple
                                               type="file"
                                               @change="handleClickUploadImg($event,field,customForm)">
                                        <i class="el-icon-plus"></i>
                                    </li>
                                </ul>
                                <p class="image_hint">只支持.jpg/.png 等图片格式</p>
                            </div>
                        </template>
                    </van-field>
                </div>
                <div v-else-if="field.field_type==='file'" class="vertical_input_wrap">
                    <van-field :label="field.field_name"
                               :name="field.field_key"
                               :required="field.is_required===1"
                               :rules="customFormRules[field.field_key]"
                               :disabled="field.field_disabled"
                               readonly>
                        <template #input>
                            <div v-if="is_preview_mode" class="m_file_outer_wrap" @click="handleClickPreviewModeBtn">
                                <p class="file_type_hint">支持Word、Excel、PDF等常见类型</p>
                                <div class="m_upload_file_btn">
                                    <i class="iconfont icon-upload"></i>上传{{ field.field_name }}
                                </div>
                            </div>
                            <div v-else class="m_file_outer_wrap">
                                <p v-if="customForm[field.field_key].length===0" class="file_type_hint">
                                    支持Word、Excel、PDF等常见类型</p>
                                <ul v-else class="m_upload_file_list">
                                    <li v-for="(file,file_idx) in customForm[field.field_key]" class="upload_file_item">
                                        <div class="file_left_wrap">
                                            <img alt="" class="file_img"
                                                 src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png">
                                            <div class="file_info_wrap">
                                                <p class="file_name" v-text="file.file_name"></p>
                                                <p class="file_size" v-text="file.file_size"></p>
                                            </div>
                                        </div>
                                        <div class="file_right_wrap">
                                            <el-tooltip content="预览"
                                                        effect="dark"
                                                        placement="top">
                                                            <span class="handle_icon_wrap"
                                                                  @click="handleClickPreview(file)">
                                                                <i class="iconfont icon-yanjing"></i>
                                                            </span>
                                            </el-tooltip>
                                            <span class="line"></span>
                                            <el-tooltip content="删除"
                                                        effect="dark"
                                                        placement="top">
                                                                <span class="handle_icon_wrap handle_icon_danger_wrap"
                                                                      @click="customForm[field.field_key].splice(file_idx,1)">
                                                                    <i class="iconfont icon-shanchu1"></i>
                                                                </span>
                                            </el-tooltip>
                                        </div>
                                    </li>
                                </ul>
                                <div class="m_upload_file_btn">
                                    <input class="upload_input"
                                           multiple
                                           type="file"
                                           @change="handleUploadFileChange($event,field,customForm)">
                                    <el-link :underline="false" type="primary">
                                        <i class="iconfont icon-shangchuan"></i> 上传{{ field.field_name }}
                                    </el-link>
                                </div>
                            </div>
                        </template>
                    </van-field>
                </div>
                <div v-else-if="field.field_type==='invoice'" class="vertical_input_wrap">
                    <van-field :label="field.field_name"
                               :name="field.field_key"
                               :required="field.is_required===1"
                               :rules="customFormRules[field.field_key]"
                               :disabled="field.field_disabled"
                               readonly>
                        <template #input>
                            <ul class="invoice_list">
                                <li v-for="item in customForm[field.field_key]" class="invoice_item">
                                    <div class="invoice_title_wrap">
                                        <span class="purchaser_name" v-text="item.purchaser_name"></span>
                                        <el-link :underline="false" type="primary"
                                                 @click="handleClickPreviewInvoiceFile(item)">发票预览
                                        </el-link>
                                    </div>
                                    <div class="invoice_total_amount" v-text="'￥'+item.total_amount"></div>
                                </li>
                            </ul>
                            <div class="upload_btn_outer_wrap" @click="handleClickUploadInvoice(field,customForm)">
                                <i class="iconfont icon-upload"></i>上传{{ field.field_name }}
                            </div>
                        </template>
                    </van-field>
                </div>
                <div v-else-if="field.field_type==='checkbox_approval'">
                    <van-field :label="field.field_name"
                               :name="field.field_key"
                               :required="field.is_required===1"
                               :value="customForm[field.field_key].value.join()"
                               :rules="customFormRules[field.field_key]"
                               :disabled="field.field_disabled"
                               @click="handleClickRelateApprove(field,customForm)"
                               is-link
                               readonly>
                        <template #input>
                            <span class="placeholder">点击选择审批单</span>
                        </template>
                    </van-field>
                    <ul v-if="customForm[field.field_key].text&&customForm[field.field_key].text.length"
                        class="related_approval_list">
                        <li v-for="(item,index) in customForm[field.field_key].text"
                            class="related_approval_item">
                            <div class="flex_js_wrap">
                                <div class="related_approval_title flex_wrap">
                                    <h4 v-text="item.approval_set_name"></h4>
                                    <div :class="'relate_approve_status_' + item.status"
                                         class="relate_approve_status"
                                         v-text="item.status === 0 ? '审批中' : item.status === 1 ? '已通过' : item.status === 2 ? '已拒绝' : '已撤回'"></div>
                                </div>
                                <div class="flex_wrap">
                                    <el-link :underline="false" type="primary"
                                             @click="handleClickRelatedApprovalDetail(item)">详情
                                    </el-link>
                                    <span class="line"></span>
                                    <el-link :underline="false" type="danger"
                                             @click="handleClickDeleteRelatedApproval(customForm,field,item,index)">
                                        删除
                                    </el-link>
                                </div>
                            </div>
                            <div class="flex_wrap approve_created_at">
                                <span v-text="item.user.name"></span>
                                <span>提交于</span>
                                <span v-text="item.created_at"></span>
                            </div>
                            <div v-if="item.overview_fields&&item.overview_fields.length"
                                 class="overview_fields_wrap">
                                <div v-if="item.is_pack_up">
                                    <OverviewFields :overviewFields="item.overview_fields"/>
                                </div>
                                <div class="ta_c">
                                    <el-link :underline="false" type="primary"
                                             @click="handleApproveOverViewField(item)">
                                        {{ item.is_pack_up ? '收起' : '展开' }}
                                        <i :class="item.is_pack_up?'icon-shangjiantou':'icon-xiajiantou'"
                                           class="iconfont"></i>
                                    </el-link>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div v-else-if="field.field_type==='checkbox_check_record'">
                    <van-field :disabled="field.field_disabled"
                               :label="field.field_name"
                               :name="field.field_key"
                               :required="field.is_required===1"
                               :rules="customFormRules[field.field_key]"
                               :value="customForm[field.field_key].value.join()"
                               is-link
                               readonly
                               @click="handleClickRelateCheckRecord(field,customForm)">
                        <template #input>
                            <span class="placeholder">点击选择打卡记录</span>
                        </template>
                    </van-field>
                    <ul v-if="customForm[field.field_key].text&&customForm[field.field_key].text.length"
                        class="related_check_record_list">
                        <li v-for="item in customForm[field.field_key].text"
                            class="related_check_record_item">
                            <div class="relate_title">
                                <h4 v-if="item.user" v-text="item.user.name+'的打卡记录'"></h4>
                                <span class="handle_icon_wrap handle_icon_danger_wrap">
                                    <i class="iconfont icon-shanchu1"
                                       @click="handleClickDeleteCheckRecord(item,field,customForm)"></i>
                                </span>
                            </div>
                            <div class="flex_wrap">
                                <i class="iconfont icon-messgae-clock"></i>
                                <span v-text="item.start_time||'--'"></span>
                                <span v-if="item.punch_type==='INTERVAL'">～</span>
                                <span v-if="item.punch_type==='INTERVAL'"
                                      v-text="item.end_time||'--'"></span>
                            </div>
                            <div class="flex_wrap">
                                <i class="iconfont icon-weizhi1"></i>
                                <span v-text="item.address||'--'"></span>
                            </div>
                        </li>
                    </ul>
                    <div v-if="field.mobile_devices_directly" class="check_record_btn">
                        <span class="link-label" @click="handleClickGoCheckRecord(field,customForm)">
                            <i class="iconfont icon-weizhi1"></i> 去打卡
                        </span>
                    </div>
                </div>
                <div v-else-if="field.field_type==='id_card'">
                    <div class="field_name_wrap">
                        <div class="field_name_inner" v-text="field.field_name"></div>
                    </div>
                    <van-field label="身份证号"
                               :name="field.field_key"
                               v-model="customForm[field.field_key].value"
                               :required="field.is_required===1"
                               :rules="customFormRules[field.field_key]"
                               :disabled="field.field_disabled"
                               error-message-align="right"
                               placeholder="请输入身份证号">
                        <template #button>
                            <i class="iconfont icon-saoyisao"
                               v-if="field.upload_recognition"
                               @click="handleClickOcrRecognition(field,customForm)"></i>
                        </template>
                    </van-field>
                    <div v-if="field.upload_recognition">
                        <van-field label="姓名"
                                   name="name"
                                   v-if="field.name_is_show"
                                   :value="customForm[field.field_key].name"
                                   :required="field.name_is_required"
                                   :rules="customFormRules[field.field_key]"
                                   :disabled="field.field_disabled"
                                   placeholder="请输入姓名"
                                   readonly>
                        </van-field>
                        <van-field label="出生日期"
                                   name="birthday"
                                   v-if="field.birthday_is_show"
                                   is-link
                                   :value="customForm[field.field_key].birthday"
                                   :required="field.birthday_is_required"
                                   :rules="customFormRules[field.field_key]"
                                   :disabled="field.field_disabled"
                                   @click="handleClickDateFieldLink(field,customForm,formInfoList)"
                                   placeholder="请选择出生日期"
                                   readonly>
                        </van-field>
                        <div class="vertical_input_wrap">
                            <van-field label="家庭地址"
                                       name="address"
                                       type="textarea"
                                       v-if="field.address_is_show"
                                       :value="customForm[field.field_key].address"
                                       :required="field.address_is_required"
                                       :rules="customFormRules[field.field_key]"
                                       :disabled="field.field_disabled"
                                       placeholder="请输入家庭地址">
                            </van-field>
                        </div>
                    </div>
                </div>
                <van-field v-else-if="field.field_type==='paying_teller'"
                           :label="field.field_name"
                           :name="field.field_key"
                           :value="customForm[field.field_key].text"
                           :required="field.is_required===1"
                           :rules="customFormRules[field.field_key]"
                           :disabled="field.field_disabled"
                           is-link
                           @click="handleClickPayingTellerFieldLink(field,customForm)"
                           readonly>
                    <template #button>
                        <i class="iconfont icon-saoyisao"
                           @click.stop="handleClickOcrRecognition(field,customForm)"></i>
                    </template>
                </van-field>
                <van-field v-else-if="field.field_type==='rate'"
                           :label="field.field_name"
                           :name="field.field_key"
                           :required="field.is_required===1"
                           :disabled="field.field_disabled"
                           :rules="customFormRules[field.field_key]"
                           error-message-align="right">
                    <template #input>
                        <van-rate v-model="customForm[field.field_key].value"
                                  :allow-half="field.point_system==='10'"
                                  :disabled="field.field_disabled"
                                  @change="handleRateFieldChange(field,customForm)"
                                  color="#f7ba2a"
                                  void-color="#BFBFBF">
                        </van-rate>
                    </template>
                    <template #button>
                        <span v-text="customForm[field.field_key].text"></span>
                    </template>
                </van-field>
                <van-field v-else-if="field.field_type==='location'"
                           v-model="customForm[field.field_key].value"
                           :clickable="field.allow_manual_edit"
                           :label="field.field_name"
                           :name="field.field_key"
                           :placeholder="field.allow_manual_edit?'自动定位，允许修改':'自动定位'"
                           :readonly="!field.allow_manual_edit"
                           :required="field.is_required===1"
                           type="textarea">
                </van-field>
                <div v-else-if="field.field_type==='purchase_details'">
                    <div class="purchase_details_wrap">
                        <div class="purchase_details_title">
                            <span class="purchase_details_title_name">采购明细</span>
                            <span class="template_color"
                                  @click="handleClickRelatedOrder(field,customForm)">关联导入</span>
                        </div>
                        <div class="purchase_details_list">
                            <div v-for="(item,index) in customForm[field.field_key]" :key="index"
                                 class="purchase_details_list_item">
                                <i class="el-icon-error"
                                   @click="customForm[field.field_key].splice(index,1);handleCountPurchaseTotalPrice(item)"></i>
                                <div class="field_wrap">
                                    <van-popover v-model="item.productPopoverShow"
                                                 :get-container="getContainerPurchaseDetails" :offset="[0,0]"
                                                 :show-arrow="false" placement="bottom-start"
                                                 style="left: 0 !important;"
                                                 trigger="click">
                                        <div class="productItemBox" v-if="productList.length>0">
                                            <div v-for="list in productList" class="product_item flex_js_wrap"
                                                 @click="handleClickSelectProduct(item,list)">
                                                <div class="product_name ellipsis">{{ list.name }}</div>
                                            </div>
                                        </div>
                                        <template #reference>
                                            <van-field v-model="item.product_name" label="产品名称"
                                                       placeholder="请输入采购产品名称" required
                                                       @input="handleInputProduct(item)"></van-field>
                                        </template>
                                    </van-popover>
                                </div>
                                <div class="field_wrap">
                                    <van-field v-model="item.num" label="数量" placeholder="请输入"
                                               required type="digit"
                                               @input="handleCountPurchaseTotalPrice(item)"></van-field>
                                </div>
                                <div class="field_wrap">
                                    <van-field v-model="item.price" label="单价（元)"
                                               placeholder="请输入"
                                               required
                                               type="number"
                                               @blur="handleCountPurchaseTotalPrice(item)"></van-field>
                                </div>
                                <div class="field_wrap">
                                    <van-field v-model="item.total_price" label="小计金额（元）"
                                               placeholder="系统计算" readonly
                                               @blur="handleCountPurchaseTotalPrice(item)"></van-field>
                                </div>
                                <div v-if="field.show_field.indexOf('stock') > -1" class="field_wrap">
                                    <van-field :value="item.stock_name" clickable is-link
                                               label="入库仓库" name="stock_id" placeholder="请选择"
                                               readonly @click="handleChangePurchaseStock(item)"></van-field>
                                </div>
                                <div v-if="field.show_field.indexOf('note') > -1"
                                     class="field_wrap vertical_input_wrap">
                                    <van-field v-model="item.none" label="产品说明" placeholder="请输入"
                                               type="textarea"></van-field>
                                </div>
                            </div>
                        </div>
                        <div class="purchase_details_add">
                           <span @click="handleClickPurchaseAdd(field,customForm)">
                                <i class="el-icon-plus"></i>
                                <span>添加更多</span>
                           </span>
                        </div>
                    </div>
                </div>
                <div v-else-if="field.field_type==='table'" class="vertical_input_wrap">
                    <van-field :name="field.field_key"
                               :rules="customFormRules[field.field_key]"
                               :value="customForm[field.field_key].length?customForm[field.field_key].join():''"
                               readonly
                               required>
                        <template #input>
                            <div class="table_field_title" v-text="field.field_name"></div>
                            <ul v-if="field._child" class="vertical_table_list">
                                <li v-for="(row,index) in customForm[field.field_key]"
                                    :key="index"
                                    class="vertical_table_item">
                                    <div class="vertical_table_item_title">
                                        <h5 v-text="field.field_name + (index+1)"></h5>
                                        <span class="handle_icon_wrap handle_icon_danger_wrap"
                                              @click="handleClickDelTableRow(field,index)">
                                            <i class="iconfont icon-shanchu1"></i>
                                        </span>
                                    </div>
                                    <van-form :ref="`table_item_form_${field.field_key}_${index}`"
                                              error-message-align="right"
                                              size="small">
                                        <div v-for="child in field._child.filter(field=>!field.initial_display)"
                                             :key="child.field_key">
                                            <van-field v-if="child.field_type==='input'"
                                                       v-model="row[child.field_key].value"
                                                       :disabled="child.field_disabled"
                                                       :label="child.field_name"
                                                       :placeholder="child.placeholder"
                                                       :required="child.is_required===1"
                                                       :rules="field.formRules[child.field_key]"
                                                       input-align="right">
                                            </van-field>
                                            <div v-else-if="child.field_type==='textarea'" class="vertical_input_wrap">
                                                <van-field v-model="row[child.field_key].value"
                                                           :disabled="child.field_disabled"
                                                           :label="child.field_name"
                                                           :name="child.field_key"
                                                           :placeholder="child.placeholder"
                                                           :required="child.is_required===1"
                                                           :rules="field.formRules[child.field_key]"
                                                           maxlength="600"
                                                           type="textarea">
                                                </van-field>
                                            </div>
                                            <van-field v-else-if="child.field_type==='number'"
                                                       v-model="row[child.field_key].value"
                                                       :disabled="child.field_disabled"
                                                       :label="child.field_name"
                                                       :name="child.field_key"
                                                       :placeholder="child.placeholder"
                                                       :required="child.is_required===1"
                                                       :rules="field.formRules[child.field_key]"
                                                       error-message-align="right"
                                                       type="number"
                                                       @blur="handleNumberInputBlur(child,row,row._child)">
                                                <template #button>
                                                    <span v-text="child.unit"></span>
                                                </template>
                                            </van-field>
                                            <van-field v-else-if="child.field_type==='money'"
                                                       v-model="row[child.field_key].text"
                                                       :disabled="child.field_disabled"
                                                       :label="child.field_name"
                                                       :name="child.field_key"
                                                       :placeholder="child.placeholder"
                                                       :required="child.is_required===1"
                                                       :rules="field.formRules[child.field_key]"
                                                       error-message-align="right"
                                                       type="number"
                                                       @blur="handlePriceInputBlur(child,row,row._child)">
                                            </van-field>
                                            <van-field v-else-if="child.field_type==='compute_mode'"
                                                       v-model="row[child.field_key].value"
                                                       :label="child.field_name"
                                                       :name="child.field_key"
                                                       :required="child.is_required===1"
                                                       :rules="field.formRules[child.field_key]"
                                                       disabled
                                                       placeholder="系统自动计算"
                                                       readonly>
                                            </van-field>
                                            <div v-else-if="child.field_type==='telephone'">
                                                <van-field v-if="child.phone_type==='3'"
                                                           :name="child.field_key"
                                                           :required="child.is_required===1"
                                                           label="电话类型">
                                                    <template #input>
                                                        <van-radio-group
                                                                v-model="row[child.field_key].phone_type"
                                                                :disabled="child.field_disabled"
                                                                direction="horizontal"
                                                                @change="handleTelPhoneTypeChange($event,row,child.field_key)">
                                                            <van-radio name="1">手机</van-radio>
                                                            <van-radio name="2">固话</van-radio>
                                                        </van-radio-group>
                                                    </template>
                                                </van-field>
                                                <van-field v-if="row[child.field_key].phone_type==='2'"
                                                           v-model="row[child.field_key].prefix"
                                                           :disabled="child.field_disabled"
                                                           :name="child.field_key"
                                                           :placeholder="child.placeholder"
                                                           :readonly="row[child.field_key].phone_type==='1'"
                                                           :required="child.is_required===1"
                                                           :rules="field.formRules[child.field_key].prefix"
                                                           :type="row[child.field_key].phone_type==='2'?'digit':''"
                                                           error-message-align="right"
                                                           label="区号"
                                                           maxlength="4">
                                                </van-field>
                                                <van-field
                                                        v-model="row[child.field_key].value"
                                                        :disabled="(pk_id!==0&&child.hasOwnProperty('can_not_edit'))|| child.field_disabled "
                                                        :label="row[child.field_key].phone_type==='1'?child.field_name+'（+86）':child.field_name"
                                                        :name="child.field_key"
                                                        :placeholder="child.placeholder"
                                                        :required="child.is_required===1"
                                                        :rules="field.formRules[child.field_key].value"
                                                        error-message-align="right">
                                                </van-field>
                                            </div>
                                            <van-field v-else-if="child.field_type==='radio'"
                                                       v-model="row[child.field_key].text"
                                                       :disabled="child.field_disabled"
                                                       :label="child.field_name"
                                                       :name="child.field_key"
                                                       :placeholder="child.placeholder"
                                                       :required="child.is_required===1"
                                                       :rules="field.formRules[child.field_key]"
                                                       error-message-align="right"
                                                       is-link
                                                       readonly
                                                       @click="handleClickRadioFieldLink(child,row,row._child)">
                                            </van-field>
                                            <van-field v-else-if="child.field_type==='checkbox'"
                                                       :disabled="child.field_disabled"
                                                       :label="child.field_name"
                                                       :name="child.field_key"
                                                       :placeholder="child.placeholder"
                                                       :required="child.is_required===1"
                                                       :rules="field.formRules[child.field_key]"
                                                       :value="row[child.field_key].text.join()"
                                                       error-message-align="right"
                                                       is-link
                                                       readonly
                                                       @click="handleClickCheckboxFieldLink(child,row,row._child)">
                                            </van-field>
                                            <van-field v-else-if="child.field_type==='cascader'"
                                                       :disabled="child.field_disabled"
                                                       :label="child.field_name"
                                                       :name="child.field_key"
                                                       :placeholder="child.placeholder"
                                                       :required="child.is_required===1"
                                                       :rules="field.formRules[child.field_key]"
                                                       :value="row[child.field_key].text"
                                                       error-message-align="right"
                                                       is-link
                                                       readonly
                                                       @click="handleClickCascaderFieldLink(child,row)">
                                            </van-field>
                                            <van-field v-else-if="child.field_type==='department'"
                                                       :disabled="child.default||child.field_disabled"
                                                       :is-link="!child.default"
                                                       :label="child.field_name"
                                                       :name="child.field_key"
                                                       :placeholder="child.placeholder"
                                                       :required="child.is_required===1"
                                                       :rules="field.formRules[child.field_key]"
                                                       :value="row[child.field_key].titles.join()"
                                                       error-message-align="right"
                                                       readonly
                                                       @click="handleClickCascaderFieldLink(child,row)">
                                            </van-field>
                                            <van-field v-else-if="child.field_type==='contact'"
                                                       :disabled="(child.default&&child.default_can_edit==='2')||child.field_disabled"
                                                       :is-link="child.default&&child.default_can_edit==='1'"
                                                       :label="child.field_name"
                                                       :name="child.field_key"
                                                       :placeholder="child.placeholder"
                                                       :required="child.is_required===1"
                                                       :rules="field.formRules[child.field_key]"
                                                       :value="row[child.field_key].text.map(user=>user.name).join()"
                                                       error-message-align="right"
                                                       readonly
                                                       @click="handleClickContactFieldLink(child,row)">
                                            </van-field>
                                            <van-field v-else-if="child.field_type==='date'"
                                                       :disabled="child.default||child.field_disabled"
                                                       :is-link="!child.default"
                                                       :label="child.field_name"
                                                       :name="child.field_key"
                                                       :placeholder="child.default?'由系统提供时间':child.placeholder"
                                                       :required="child.is_required===1"
                                                       :rules="field.formRules[child.field_key]"
                                                       :value="row[child.field_key].value"
                                                       error-message-align="right"
                                                       readonly
                                                       @click="handleClickDateFieldLink(child,row,row._child)">
                                            </van-field>
                                            <div v-else-if="child.field_type==='address'">
                                                <van-field :disabled="child.field_disabled"
                                                           :label="child.field_name"
                                                           :name="child.field_key"
                                                           :placeholder="child.area_accuracy_placeholder"
                                                           :required="child.is_required===1"
                                                           :rules="field.formRules[child.field_key]?field.formRules[child.field_key].value:[]"
                                                           :value="row[child.field_key].text"
                                                           error-message-align="right"
                                                           is-link
                                                           readonly
                                                           @click="handleClickCascaderFieldLink(child,row)">
                                                </van-field>
                                                <div class="vertical_input_wrap">
                                                    <van-field v-if="child.is_show_detail_address"
                                                               v-model="row[child.field_key].detail_address"
                                                               :name="child.field_key"
                                                               :placeholder="child.detail_address_placeholder"
                                                               :rules="field.formRules[child.field_key]?field.formRules[child.field_key].detail_address:[]"
                                                               maxlength="30"
                                                               style="margin-top: 0"
                                                               type="textarea">
                                                    </van-field>
                                                </div>
                                            </div>
                                            <div v-else-if="child.field_type==='date_range'">
                                                <van-field :disabled="child.field_disabled"
                                                           :label="child.field_name"
                                                           :name="child.field_key"
                                                           :placeholder="'请选择'+child.field_name"
                                                           :required="child.is_required===1"
                                                           :rules="field.formRules[child.field_key]"
                                                           :value="row[child.field_key].text"
                                                           error-message-align="right"
                                                           is-link
                                                           readonly
                                                           @click="handleClickDateRangeFieldLink(child,row)">
                                                </van-field>
                                                <van-field v-if="child.auto_computed"
                                                           :name="child.field_key"
                                                           :value="row[child.field_key].duration"
                                                           disabled
                                                           label="时长"
                                                           placeholder="自动计算"
                                                           readonly>
                                                    <template #button>
                                                        <span>天</span>
                                                    </template>
                                                </van-field>
                                            </div>
                                            <div v-else-if="child.field_type==='explain'" class="explain_wrap"
                                                 v-text="child.explain"></div>
                                            <div v-else-if="child.field_type==='image'" class="vertical_input_wrap">
                                                <van-field :disabled="child.field_disabled"
                                                           :label="child.field_name"
                                                           :name="child.field_key"
                                                           :required="child.is_required===1"
                                                           :rules="field.formRules[child.field_key]"
                                                           readonly>
                                                    <template #input>
                                                        <div class="image_outer_wrap">
                                                            <div v-if="is_preview_mode" class="image_upload_wrap"
                                                                 @click="handleClickPreviewModeBtn">
                                                                <i class="el-icon-plus"></i>
                                                            </div>
                                                            <ul v-else class="upload_image_list">
                                                                <li v-for="item in row[child.field_key]"
                                                                    :key="item.file_path"
                                                                    class="upload_image_item">
                                                                    <el-image
                                                                            :preview-src-list="row[child.field_key].map(img=>img.file_path)"
                                                                            :src="item.file_path"
                                                                            fit="cover">
                                                                    </el-image>
                                                                    <i class="el-icon-error"
                                                                       @click="row[child.field_key].splice(index,1)"></i>
                                                                </li>
                                                                <li class="image_upload_wrap">
                                                                    <input accept="image/*"
                                                                           class="upload_input"
                                                                           multiple
                                                                           type="file"
                                                                           @change="handleClickUploadImg($event,child,row)">
                                                                    <i class="el-icon-plus"></i>
                                                                </li>
                                                            </ul>
                                                            <p class="image_hint">只支持.jpg/.png 等图片格式</p>
                                                        </div>
                                                    </template>
                                                </van-field>
                                            </div>
                                            <div v-else-if="child.field_type==='file'" class="vertical_input_wrap">
                                                <van-field :disabled="child.field_disabled"
                                                           :label="child.field_name"
                                                           :name="child.field_key"
                                                           :required="child.is_required===1"
                                                           :rules="field.formRules[child.field_key]"
                                                           readonly>
                                                    <template #input>
                                                        <div v-if="is_preview_mode" class="m_file_outer_wrap"
                                                             @click="handleClickPreviewModeBtn">
                                                            <p class="file_type_hint">支持Word、Excel、PDF等常见类型</p>
                                                            <div class="m_upload_file_btn">
                                                                <i class="iconfont icon-upload"></i>上传{{
                                                                child.field_name
                                                                }}
                                                            </div>
                                                        </div>
                                                        <div v-else class="m_file_outer_wrap">
                                                            <p v-if="row[child.field_key].length===0"
                                                               class="file_type_hint">
                                                                支持Word、Excel、PDF等常见类型</p>
                                                            <ul v-else class="m_upload_file_list">
                                                                <li v-for="(file,file_idx) in row[child.field_key]"
                                                                    class="upload_file_item">
                                                                    <div class="file_left_wrap">
                                                                        <img alt="" class="file_img"
                                                                             src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png">
                                                                        <div class="file_info_wrap">
                                                                            <p class="file_name"
                                                                               v-text="file.file_name"></p>
                                                                            <p class="file_size"
                                                                               v-text="file.file_size"></p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="file_right_wrap">
                                                                        <el-tooltip content="预览"
                                                                                    effect="dark"
                                                                                    placement="top">
                                                                        <span class="handle_icon_wrap"
                                                                              @click="handleClickPreview(file)">
                                                                <i class="iconfont icon-yanjing"></i>
                                                            </span>
                                                                        </el-tooltip>
                                                                        <span class="line"></span>
                                                                        <el-tooltip content="删除"
                                                                                    effect="dark"
                                                                                    placement="top">
                                                                            <span class="handle_icon_wrap handle_icon_danger_wrap"
                                                                                  @click="row[child.field_key].splice(file_idx,1)">
                                                                                <i class="iconfont icon-shanchu1"></i>
                                                                            </span>
                                                                        </el-tooltip>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                            <div class="m_upload_file_btn">
                                                                <input class="upload_input"
                                                                       multiple
                                                                       type="file"
                                                                       @change="handleUploadFileChange($event,child,row)">
                                                                <el-link :underline="false" type="primary">
                                                                    <i class="iconfont icon-shangchuan"></i>
                                                                    上传{{ child.field_name }}
                                                                </el-link>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </van-field>
                                            </div>
                                            <div v-else-if="child.field_type==='invoice'" class="vertical_input_wrap">
                                                <van-field :disabled="child.field_disabled"
                                                           :label="child.field_name"
                                                           :name="child.field_key"
                                                           :required="child.is_required===1"
                                                           :rules="field.formRules[child.field_key]"
                                                           readonly>
                                                    <template #input>
                                                        <ul class="invoice_list">
                                                            <li v-for="item in row[child.field_key]"
                                                                class="invoice_item">
                                                                <div class="invoice_title_wrap">
                                                                    <span class="purchaser_name"
                                                                          v-text="item.purchaser_name"></span>
                                                                    <el-link :underline="false" type="primary"
                                                                             @click="handleClickPreviewInvoiceFile(item)">
                                                                        发票预览
                                                                    </el-link>
                                                                </div>
                                                                <div class="invoice_total_amount"
                                                                     v-text="'￥'+item.total_amount"></div>
                                                            </li>
                                                        </ul>
                                                        <div class="upload_btn_outer_wrap"
                                                             @click="handleClickUploadInvoice(child,row)">
                                                            <i class="iconfont icon-upload"></i>上传{{
                                                            child.field_name
                                                            }}
                                                        </div>
                                                    </template>
                                                </van-field>
                                            </div>
                                            <div v-else-if="child.field_type==='checkbox_approval'">
                                                <van-field :disabled="child.field_disabled"
                                                           :label="child.field_name"
                                                           :name="child.field_key"
                                                           :required="child.is_required===1"
                                                           :rules="field.formRules[child.field_key]"
                                                           :value="row[child.field_key].value.join()"
                                                           is-link
                                                           readonly
                                                           @click="handleClickRelateApprove(child,row)">
                                                    <template #input>
                                                        <span class="placeholder">点击选择审批单</span>
                                                    </template>
                                                </van-field>
                                                <ul v-if="row[child.field_key].text&&row[child.field_key].text.length"
                                                    class="related_approval_list">
                                                    <li v-for="(item,index) in row[child.field_key].text"
                                                        class="related_approval_item">
                                                        <div class="flex_js_wrap">
                                                            <div class="related_approval_title flex_wrap">
                                                                <h4 v-text="item.approval_set_name"></h4>
                                                                <div :class="'relate_approve_status_' + item.status"
                                                                     class="relate_approve_status"
                                                                     v-text="item.status === 0 ? '审批中' : item.status === 1 ? '已通过' : item.status === 2 ? '已拒绝' : '已撤回'"></div>
                                                            </div>
                                                            <div class="flex_wrap">
                                                                <el-link :underline="false" type="primary"
                                                                         @click="handleClickRelatedApprovalDetail(item)">
                                                                    详情
                                                                </el-link>
                                                                <span class="line"></span>
                                                                <el-link :underline="false" type="danger"
                                                                         @click="handleClickDeleteRelatedApproval(row,child,item,index)">
                                                                    删除
                                                                </el-link>
                                                            </div>
                                                        </div>
                                                        <div class="flex_wrap approve_created_at">
                                                            <span v-text="item.user.name"></span>
                                                            <span>提交于</span>
                                                            <span v-text="item.created_at"></span>
                                                        </div>
                                                        <div v-if="item.overview_fields&&item.overview_fields.length"
                                                             class="overview_fields_wrap">
                                                            <div v-if="item.is_pack_up">
                                                                <OverviewFields :overviewFields="item.overview_fields"/>
                                                            </div>
                                                            <div class="ta_c">
                                                                <el-link :underline="false" type="primary"
                                                                         @click="handleApproveOverViewField(item)">
                                                                    {{ item.is_pack_up ? '收起' : '展开' }}
                                                                    <i :class="item.is_pack_up?'icon-shangjiantou':'icon-xiajiantou'"
                                                                       class="iconfont"></i>
                                                                </el-link>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div v-else-if="child.field_type==='checkbox_check_record'">
                                                <van-field :disabled="child.field_disabled"
                                                           :label="child.field_name"
                                                           :name="child.field_key"
                                                           :required="child.is_required===1"
                                                           :rules="field.formRules[child.field_key]"
                                                           :value="row[child.field_key].value.join()"
                                                           is-link
                                                           readonly
                                                           @click="handleClickRelateCheckRecord(child,row)">
                                                    <template #input>
                                                        <span class="placeholder">点击选择打卡记录</span>
                                                    </template>
                                                </van-field>
                                                <ul v-if="row[child.field_key].text&&row[child.field_key].text.length"
                                                    class="related_check_record_list">
                                                    <li v-for="item in row[child.field_key].text"
                                                        class="related_check_record_item">
                                                        <div class="relate_title">
                                                            <h4 v-if="item.user"
                                                                v-text="item.user.name+'的打卡记录'"></h4>
                                                            <span class="handle_icon_wrap handle_icon_danger_wrap">
                                    <i class="iconfont icon-shanchu1"
                                       @click="handleClickDeleteCheckRecord(item,child,row)"></i>
                                </span>
                                                        </div>
                                                        <div class="flex_wrap">
                                                            <i class="iconfont icon-messgae-clock"></i>
                                                            <span v-text="item.start_time||'--'"></span>
                                                            <span v-if="item.punch_type==='INTERVAL'">～</span>
                                                            <span v-if="item.punch_type==='INTERVAL'"
                                                                  v-text="item.end_time||'--'"></span>
                                                        </div>
                                                        <div class="flex_wrap">
                                                            <i class="iconfont icon-weizhi1"></i>
                                                            <span v-text="item.address||'--'"></span>
                                                        </div>
                                                    </li>
                                                </ul>
                                                <div v-if="child.mobile_devices_directly" class="check_record_btn">
                        <span class="link-label" @click="handleClickGoCheckRecord(child,row)">
                            <i class="iconfont icon-weizhi1"></i> 去打卡
                        </span>
                                                </div>
                                            </div>
                                            <div v-else-if="child.field_type==='id_card'">
                                                <div class="field_name_wrap">
                                                    <div class="field_name_inner" v-text="child.field_name"></div>
                                                </div>
                                                <van-field v-model="row[child.field_key].value"
                                                           :disabled="child.field_disabled"
                                                           :name="child.field_key"
                                                           :required="child.is_required===1"
                                                           :rules="field.formRules[child.field_key]"
                                                           error-message-align="right"
                                                           label="身份证号"
                                                           placeholder="请输入身份证号">
                                                    <template #button>
                                                        <i v-if="child.upload_recognition"
                                                           class="iconfont icon-saoyisao"
                                                           @click="handleClickOcrRecognition(field,row)"></i>
                                                    </template>
                                                </van-field>
                                                <div v-if="child.upload_recognition">
                                                    <van-field v-if="child.name_is_show"
                                                               :disabled="child.field_disabled"
                                                               :required="child.name_is_required"
                                                               :rules="field.formRules[child.field_key]"
                                                               :value="row[child.field_key].name"
                                                               label="姓名"
                                                               name="name"
                                                               placeholder="请输入姓名"
                                                               readonly>
                                                    </van-field>
                                                    <van-field v-if="child.birthday_is_show"
                                                               :disabled="child.field_disabled"
                                                               :required="child.birthday_is_required"
                                                               :rules="field.formRules[child.field_key]"
                                                               :value="row[child.field_key].birthday"
                                                               is-link
                                                               label="出生日期"
                                                               name="birthday"
                                                               placeholder="请选择出生日期"
                                                               readonly
                                                               @click="handleClickDateFieldLink(field,row,formInfoList)">
                                                    </van-field>
                                                    <div class="vertical_input_wrap">
                                                        <van-field v-if="child.address_is_show"
                                                                   :disabled="child.field_disabled"
                                                                   :required="child.address_is_required"
                                                                   :rules="field.formRules[child.field_key]"
                                                                   :value="row[child.field_key].address"
                                                                   label="家庭地址"
                                                                   name="address"
                                                                   placeholder="请输入家庭地址"
                                                                   type="textarea">
                                                        </van-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <van-field v-else-if="child.field_type==='paying_teller'"
                                                       :disabled="child.field_disabled"
                                                       :label="child.field_name"
                                                       :name="child.field_key"
                                                       :required="child.is_required===1"
                                                       :rules="field.formRules[child.field_key]"
                                                       :value="row[child.field_key].text"
                                                       is-link
                                                       readonly
                                                       @click="handleClickPayingTellerFieldLink(field,row)">
                                                <template #button>
                                                    <i class="iconfont icon-saoyisao"
                                                       @click.stop="handleClickOcrRecognition(field,row)"></i>
                                                </template>
                                            </van-field>
                                            <van-field v-else-if="child.field_type==='rate'"
                                                       :disabled="child.field_disabled"
                                                       :label="child.field_name"
                                                       :name="child.field_key"
                                                       :required="child.is_required===1"
                                                       :rules="field.formRules[child.field_key]"
                                                       error-message-align="right">
                                                <template #input>
                                                    <van-rate v-model="row[child.field_key].value"
                                                              :allow-half="child.point_system==='10'"
                                                              :disabled="child.field_disabled"
                                                              color="#f7ba2a"
                                                              void-color="#BFBFBF"
                                                              @change="handleRateFieldChange(field,row)">
                                                    </van-rate>
                                                </template>
                                                <template #button>
                                                    <span v-text="row[child.field_key].text"></span>
                                                </template>
                                            </van-field>
                                            <van-field v-else-if="child.field_type==='location'"
                                                       v-model="row[child.field_key].value"
                                                       :clickable="child.allow_manual_edit"
                                                       :label="child.field_name"
                                                       :name="child.field_key"
                                                       :placeholder="child.allow_manual_edit?'自动定位，允许修改':'自动定位'"
                                                       :readonly="!child.allow_manual_edit"
                                                       :required="child.is_required===1"
                                                       type="textarea">
                                            </van-field>
                                        </div>
                                    </van-form>
                                </li>
                            </ul>
                            <div class="ta_c" style="padding: 10px 0 0">
                                <el-link :underline="false" type="primary" @click="handleClickAddTableRow(field)"><i
                                        class="el-icon-plus"></i>添加{{ field.field_name }}
                                </el-link>
                            </div>
                        </template>
                    </van-field>
                </div>
                <div v-else-if="field.field_type==='goods'" class="vertical_input_wrap required_icon_hide">
                    <van-field :rules="customFormRules[field.field_key]"
                               :name="field.field_key"
                               :value="customForm[field.field_key].length?customForm[field.field_key].join():''"
                               readonly
                               required>
                        <template #input>
                            <ul v-if="customForm[field.field_key].length" class="order_goods_list">
                                <li v-for="(row,index) in customForm[field.field_key]" :key="index"
                                    class="order_goods_item">
                                    <div class="goods_info_wrap flex_wrap">
                                        <div class="goods_image_wrap">
                                            <img :src="row.goods_image?row.goods_image:'https://download.hecoos.com/enlightv/2025-03/9d94ed737997e3e1e393bb74609ffc64.jpg'"
                                                 alt="">
                                            <div class="good_status_text"
                                                 v-if="row.goods_status===0||row.goods_deleted_at"
                                                 v-text="row.goods_status===0?'已下架':row.goods_deleted_at?'已删除':''"></div>
                                        </div>
                                        <div class="goods_name_wrap">
                                            <div class="flex_js_wrap" style="align-items: start">
                                                <div class="goods_name">
                                                    <span v-text="row.goods_name"></span>
                                                    <span v-if="row.goods_sku_name&&row.goods_type!=='bundle'"
                                                          v-text="'：'+row.goods_sku_name"></span>
                                                </div>
                                                <div class="flex_wrap">
                                                    <span :class="{'handle_icon_disabled_wrap':row.hasOwnProperty('return_num') && row.return_num > 0}"
                                                          class="handle_icon_wrap"
                                                          @click="handleClickEditGoods(row,index)">
                                                            <i class="iconfont icon-bianji"></i>
                                                        </span>
                                                    <span class="line"></span>
                                                    <span class="handle_icon_wrap handle_icon_danger_wrap"
                                                          @click="handleClickDeleteGoods(index)">
                                                            <i class="iconfont icon-shanchu1"></i>
                                                        </span>
                                                </div>
                                            </div>
                                            <div class="flex_js_wrap">
                                                <div class="goods_price flex_wrap">
                                                    <div>
                                                        <span class="goods_price_label">总价：</span>
                                                        <span class="goods_price_value"
                                                              v-text="'¥'+row.subtotal_price.text"></span>
                                                    </div>
                                                    <div v-if="row.guide_price&&row.price.value&&Number(row.guide_price)!==row.price.value"
                                                         class="ta_r">
                                                        <div :class="'discounts_'+goodsDiscountsTextOrClass(row,'class')"
                                                             class="discounts_text"
                                                             v-text="goodsDiscountsTextOrClass(row,'text')"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="row.hasOwnProperty('_child')&&row._child.length" class="goods_spec_wrap">
                                        <ul class="goods_spec_list">
                                            <template v-if="row.is_expand">
                                                <li v-for="child in row._child"
                                                    :key="child.part_id"
                                                    class="good_part_item"
                                                    v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                                </li>
                                            </template>
                                            <template v-else>
                                                <li v-for="child in row._child.slice(0,1)"
                                                    :key="child.part_id"
                                                    class="good_part_item"
                                                    v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                                </li>
                                            </template>
                                        </ul>
                                        <div class="handle_expand_btn" @click="handleClickExpandConfig(row)">
                                        <span class="handle_expand_text"
                                              v-text="row.is_expand?'收起配置':'展开配置'"></span>
                                            <i :class="row.is_expand?'icon-shangjiantou':'icon-xiajiantou'"
                                               class="iconfont"></i>
                                        </div>
                                    </div>
                                    <div class="goods_amount_wrap">
                                        <div class="cost_guide_price_wrap flex_wrap">
                                            <img alt=""
                                                 src="https://download.hecoos.com/enlightv/2025-10/d83f6be23fa8ac527f87c9296c8e1e39.svg">
                                            <span v-text="'¥' + row.cost_price"></span>
                                            <img alt=""
                                                 src="https://download.hecoos.com/enlightv/2025-10/4283680c308ffa0dee2c8105fda1ed53.svg">
                                            <span v-text="'¥' + row.guide_price"></span>
                                        </div>
                                        <el-radio-group v-model="row.type"
                                                        :disabled="pk_id!==0&&is_release===1&&row.hasOwnProperty('order_goods_id')"
                                                        class="goods_type_radio_group"
                                                        @change="handleGoodsTypeChange(row)">
                                            <el-radio :disabled="row.is_sale===0" :label="1">销售</el-radio>
                                            <el-radio :disabled="row.is_lease===0" :label="2">租借</el-radio>
                                        </el-radio-group>
                                    </div>
                                    <van-field v-if="row.type===2&&row.is_virtual!==0"
                                               :disabled="row.goods_status===0||row.goods_deleted_at"
                                               :value="row.start_at + ' ~ ' + row.end_at"
                                               is-link
                                               label="租借起止时间"
                                               readonly
                                               @click="handleClickGoodsLeaseTimePicker(index)">
                                    </van-field>
                                    <van-field v-model="row.price.value"
                                               :disabled="row.goods_status===0||row.goods_deleted_at"
                                               input-align="right"
                                               label="单价"
                                               name="price"
                                               placeholder="请输入单价"
                                               @blur="handleProductPriceInputBlur(row)">
                                    </van-field>
                                    <van-field label="数量"
                                               name="num"
                                               placeholder="请输入数量">
                                        <template #input>
                                            <van-stepper v-model="row.num"
                                                         :max="row.max_num?row.max_num:99999"
                                                         :min="1"
                                                         @change="handleProductNumInputBlur(row)"/>
                                        </template>
                                    </van-field>
                                </li>
                            </ul>
                            <div v-else class="ta_c">
                                <div class="hint">暂无产品信息请先添加产品</div>
                                <i class="iconfont icon-xiangxia"></i>
                            </div>
                            <div class="ta_c" style="padding: 10px 0 0">
                                <el-link
                                        :disabled="formInfoList.find(find => find.field_key === 'order_goods').field_disabled"
                                        :underline="false"
                                        type="primary"
                                        @click="handleClickAddProduct">
                                    <i class="el-icon-plus"></i>添加产品
                                </el-link>
                            </div>
                        </template>
                    </van-field>
                </div>
                <div v-else-if="field.field_type==='money_compute_mode'">
                    <div v-if="order_procurement_show&&field_form==='orders'">
                        <div class="purchase_price_wrap">
                            <div class="flex_js_wrap">
                                <h4>代采产品</h4>
                                <span class="handle_icon_wrap" @click="handleClickDeletePurchasePrice">
                                <i class="iconfont icon-shanchu1"></i>
                            </span>
                            </div>
                            <div class="hint">订单审批通过后，请前往订单详情中填写代采明细</div>
                        </div>
                        <van-field v-model="customForm.purchase_price.text"
                                   :disabled="formInfoList.find(find => find.field_key === 'purchase_price').field_disabled"
                                   label="代采销售金额"
                                   placeholder="请输入代采销售金额"
                                   required
                                   @blur="handlePurchasePriceInputBlur"></van-field>
                    </div>
                    <div v-if="field.field_key==='total_price'"
                         class="total_price_wrap flex_js_wrap">
                        <div>订单总金额</div>
                        <div class="money_compute_mode_text"
                             v-text="'¥' + customForm[field.field_key].text"></div>
                    </div>
                    <van-field v-else-if="field.field_key==='payable_amount'"
                               :name="field.field_key">
                        <template #label>
                            <span v-text="field.field_name"></span>
                            <span v-text="customForm[field.field_key].currency&&customForm[field.field_key].currency.includes('CNY')?'（CNY-人民币）':'（USD-美元）'"></span>
                        </template>
                        <template #button class="detail_value">
                            <span v-text="customForm[field.field_key].text||'--'"></span>
                            <div v-if="customForm[field.field_key].currency==='CNY'"
                                 class="chinese_text"
                                 v-text="customForm[field.field_key].chinese_text"></div>
                        </template>
                    </van-field>
                </div>
            </div>
        </van-form>
        <!--_年_月_日 日期选择-->
        <van-calendar v-model="showDateCalendar"
                      color="#2990FF"
                      :min-date="dateCalendarMin"
                      :max-date="dateCalendarMax"
                      @confirm="handleDateCalenderConfirm"/>
        <!--其他类型日期选择-->
        <van-popup :style="{ height: '352px' }"
                   round
                   position="bottom"
                   v-if="showDatePopupShow"
                   v-model="showDatePopupShow">
            <van-datetime-picker v-model="currentTime"
                                 type="time"
                                 v-if="currentFieldData.date_type==='time'"
                                 @cancel="showDatePopupShow=false"
                                 :title="'选择'+currentFieldData.field_name"
                                 @confirm="handleDateCalenderConfirm"
                                 :min-hour="timeCalendarScope.min_hour"
                                 :max-hour="timeCalendarScope.max_hour"
                                 :min-minute="timeCalendarScope.min_minute"
                                 :max-minute="timeCalendarScope.max_minute"/>
            <van-datetime-picker v-model="currentDate"
                                 v-else
                                 :title="'选择'+currentFieldData.field_name"
                                 :type="currentFieldData.date_type"
                                 @cancel="showDatePopupShow=false"
                                 @confirm="handleDateCalenderConfirm"
                                 :min-date="dateCalendarMin"
                                 :max-date="dateCalendarMax"/>
        </van-popup>
        <!--日期区间选择-->
        <van-calendar :allow-same-day="true"
                      :min-date="dateCalendarMin"
                      :max-date="dateCalendarMax"
                      :show-confirm="false"
                      @close="showDateRangePicker=false"
                      @confirm="handleClickRangeCalendarConfirm"
                      color="#1990FF"
                      type="range"
                      v-model="showDateRangePicker">
        </van-calendar>
        <!--商品租借时间选择-->
        <van-calendar v-model="goodsLeaseTimePickerVisible"
                      :allow-same-day="true"
                      :max-date="dateCalendarMax"
                      :min-date="dateCalendarMin"
                      :show-confirm="false"
                      color="#1990FF"
                      type="range"
                      @close="goodsLeaseTimePickerVisible=false"
                      @confirm="handleClickGoodsLeaseTimeConfirm">
        </van-calendar>
        <!--级联选择-->
        <van-popup :style="{ height: '480px' }"
                   position="bottom"
                   round
                   v-if="showCascaderPicker"
                   v-model="showCascaderPicker">
            <van-cascader :field-names="cascaderFieldNames"
                          :options="cascaderOptions"
                          :title="'选择' + currentFieldData.field_name"
                          @close="showCascaderPicker = false"
                          @finish="handleClickCascaderFinish"
                          active-color="#2990FF"
                          v-model="cascaderValue">
            </van-cascader>
        </van-popup>
        <!--联系人组件弹窗-->
        <van-overlay :show="showContactPicker"
                     v-if="showContactPicker"
                     :custom-style="{background: 'rgba(0, 0, 0, 0.3)'}">
            <div class="contact_select_wrap">
                <div class="contact_select_header">
                    <van-icon name="arrow-left" @click="handleClickContactPickerClose"></van-icon>
                    <span class="title" v-text="'选择'+currentFieldData.field_name"></span>
                    <el-link :underline="false" type="primary"
                             @click="handleClickContactPickerConfirm">确定
                    </el-link>
                </div>
                <van-search v-model="contactName"
                            v-if="currentFieldData.field_type==='contact'"
                            placeholder="请输入搜索关键词"
                            @blur="getUserList(contactName)"
                            @cancel="getUserList(contactName)"
                            @clear="getUserList(contactName)"
                            @search="getUserList(contactName)"></van-search>
                <van-search v-else-if="currentFieldData.field_type==='radio_customer'"
                            v-model="contactName"
                            placeholder="请输入搜索关键词"
                            @blur="getCustomerList(contactName)"
                            @cancel="getCustomerList(contactName)"
                            @clear="getCustomerList(contactName)"
                            @search="getCustomerList(contactName)"></van-search>
                <ul v-if="currentFieldData.field_type==='contact'" class="contact_select_list">
                    <li class="contact_select_item"
                        @click="handleClickContactItem(item)"
                        v-for="item in userList">
                        <van-checkbox v-model="item.checked"
                                      @change="handleContactCheckboxChange(item)"
                                      v-if="currentFieldData.select_range.includes('1')"></van-checkbox>
                        <span class="avatar_wrap">
                           <img :src="item.avatar?item.avatar:defaultImg" alt="">
                       </span>
                        <span v-text="item.name"></span>
                    </li>
                </ul>
                <ul v-else-if="currentFieldData.field_type==='radio_customer'" class="contact_select_list">
                    <li v-for="item in relateCustomList"
                        class="contact_select_item"
                        @click.stop="handleClickCustomerItem(item)">
                        <span v-text="item.name.value"></span>
                    </li>
                </ul>
                <ul v-else-if="currentFieldData.field_type==='customer_contact'" class="contact_select_list">
                    <li v-for="item in relateCustomContactList"
                        class="contact_select_item"
                        @click.stop="handleClickCustomerContactItem(item)">
                        <span v-text="item.name"></span>
                    </li>
                </ul>
            </div>
        </van-overlay>
        <!--单选弹窗-->
        <van-overlay :custom-style="{background: 'rgba(0, 0, 0, 0.3)'}"
                     v-if="showRadioPicker"
                     :show="showRadioPicker">
            <div class="radio_option_wrap">
                <ul class="radio_option_list">
                    <li v-for="item in currentFieldData.options"
                        class="radio_option_item"
                        @click="handleClickRadioOption(item)"
                        v-text="item.label"></li>
                </ul>
                <div class="cancel_btn" @click="showRadioPicker=false">取消</div>
            </div>
        </van-overlay>
        <!--商机阶段单选弹窗-->
        <van-overlay v-if="showRadioProjectStagePicker"
                     :custom-style="{background: 'rgba(0, 0, 0, 0.3)'}"
                     :show="showRadioProjectStagePicker">
            <div class="radio_option_wrap">
                <ul class="radio_option_list">
                    <li v-for="item in currentFieldData.options"
                        :key="item.project_stage_id"
                        class="radio_option_item"
                        @click="handleClickRadioProjectStageOption(item)"
                        v-text="item.name"></li>
                </ul>
                <div class="cancel_btn" @click="showRadioProjectStagePicker=false">取消</div>
            </div>
        </van-overlay>
        <!--多选组件弹窗-->
        <van-popup v-if="showCheckboxPicker"
                   :style="{ height: '80%' }"
                   :value.sync="showCheckboxPicker"
                   position="bottom"
                   round>
            <div class="checkbox_select_wrap">
                <div class="checkbox_select_header">
                    <van-icon name="arrow-left" @click="handleClickCheckboxPickerClose"></van-icon>
                    <span class="title" v-text="'选择'+currentFieldData.field_name"></span>
                    <el-link :underline="false" type="primary" @click="handleClickCheckboxPickerConfirm">确定</el-link>
                </div>
                <div class="checkbox_select_content">
                    <ul class="checkbox_select_list">
                        <li v-for="item in checkboxOptionsList"
                            :key="item.value"
                            class="checkbox_select_item"
                            @click="handleClickCheckboxItem(item)">
                            <van-checkbox v-model="item.checked"
                                          @change="handleCheckboxItemChange(item)"></van-checkbox>
                            <span v-text="item.label"></span>
                        </li>
                    </ul>
                </div>
            </div>
        </van-popup>
        <van-popup v-if="showCheckboxTagPicker"
                   :style="{ height: '80%' }"
                   :value.sync="showCheckboxTagPicker"
                   position="bottom"
                   round>
            <div class="checkbox_select_wrap">
                <div class="checkbox_select_header">
                    <van-icon name="arrow-left" @click="handleClickCheckboxPickerClose"></van-icon>
                    <span class="title" v-text="'选择'+currentFieldData.field_name"></span>
                    <el-link :underline="false" type="primary" @click="handleClickCheckboxPickerConfirm">确定</el-link>
                </div>
                <div class="checkbox_select_content">
                    <ul class="checkbox_select_list">
                        <li v-for="item in currentFieldData.options"
                            :key="item.id"
                            class="checkbox_select_item"
                            @click="handleClickCheckboxItem(item)">
                            <van-checkbox v-model="item.checked"
                                          @change="handleCheckboxItemChange(item)"></van-checkbox>
                            <span v-text="item.name"></span>
                        </li>
                    </ul>
                </div>
            </div>
        </van-popup>
        <!--ocr识别弹窗-->
        <van-dialog @close="handleClickOcrRecognizeClose"
                    v-if="ocrRecognizeVisible"
                    :show-confirm-button="false"
                    :title="currentFieldData.field_type==='id_card'?'识别身份证信息':'识别银行卡信息'"
                    show-cancel-button
                    v-model="ocrRecognizeVisible">
            <div class="ocr_upload_wrap">
                <el-image :preview-src-list="[ocrImgUrl]"
                          :src="ocrImgUrl"
                          fit="cover"
                          v-if="ocrImgUrl">
                </el-image>
                <i @click="ocrImgUrl=''" class="el-icon-error" v-if="ocrImgUrl"></i>
                <div class="ocr_upload_inner_wrap" v-else>
                    <div class="ta_c">
                        <i class="el-icon-plus"></i>
                        <p class="upload_text">上传照片</p>
                    </div>
                    <input @change="handleOcrUploadChange($event)"
                           accept='image/png,image/jpeg,image/gif,image/jpg'
                           type="file">
                </div>
            </div>
            <p class="ocr_upload_hint">只支持.jpg/.png 格式</p>
        </van-dialog>
        <!--收付款账户选择弹窗-->
        <van-popup v-model="showTellerSelectPopup"
                   v-if="showTellerSelectPopup"
                   :style="{ width: '100%',height: '100vh' }"
                   position="bottom"
                   @close="handleSelectTellerCancel">
            <div class="select_bank_card_wrap">
                <div class="select_bank_card_header">
                    <div>
                        <van-icon name="arrow-left" @click="handleSelectTellerCancel"></van-icon>
                        <span v-text="'选择' + currentFieldData.field_name"></span>
                    </div>
                    <el-link :underline="false" type="primary" @click="addTellerVisible=true">添加账户</el-link>
                </div>
                <div class="select_bank_card_body">
                    <ul class="select_bank_card_list">
                        <li v-for="bank in currentFieldData.options"
                            :key="bank.bank_card_id"
                            class="select_bank_card_item"
                            @click.stop="handleClickSelectBankCard(bank)">
                            <div class="left_info_wrap">
                                <van-checkbox v-model="bank.checked"></van-checkbox>
                                <img alt=""
                                     class="bank_logo"
                                     src="https://download.hecoos.com/enlightv/2023-50/Mai6CwZRQfRjb23YEACA.png">
                                <div style="margin-left: 6px;flex: 1">
                                    <span class="account_name" v-text="bank.account_name"></span>
                                    <el-tag size="mini"
                                            v-text="bank.account_type==='1'?'个人账户':'对公账户'"></el-tag>
                                    <p class="bank_name"
                                       v-text="bank.bank_name + '（' + bank.card_number + '）'"></p>
                                </div>
                            </div>
                            <div class="ta_r">
                                <div class="handle_icon_wrap">
                                    <i class="iconfont icon-bianji"
                                       @click.stop="handleClickEditPayingTeller(bank)"></i>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </van-popup>
        <!--添加银行账户-->
        <van-popup v-model="addTellerVisible"
                   v-if="addTellerVisible"
                   :style="{ width: '100%',height: '100vh' }"
                   position="right">
            <div class="select_bank_card_header">
                <div>
                    <van-icon name="arrow-left" @click="handleClickAddTellerCancel"></van-icon>
                    <span v-text="payingTellerForm.bank_card_id?'编辑账户':'添加账户'"></span>
                </div>
                <el-link v-if="payingTellerForm.bank_card_id"
                         :underline="false"
                         type="primary"
                         @click="handleClickDelPayingTeller">删除
                </el-link>
            </div>
            <div class="add_teller_wrap">
                <van-form ref="payingTellerForm"
                          :rules="payingTellerFormRules"
                          @submit="handleClickAddTellerConfirm">
                    <van-field label="账户类型" name="account_type">
                        <template #input>
                            <van-radio-group v-model="payingTellerForm.account_type" direction="horizontal">
                                <van-radio :name="1">个人账户</van-radio>
                                <van-radio :name="2">对公账户</van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>
                    <van-field v-model="payingTellerForm.account_name"
                               :rules="payingTellerFormRules.account_name"
                               label="户名"
                               name="account_name"
                               placeholder="请输入户名"
                               required>
                    </van-field>
                    <van-field v-model="payingTellerForm.card_number"
                               :rules="payingTellerFormRules.card_number"
                               label="账号"
                               name="card_number"
                               placeholder="请输入账号"
                               required>
                    </van-field>
                    <van-field v-model="payingTellerForm.bank_name"
                               :rules="payingTellerFormRules.bank_name"
                               label="所属银行"
                               name="bank_name"
                               placeholder="请输入所属银行"
                               required>
                    </van-field>
                    <van-field v-if="currentFieldData.bank_branch_is_show"
                               v-model="payingTellerForm.bank_branch"
                               :rules="payingTellerFormRules.bank_branch"
                               label="银行支行"
                               name="bank_branch"
                               placeholder="请输入银行支行"
                               required>
                    </van-field>
                    <div class="submit_btn_wrap">
                        <van-button block native-type="submit" round type="info">提交</van-button>
                    </div>
                </van-form>
            </div>
        </van-popup>
        <el-image ref="preview_img"
                  :preview-src-list="previewImgList"
                  :src="previewImgSrc"
                  style="display:none">
        </el-image>
        <!-- 新增关联表单-->
        <van-popup v-if="relateCustomFormVisible"
                   v-model="relateCustomFormVisible"
                   :style="{ height: '100%' }"
                   position="bottom">
            <div v-loading="loading" class="public_container">
                <div class="returnNavBar">
                    <ReturnNavBar :isAllFunctions="false"
                                  :isCustomReturnEvent="true"
                                  :isTitleNormal="true"
                                  title="返回"
                                  @returnEvent="handleClickRelateFormCancel"></ReturnNavBar>
                </div>
                <div class="detail_wrap_container pt_10">
                    <CustomFormMobile ref="relateCustomForm"
                                      :field_list="relateCustomFormFields"
                                      :form_detail="relateCustomFormData"
                                      :pk_id="relate_pk_id"
                                      :relate_field_form="relateFieldForm"
                                      :is_form_module="relateCustomFormIsFormModule"
                                      @submit-form="submitRelateFormData"/>
                    <div v-if="relateCustomFormIsApprove===1" class="add_approval_select_process">
                        <div class="page_little_title">
                            <span class="title">审批流程</span>
                        </div>
                        <approveProcessSelect ref="approveProcessSelectRef"
                                              :approval_node_list="approval_node_list">
                        </approveProcessSelect>
                    </div>
                </div>
                <div class="add_footer_wrap">
                    <van-button :disabled="btnDisabled"
                                block
                                round
                                type="info"
                                @click="handleClickCrmContactConfirm">
                        提交
                    </van-button>
                </div>
            </div>
        </van-popup>
        <!--选择仓库-->
        <SelectStock v-if="selectStockPopupShow" :allAuthority="true"
                     :selectStockPopupShow.sync="selectStockPopupShow"
                     :selectedStockId="(purchaseDetailInfo && purchaseDetailInfo.stock_id) ? purchaseDetailInfo.stock_id : 0"
                     @success="selectStockSuccess"/>
        <!--选择订单-->
        <SelectOrder v-if="selectOrderPopupShow" :selectData="[]" :selectOrderPopupShow.sync="selectOrderPopupShow"
                     @success="successSelectOrderRefresh"/>
        <!--选择订单产品弹窗-->
        <SelectOrderProducts v-if="selectProductsDialog"
                             ref="selectOrderProducts"
                             @send-goods-data="handleClickSelectProductsConfirm"
                             :dialogVisible.sync="selectProductsDialog">
        </SelectOrderProducts>
        <!--订单产品配置弹窗-->
        <ProductConfigDialog v-if="productConfigDialogVisible"
                             :dialogVisible.sync="productConfigDialogVisible"
                             :goods_detail="goods_detail"
                             :goods_id="goods_id"
                             :product_type="product_type"
                             :is_release="is_release"
                             @submit="handleGetProductConfig"/>
        <!--选择关联商机-->
        <van-popup v-if="relateProjectVisible"
                   v-model="relateProjectVisible"
                   :style="{ width: '100%',height: '100vh' }"
                   position="bottom">
            <div class="public_container">
                <div class="returnNavBar">
                    <ReturnNavBar :isAllFunctions="false"
                                  :isCustomReturnEvent="true"
                                  :isTitleNormal="true"
                                  title="返回"
                                  @returnEvent="relateProjectVisible=false"></ReturnNavBar>
                </div>
                <div class="relate_table_search">
                    <van-search v-model="relateTableKeyword"
                                placeholder="请输入需要查询的内容"
                                @search="handleSearchRelateTable"/>
                    <span class="handle_icon_wrap" @click="showDateRangePicker=true">
                        <i class="iconfont icon-rili1"></i>
                    </span>
                </div>
                <div class="detail_wrap_container">
                    <ul v-if="relateProjectList.length" v-infinite-scroll="scrollLoadRelateProjectList"
                        class="relate_project_list">
                        <li v-for="item in relateProjectList"
                            :key="item.project_id"
                            class="relate_project_item"
                            @click="handleClickRelateProjectItem(item)">
                            <div class="relate_project_title" v-text="item.name"></div>
                            <div class="relate_project_content">
                                <div class="flex_js_wrap mb_8">
                                    <span class="field_label">销售</span>
                                    <div class="custom_contact_field_wrap" @click.stop>
                                        <PersonnelCard :userId="item.salesperson">
                                            <template slot="container">
                                                <img :src="item.salesperson_avatar|| defaultImg" alt=""
                                                     class="avatar">
                                                <span class="name" v-text="item.salesperson_name"></span>
                                            </template>
                                        </PersonnelCard>
                                    </div>
                                </div>
                                <div class="flex_js_wrap">
                                    <span class="field_label">创建时间</span>
                                    <span v-text="item.created_at"></span>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div v-else class="ta_c">暂无数据</div>
                </div>
            </div>
        </van-popup>
        <!--选择关联报价单-->
        <van-popup v-if="importQuotationVisible"
                   v-model="importQuotationVisible"
                   :style="{ width: '100%',height: '100vh' }"
                   position="bottom">
            <div class="public_container">
                <div class="returnNavBar">
                    <ReturnNavBar :isAllFunctions="false"
                                  :isCustomReturnEvent="true"
                                  :isTitleNormal="true"
                                  title="返回"
                                  @returnEvent="importQuotationVisible=false"></ReturnNavBar>
                </div>
                <div class="relate_table_search">
                    <van-search v-model="relateTableKeyword"
                                placeholder="请输入需要查询的内容"
                                @search="handleSearchRelateTable"/>
                    <span class="handle_icon_wrap" @click="showDateRangePicker=true">
                        <i class="iconfont icon-rili1"></i>
                    </span>
                </div>
                <div class="detail_wrap_container">
                    <ul v-if="quotationData.length" v-infinite-scroll="scrollLoadRelateQuotationList"
                        class="relate_project_list">
                        <li v-for="item in quotationData"
                            :key="item.project_quotation_id"
                            class="relate_project_item"
                            @click="handleClickRelateQuotationItem(item)">
                            <div class="relate_project_title" v-text="item.quotation_num"></div>
                            <div class="relate_project_content">
                                <div class="flex_js_wrap mb_8">
                                    <div class="flex_wrap">
                                        <span class="field_label">报价人：</span>
                                        <div class="custom_contact_field_wrap">
                                            <PersonnelCard :userId="item.quoter">
                                                <template slot="container">
                                                    <img :src="item.quoter_avatar || defaultImg" alt=""
                                                         class="avatar">
                                                    <span class="name" v-text="item.quoter_name"></span>
                                                </template>
                                            </PersonnelCard>
                                        </div>
                                    </div>
                                    <div class="flex_wrap">
                                        <span class="field_label">报价时间：</span>
                                        <span v-text="item.quotation_at"></span>
                                    </div>
                                </div>
                                <div class="flex_js_wrap">
                                    <div class="flex_wrap">
                                        <span class="field_label">报价总金额：</span>
                                        <span v-text="'¥'+item.total_price"></span>
                                    </div>
                                    <div class="flex_wrap">
                                        <span class="field_label">失效时间：</span>
                                        <span v-text="item.expiration_at"></span>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div v-else class="ta_c">暂无数据</div>
                </div>
            </div>
        </van-popup>
        <!--关联审批单-->
        <van-popup v-if="relateApproveFormVisible"
                   v-model="relateApproveFormVisible"
                   :style="{ width: '100%',height: '100vh' }"
                   position="bottom">
            <div class="public_container">
                <div class="returnNavBar">
                    <ReturnNavBar :isAllFunctions="false"
                                  :isCustomReturnEvent="true"
                                  :isTitleNormal="true"
                                  title="返回"
                                  @returnEvent="handleClickRelateApproveCancel"></ReturnNavBar>
                </div>
                <div class="relate_table_search">
                    <van-search v-model="relateApproveKeyword"
                                placeholder="请输入需要查询的内容"
                                @search="handleRelateApproveInputSearch"/>
                </div>
                <div class="detail_wrap_container relate_approve_wrap">
                    <ul class="relate_approve_status_list">
                        <li :class="{'active':relateApproveStatus==='initiated_by_me'}"
                            class="relate_approve_status_item"
                            @click="handleClickRelateApproveStatus('initiated_by_me')">已发起
                        </li>
                        <li v-if="currentFieldData.not_promoter_self&&!currentFieldData.relate_approved"
                            :class="{'active':relateApproveStatus==='awaiting_my_action'}"
                            class="relate_approve_status_item"
                            @click="handleClickRelateApproveStatus('awaiting_my_action')">待处理
                        </li>
                        <li v-if="currentFieldData.not_promoter_self"
                            :class="{'active':relateApproveStatus==='already_handled_by_me'}"
                            class="relate_approve_status_item"
                            @click="handleClickRelateApproveStatus('already_handled_by_me')">已处理
                        </li>
                        <li v-if="currentFieldData.not_promoter_self"
                            :class="{'active':relateApproveStatus==='received_by_me'}"
                            class="relate_approve_status_item"
                            @click="handleClickRelateApproveStatus('received_by_me')">已收到
                        </li>
                    </ul>
                    <ul v-if="relateApproveList.length"
                        v-infinite-scroll="scrollLoadRelateApprove"
                        class="relate_approve_list">
                        <li v-for="(item,index) in relateApproveList"
                            :class="{'active':selectRelateApproveList.findIndex(approve=>approve.id===item.id) !== -1}"
                            class="relate_approve_item"
                            @click="handleClickRelateApproveItem(item,index)">
                            <div class="flex_js_wrap mb_16">
                                <h4 v-text="item.approval_set_name"></h4>
                                <div :class="'approve_status_' + item.status" class="approve_status"
                                     v-text="item.status === 0 ? '审批中' : item.status === 1 ? '已通过' : item.status === 2 ? '已拒绝' : '已撤回'"></div>
                            </div>
                            <div v-if="item.overview_fields&&item.overview_fields.length" class="mb_16">
                                <OverviewFields :overviewFields="item.overview_fields"/>
                            </div>
                            <div class="flex_js_wrap">
                                <div class="custom_contact_field_wrap">
                                    <PersonnelCard v-if="item.user"
                                                   :userId="item.user.id">
                                        <template slot="container">
                                            <img :src="item.user.avatar || defaultImg" alt=""
                                                 class="avatar">
                                            <span class="name" v-text="item.user.name"></span>
                                        </template>
                                    </PersonnelCard>
                                </div>
                                <div>
                                    <span class="field_label">申请时间：</span>
                                    <span class="field_value" v-text="item.created_at"></span>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div v-else class="ta_c">暂无数据</div>
                </div>
                <div class="add_footer_wrap">
                    <van-button size="large"
                                type="primary"
                                @click="handleClickRelateApproveConfirm">提交
                    </van-button>
                </div>
            </div>
        </van-popup>
        <!--选择关联打卡记录-->
        <van-popup v-if="relateCheckRecordVisible"
                   v-model="relateCheckRecordVisible"
                   :style="{ width: '100%',height: '100vh' }"
                   position="bottom">
            <div v-loading="relateCheckRecordLoading" class="public_container">
                <div class="returnNavBar">
                    <ReturnNavBar :isAllFunctions="false"
                                  :isCustomReturnEvent="true"
                                  :isTitleNormal="true"
                                  title="返回"
                                  @returnEvent="relateCheckRecordVisible=false"></ReturnNavBar>
                </div>
                <div class="relate_table_search">
                    <van-search v-model="relateCheckRecordSearch.keyword"
                                placeholder="请输入需要查询的内容"
                                @search="handleCheckRecordInputSearch"/>
                    <span class="handle_icon_wrap" @click="showDateRangePicker=true">
                        <i class="iconfont icon-rili1"></i>
                    </span>
                </div>
                <div class="detail_wrap_container">
                    <ul v-if="relateCheckRecord.length" v-infinite-scroll="scrollLoadRelateRecordsList"
                        class="relate_check_record_list">
                        <li v-for="item in relateCheckRecord"
                            :key="item.id"
                            class="relate_check_record_item"
                            @click="handleClickRelateCheckRecordItem(item)">
                            <van-checkbox v-model="item.is_checked"></van-checkbox>
                            <div style="flex: 1">
                                <div class="flex_js_wrap mb_8">
                                    <div class="flex_wrap">
                                        <i class="iconfont icon-messgae-clock"></i>
                                        <span v-text="item.start_time||'--'"></span>
                                        <span v-if="item.punch_type==='INTERVAL'">～</span>
                                        <span v-if="item.punch_type==='INTERVAL'" v-text="item.end_time||'--'"></span>
                                    </div>
                                    <el-link :underline="false" type="primary"
                                             @click.stop="handleClickRelateCheckRecordDetail(item)">详情
                                    </el-link>
                                </div>
                                <div class="flex_wrap">
                                    <i class="iconfont icon-weizhi1"></i>
                                    <span v-text="item.address||'--'"></span>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div v-else class="ta_c">暂无数据</div>
                </div>
                <div class="add_footer_wrap">
                    <van-button size="large"
                                type="primary"
                                @click="handleClickRelateCheckRecordConfirm">提交
                    </van-button>
                </div>
            </div>
            <checkRecordDetail v-if="relateCheckRecordDetailVisible"
                               :check_record_id="check_record_id"
                               :dialog-visible.sync="relateCheckRecordDetailVisible"/>
        </van-popup>
        <!-- 打卡弹窗-->
        <van-popup v-if="clockInVisible"
                   v-model="clockInVisible"
                   :style="{ width: '100%',height: '60vh' }"
                   position="bottom"
                   round>
            <div class="clock_in_container">
                <div class="flex_wrap">
                    <h4>单次打卡</h4>
                    <van-icon name="cross" @click="handleClickCloseCloseIn"/>
                </div>
                <div class="clock_in_time_wrap">
                    <div class="flex_js_wrap">
                        <h2 class="clock_in_formatted_time" v-text="clock_in_formatted_time"></h2>
                        <div>
                            <div class="clock_in_formatted_week_day ta_r" v-text="clock_in_formatted_week_day"></div>
                            <div class="clock_in_formatted_date ta_r" v-text="clock_in_formatted_date"></div>
                        </div>
                    </div>
                    <div class="flex_wrap">
                        <i class="iconfont icon-weizhi1"></i>
                        <span class="ellipsis_2" v-text="locationName || '定位失败'"></span>
                    </div>
                </div>
                <div class="ta_r">
                    <el-link :underline="false"
                             type="primary"
                             @click.stop="handleClickUpdateClock"><i class="iconfont icon-shuaxin"></i> 更改定位
                    </el-link>
                </div>
            </div>
            <div class="clock_in_btn">
                <van-button size="small"
                            type="primary"
                            @click="handleClickClockIn">打卡
                </van-button>
            </div>
            <!-- 打卡成功弹框 -->
            <van-popup v-model="clockInSuccessPopup"
                       :style="{ height: '434px' }"
                       closeable
                       position="bottom"
                       round
                       @close="handleClockInSuccessPopupClose">
                <div class="clockIn_success_wrap">
                    <div class="clockIn_success_icon">
                        <img alt=""
                             src="https://download.hecoos.com/enlightv/2024-52/ee3c2949285252c3cf0839120c8a21d8.png"/>
                        <p>打卡成功</p>
                    </div>
                    <van-form input-align="right">
                        <van-field readonly>
                            <template #label>
                                <i class="iconfont icon-messgae-clock"></i> <span>开始时间</span>
                            </template>
                            <template #input>
                                <span v-text="clockInForm.punch_at"></span>
                            </template>
                        </van-field>
                        <van-field readonly>
                            <template #label>
                                <i class="iconfont icon-weizhi1"></i> <span>位置</span>
                            </template>
                            <template #input>
                                <span v-text="clockInForm.locationName"></span>
                            </template>
                        </van-field>
                        <van-field readonly>
                            <template #label>
                                <i class="iconfont icon-tupian"></i> <span>照片</span>
                            </template>
                            <template #input>
                                <div class="upload_img_wrap">
                                    <div v-for="(imgItem, imgIndex) in clockInForm.images" :key="imgIndex"
                                         class="item_img">
                                        <img :src="imgItem" alt=""/>
                                        <i class="iconfont icon-guanbi1" @click="handleClickImgDelete(imgIndex)"></i>
                                    </div>
                                    <div v-if="clockInForm.images.length < 5"
                                         class="upload_icon"
                                         @click="handleClickSelectUploadType">
                                        <i class="iconfont icon-xiangji"></i>
                                    </div>
                                </div>
                            </template>
                        </van-field>
                        <div class="vertical_input_wrap">
                            <van-field
                                    v-model="clockInForm.remark"
                                    autosize
                                    label=""
                                    placeholder="请输入备注"
                                    rows="3"
                                    type="textarea"
                                    @blur="handleUpdateAttendanceCheck">
                                <template #label>
                                    <i class="iconfont icon-bianji"></i> <span>备注</span>
                                </template>
                            </van-field>
                        </div>
                    </van-form>
                </div>
            </van-popup>
            <!-- 选择照片上传方式 -->
            <van-action-sheet v-model="imageActionSheetShow" cancel-text="取消">
                <template #default>
                    <div v-for="item in imageActions" class="van-action-sheet__item ta-c">
                        <span v-text="item.name"></span>
                        <input v-if="item.value === 1"
                               accept="image/png,image/jpeg,image/gif,image/jpg"
                               capture="camera"
                               type="file"
                               @change="handleClickUploadFile"/>
                        <input v-if="item.value === 2"
                               accept="image/png,image/jpeg,image/gif,image/jpg"
                               type="file"
                               @change="handleClickUploadFile"/>
                    </div>
                </template>
            </van-action-sheet>
            <!-- 更改定位 -->
            <van-popup v-model="updateClockPopup"
                       :overlay="false"
                       :style="{ height: '100%' }"
                       position="bottom">
                <div class="returnNavBar">
                    <ReturnNavBar :isAllFunctions="false"
                                  :isCustomReturnEvent="true"
                                  :isTitleNormal="true"
                                  title="返回"
                                  @returnEvent="updateClockPopup=false"></ReturnNavBar>
                </div>
                <div class="update_clock_popup_content">
                    <p class="map_tip">可更改500米内的定位范围</p>
                    <div id="mapBox" style="width: 100%; height: 383px"></div>
                    <van-form input-align="right">
                        <van-field readonly>
                            <template #label>
                                <i class="iconfont icon-messgae-clock"></i> <span>开始时间</span>
                            </template>
                            <template #input>
                                <span v-text="clock_in_formatted_time"></span>
                            </template>
                        </van-field>
                        <van-field readonly>
                            <template #label>
                                <i class="iconfont icon-weizhi1"></i> <span>位置</span>
                            </template>
                            <template #input>
                                <span v-text="updateClockForm.locationName"></span>
                            </template>
                        </van-field>
                        <van-field readonly>
                            <template #label>
                                <i class="iconfont icon-tupian"></i> <span>照片</span>
                            </template>
                            <template #input>
                                <div class="upload_img_wrap">
                                    <div v-for="(imgItem, imgIndex) in updateClockForm.images" :key="imgIndex"
                                         class="item_img">
                                        <img :src="imgItem" alt=""/>
                                        <i class="iconfont icon-guanbi1" @click="handleClickImgDelete(imgIndex)"></i>
                                    </div>
                                    <div v-if="clockInForm.images.length < 5"
                                         class="upload_icon"
                                         @click="handleClickSelectUploadType">
                                        <i class="iconfont icon-xiangji"></i>
                                    </div>
                                </div>
                            </template>
                        </van-field>
                        <div class="vertical_input_wrap">
                            <van-field
                                    v-model="updateClockForm.remark"
                                    autosize
                                    label=""
                                    placeholder="请输入备注"
                                    rows="3"
                                    type="textarea">
                                <template #label>
                                    <i class="iconfont icon-bianji"></i> <span>备注</span>
                                </template>
                            </van-field>
                        </div>
                    </van-form>
                    <div class="update_clock_btn">
                        <van-button type="info" @click="handleClickUpdateClockSubmit">打卡</van-button>
                    </div>
                </div>
            </van-popup>
        </van-popup>
    </div>
</template>
<script>
import {
    calculate,
    formatFileSize,
    getWorldArea,
    getItemByIdInTree,
    findObjectById,
    formatDate,
    getNowDate,
    numberPriceToChinese,
    goodsPriceDiscountsText, getBusinessIsApproval
} from '@/utils'
import {uploadImg} from '@/utils/uploadOss'
import {
    addContact,
    addressParse,
    bankCardAdd,
    bankCardDel,
    bankCardEdit,
    contactDetail,
    editContact,
    getBankCardList,
    GetDepartmentList,
    getFormFields,
    GetUserList,
    ocrRecognize,
    getHoliday,
    checkInvoiceExists,
    PersonTagAllList,
    searchProducts,
    PurchaseOrderGetProducts,
    PurchaseGetSupplier,
    getProjectList,
    GetCustomerPrivateList,
    GetContactList,
    projectQuotationOrderList,
    orderImportDetails,
    getRelateCheckRecord,
    CreateAttendanceCheck,
    UpdateAttendanceCheck,
    getApprovalType,
    getRelateApproval,
    getProjectGroup,
    getApprovalNodes,
    CustomerPrivateEdit, CustomerPrivateAdd, orderAdd
} from '@/api'
import {mapState} from 'vuex'
import CustomFormMobile from '@/components/mComponents/CustomFormMobile'
import SelectOrderProducts from '@/components/mComponents/SelectProductDialog'
import ProductConfigDialog from "@/components/mComponents/ProductConfigDialog";
import checkRecordDetail from "@/components/mComponents/checkRecordDetail";
import SelectStock from "../../views/mobile/InventoryManagement/component/select_stock.vue"
import SelectOrder from "./SelectOrder"
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import PersonnelCard from "@/components/pComponents/PersonnelCard.vue";
import {ImagePreview} from "vant";
import OverviewFields from "@/components/pComponents/overviewFields.vue";
import approveProcessSelect from "@/components/pComponents/approveProcessSelect.vue";

export default {
    name: 'CustomFormMobile',
    data() {
        return {
            loading: false,
            defaultImg: require('@/assets/images/default.jpg'),
            formInfoList: [],
            customForm: {},
            customFormRules: {},
            userList: [],
            departmentList: [],
            previewImgList: [],
            previewImgSrc: '',
            currentFieldData: {},
            currentFieldFormData: {},
            nowFieldsList: [],
            formName: '',
            payingTellerForm: {
                bank_card_id: '',
                account_type: '1',
                account_name: '',
                card_number: '',
                bank_name: '',
                bank_branch: '',
            },
            payingTellerFormRules: {
                account_type: [{
                    required: true,
                    message: '请选择账户类型',
                    trigger: 'change'
                }],
                account_name: [
                    {
                        required: true,
                        message: '请输入户名',
                        trigger: 'onBlur'
                    },
                    {
                        min: 2,
                        max: 20,
                        message: '请输入2-20个字符'
                    },
                ],
                card_number: [
                    {required: true, trigger: 'onBlur', message: '请输入账号'},
                    {
                        required: true,
                        message: '账号格式不正确',
                        validator: value => {
                            const number = value.replace(/\s/g, '')
                            // const regs = /^(?:\d{9}|\d{16}|\d{17}|\d{19})$/;
                            const regs = /^\d+$/;
                            return regs.test(number)
                        }
                    }
                ],
                bank_name: [{
                    required: true,
                    message: '请输入所属银行',
                    trigger: 'onBlur'
                }],
            },
            addTellerVisible: false,
            isEditSelected: false,
            relateCustomFormVisible: false,
            btnDisabled: false,
            relateCustomFormFields: [],
            relate_form_id: 0,
            relateCustomFormData: {},
            idCardForm: {
                value: '',
                name: '',
                birthday: '',
                address: '',
            },
            idCardFormRules: {},
            idCardFormDialogVisible: false,
            recognitionCardVisible: false,
            parseInfoVisible: false,
            parseInfo: '',
            // ocrImgUrl: 'https://download.hecoos.com/enlightv/2024-47/d943450a6db3572b722b970f109088fa.jfif',
            // ocrImgUrl: 'https://download.hecoos.com/enlightv/2024-47/3fa4fd7c6bc4b954fe1bc7b20a46e3e6.png',
            ocrImgUrl: '',
            invoiceUploadVisible: false,
            table_phone_type: '1',
            invoiceFilesList: [],
            invoiceDetailDialogVisible: false,
            invoiceInfoPreview: false,
            showRadioPicker: false,
            showRadioProjectStagePicker: false,
            showDateCalendar: false,
            showDatePopupShow: false,
            dateCalendarMin: new Date('1970-01-01'),
            dateCalendarMax: new Date('2070-01-01'),
            timeCalendarScope: {
                min_hour: 0,
                max_hour: 23,
                min_minute: 0,
                max_minute: 59,
            },
            currentDate: new Date(),
            currentTime: '',
            showDateRangePicker: false,
            cascaderOptions: [],
            cascaderFieldNames: {},
            showCascaderPicker: false,
            cascaderValue: '',
            showContactPicker: false,
            contactName: '',
            selectContacts: [],
            showCheckboxPicker: false,
            showCheckboxTagPicker: false,
            checkboxOptionsList: [],
            checkboxCheckedList: [],
            ocrRecognizeVisible: false,
            showTellerSelectPopup: false,
            productList: [],
            selectStockPopupShow: false,
            purchaseDetailInfo: null,
            selectOrderPopupShow: false,
            supplierNamePopoverShow: false,
            supplierList: [],
            order_procurement_show: false,
            goods_id: 0,
            product_type: '',
            goods_detail: {},
            goods_index: 0,
            goodsLeaseTimePickerVisible: false,
            selectProductsDialog: false,
            productConfigDialogVisible: false,
            relateProjectVisible: false,
            relateTableKeyword: '',
            relateProjectList: [],
            relatePagination: {
                pageNum: 1,
                pageSize: 15,
                total: 0,
            },
            relateCustomList: [],
            relateCustomContactList: [],
            relate_created_at: [],
            importQuotationVisible: false,
            quotationData: [],
            rest_rule_json: {},
            overtime_rule_json: {},
            relateCheckRecord: [],
            relateCheckRecordSearch: {
                keyword: '',
                check_in_date: [],
            },
            relateCheckRecordPagination: {
                pageNum: 1,
                pageSize: 15,
                total: 0,
            },
            relateCheckRecordVisible: false,
            relateCheckRecordLoading: false,
            relateCheckRecordDetailVisible: false,
            check_record_id: 0,
            clockInVisible: false,
            currentClockInTime: new Date(),
            clockInTimer: null,
            location: "116.359767,40.073051",
            locationName: "首开国风美唐综合楼-3号楼",
            selectedPosition: [],
            map: null,
            updateClockPopup: false,
            clockInSuccessPopup: false,
            clockInForm: {
                punch_at: "",
                locationName: "",
                remark: "",
                images: [],
            },
            imageActionSheetShow: false,
            imageActions: [
                {name: "拍照", value: 1},
                {name: "从手机相册选择", value: 2},
            ],
            currentClockId: 0,
            updateClockForm: {
                locationName: "",
                location: "",
                is_skip: 0,
                remark: "",
                images: [],
            },
            relateApproveSetIds: [],
            relateApproveTypeList: [],
            relateApproveList: [],
            relateApprovePage: {
                pageNum: 1,
                pageSize: 15,
                total: 0,
            },
            relateApproveKeyword: '',
            relateApproveLoading: false,
            relateApproveFormVisible: false,
            relateApproveAction: 'initiated_by_me',//awaiting_my_action:待我处理 already_handled_by_me:我已处理 received_by_me:我收到的 initiated_by_me:我发起的 copy_by_me:抄送我的
            relateApproveStatus: 'initiated_by_me',//awaiting_my_action:待我处理 already_handled_by_me:我已处理 received_by_me:我收到的 initiated_by_me:我发起的 copy_by_me:抄送我的
            selectRelateApproveList: [],
            old_project_group_id: 0,
            relateCustomFormIsApprove: 0,
            relateFieldForm: {},
            relateCustomFormIsFormModule: false,
            relate_pk_id: 0,
            approval_node_list: [],
            order_is_release: 0
        }
    },
    props: {
        //表单字段数据
        field_list: {
            type: Array,
            default: () => {
                return []
            }
        },
        //是否为预览模式
        is_preview_mode: {
            type: Boolean,
            default: false
        },
        //是否有表单分组
        is_form_module: {
            type: Boolean,
            default: () => false
        },
        //是否为预览模式
        is_filter_field: {
            type: Boolean,
            default: false
        },
        //表单详情，编辑时使用
        form_detail: {
            type: Object,
            default: () => {
                return {}
            }
        },
        //当前表单ID，编辑时使用
        pk_id: {
            type: Number,
            default: 0
        },
        field_form: {
            type: String,
            default: ''
        },
        is_release: {
            type: Number,
            default: 0
        },
        //是否重新计算订单金额信息
        is_recalculate: {
            type: Boolean,
            default: false
        },
        //关联客户id
        relate_customer_id: {
            type: Number,
            default: 0
        },
    },
    components: {
        approveProcessSelect,
        OverviewFields,
        PersonnelCard,
        ReturnNavBar,
        CustomFormMobile,
        SelectStock,
        SelectOrder,
        SelectOrderProducts,
        ProductConfigDialog,
        checkRecordDetail
    },
    computed: {
        compute_mode_field_list() {
            let list = []
            //取出字段列表中,包括明细列表中的所有的计算公式
            this.formInfoList.forEach(field => {
                if (field.field_type === 'compute_mode') {
                    list.push(field)
                } else if (field.field_type === 'computed_money') {
                    if (field.filling_method === '1') {
                        list.push(field)
                    }
                } else if (field.field_type === 'table') {
                    if (field._child && field._child.length) {
                        field._child.forEach(child => {
                            if (child.field_type === 'compute_mode') {
                                list.push(child)
                            }
                        })
                    }
                }
            })
            return list
        },
        order_amount_compute_mode() {
            //取出字段列表中,所有的金额计算字段
            return this.formInfoList.filter(field => field.field_type === 'order_amount_compute_mode' && field.status === 0)
        },
        ...mapState(['userInfo']),
        clock_in_formatted_time() {
            return formatDate(this.currentClockInTime, "hourtime");
        },
        clock_in_formatted_date() {
            return getNowDate('date');
        },
        clock_in_formatted_week_day() {
            const days = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
            const date = new Date();
            return days[date.getDay()];
        },
    },
    created() {
        if (this.is_form_module) {
            const fields = []
            this.field_list.forEach(field => {
                fields.push(field)
                if (field._child && field._child.length) {
                    field._child.forEach(child => {
                        fields.push(child)
                    })
                }
            })
            const {
                fieldList,
                formData,
                formDataRules
            } = this.deepCreateFormData(fields)
            this.formInfoList = fieldList
            this.customForm = formData
            this.customFormRules = formDataRules
        } else {
            const {
                fieldList,
                formData,
                formDataRules
            } = this.deepCreateFormData(this.field_list)
            this.formInfoList = fieldList
            this.customForm = formData
            this.customFormRules = formDataRules
        }
        if (this.pk_id !== 0 && Object.keys(this.form_detail).length) {
            this.deepSiteDetailValue(this.formInfoList, this.customForm, this.form_detail)
            const condition_fields = ['number', 'money', 'compute_mode', 'radio', 'checkbox', 'date', 'date_range', 'department']
            this.formInfoList.forEach(field => {
                if (condition_fields.includes(field.field_type)) {
                    this.checkMeetTheCondition(field, this.customForm, this.formInfoList)
                }
            })
            if (this.is_recalculate) {
                this.computeTotalAmountForTheOrderList()
            }
            if (this.field_form === 'projects') {
                this.customForm.project_group_id = this.form_detail.project_group_id || 0
                const task_field = ['radio', 'checkbox', 'date', 'department', 'contact']
                if (this.formInfoList.some(item => task_field.includes(item.field_type))) {
                    this.getBusinessGroup(true)
                }
            }
        }
    },
    mounted() {
    },
    methods: {
        //递归生成表单，表单字段列表，表单校验规则
        deepCreateFormData(field_data) {
            let fieldList = []
            let formData = {}
            let formDataRules = {}
            field_data.forEach(field => {
                field = {...field, ...field.extend}
                delete field.extend
                if (field.field_type === 'form_module') {
                    field.col_span = 24
                    fieldList.push(field)
                } else {
                    switch (field.field_type) {
                        case 'input':
                            formData[field.field_key] = {
                                value: '',
                            }
                            formDataRules[field.field_key] = [
                                {
                                    required: field.is_required === 1,
                                    trigger: 'onBlur',
                                    message: field.placeholder,
                                    validator: (value) => {
                                        return field.is_required === 1 ? value !== '' : true
                                    }
                                },
                                {
                                    required: field.is_required === 1,
                                    trigger: 'onBlur',
                                    message: '邮箱格式不正确',
                                    validator: (value) => {
                                        if (field.input_type === 'email' && value.replace(/\s/g, '') !== '') {
                                            const regs = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/
                                            return regs.test(value.replace(/\s/g, ''))
                                        } else {
                                            return true
                                        }
                                    }
                                },
                                {
                                    required: field.is_required === 1,
                                    trigger: 'onBlur',
                                    message: '文本内容与现有数据重复，请重新输入',
                                    validator: (value) => {
                                        if (field.is_unique === '1' && value !== '') {

                                        } else {
                                            return true
                                        }
                                    }
                                },
                            ]
                            break
                        case 'textarea':
                            formData[field.field_key] = {
                                value: '',
                            }
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [{
                                    required: true,
                                    trigger: 'onBlur',
                                    message: field.placeholder,
                                }]
                            }
                            break
                        case 'number':
                            formData[field.field_key] = {
                                value: undefined,
                                text: '',
                            }
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [{
                                    required: true,
                                    trigger: 'onBlur',
                                    message: field.placeholder,
                                }]
                            }
                            break
                        case 'money':
                            formData[field.field_key] = {
                                value: '',
                                text: '',
                                currency: field.currency[0],
                                chinese_text: '',
                                value_converted: '',
                            }
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [{
                                    required: true,
                                    trigger: 'onBlur',
                                    message: field.placeholder,
                                }]
                            }
                            break
                        case 'compute_mode':
                            formData[field.field_key] = {
                                value: '',
                                text: '',
                                chinese_text: '',
                            }
                            break
                        case 'money_compute_mode':
                            formData[field.field_key] = {
                                value: 0,
                                text: '0.00',
                                currency: field.currency[0],
                                chinese_text: '',
                                value_converted: '',
                            }
                            if (field.field_key === 'payable_amount') {
                                formDataRules[field.field_key] = [{
                                    required: true,
                                    trigger: 'onBlur',
                                    message: '请输入',
                                    validator: (rule, value, callback) => {
                                        return field.filling_method === '1' && value.value === ''
                                    }
                                }]
                            }
                            break
                        case 'order_amount_compute_mode':
                            formData[field.field_key] = {
                                value: '',
                                text: '',
                            }
                            if (field.filling_method === '1') {
                                field.initial_display = true
                            }
                            break
                        case 'telephone':
                            formData[field.field_key] = {
                                value: '',
                                phone_type: field.phone_type !== '2' ? '1' : '2',
                                prefix: field.phone_type !== '2' ? '+86' : '',
                                direct_dial: field.direct_dial,
                            }
                            formDataRules[field.field_key] = [{
                                required: field.is_required === 1,
                                trigger: 'onBlur',
                                validator: (value) => {

                                }
                            }]
                            break
                        case 'radio':
                            formData[field.field_key] = {
                                value: '',
                                text: '',
                            }
                            const default_option = field.options.find(o => o.default)
                            if (default_option) {
                                this.$set(formData[field.field_key], 'value', default_option.value)
                                this.$set(formData[field.field_key], 'text', default_option.label)
                                this.checkMeetTheCondition(field, formData, field_data)
                            }
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [{
                                    required: true,
                                    trigger: 'onChange',
                                    message: field.placeholder,
                                }]
                            }
                            break
                        case 'radio_project_stage':
                            formData[field.field_key] = {
                                value: '',
                                text: ''
                            }
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [{
                                    required: true,
                                    trigger: 'onChange',
                                    message: field.placeholder,
                                }]
                            }
                            break
                        case 'radio_customer':
                            formData[field.field_key] = {
                                value: '',
                                text: ''
                            }
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [{
                                    required: true,
                                    trigger: 'onChange',
                                    message: field.placeholder,
                                }]
                            }
                            break
                        case 'radio_project':
                            formData[field.field_key] = {
                                value: '',
                                text: ''
                            }
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [{
                                    required: true,
                                    trigger: 'onChange',
                                    message: field.placeholder,
                                }]
                            }
                            break
                        case 'checkbox':
                            formData[field.field_key] = {
                                value: [],
                                text: [],
                            }
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [{
                                    required: true,
                                    trigger: 'onChange',
                                    message: field.placeholder,
                                }]
                            }
                            break
                        case 'checkbox_user_tag':
                            formData[field.field_key] = {
                                value: [],
                                text: [],
                            }
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [{
                                    required: true,
                                    trigger: 'onChange',
                                    message: field.placeholder,
                                }]
                            }
                            break
                        case 'checkbox_quotation':
                            formData[field.field_key] = {
                                value: [],
                                text: [],
                            }
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [{
                                    required: true,
                                    trigger: 'onChange',
                                    message: field.placeholder,
                                }]
                            }
                            break
                        case 'cascader':
                            formData[field.field_key] = {
                                value: [],
                                text: '',
                            }
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [{
                                    required: true,
                                    trigger: 'onChange',
                                    message: field.placeholder,
                                }]
                            }
                            break
                        case 'date':
                            formData[field.field_key] = {
                                value: '',
                            }
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [{
                                    required: true,
                                    trigger: 'onChange',
                                    message: field.placeholder,
                                }]
                            }
                            break
                        case 'date_range':
                            formData[field.field_key] = {
                                value: [],
                                text: '',
                                duration: ''
                            }
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [{
                                    required: true,
                                    trigger: 'onChange',
                                    message: '请选择' + field.field_name,
                                }]
                            }
                            break
                        case 'address':
                            formData[field.field_key] = {
                                value: [],
                                text: '',
                                detail_address: ''
                            }
                            if (field.is_required === 1 || (field.is_show_detail_address && field.detail_address_is_required)) {
                                formDataRules[field.field_key] = {}
                                if (field.is_required === 1) {
                                    formDataRules[field.field_key].value = [{
                                        required: true,
                                        trigger: 'onChange',
                                        message: field.area_accuracy_placeholder,
                                    }]
                                }
                                if (field.is_show_detail_address && field.detail_address_is_required) {
                                    formDataRules[field.field_key].detail_address = [{
                                        required: true,
                                        trigger: 'onBlur',
                                        message: field.detail_address_placeholder,
                                    }]
                                }
                            }
                            break
                        case 'contact':
                            if (field.default) {
                                formData[field.field_key] = {
                                    value: [this.userInfo.user.id],
                                    text: [{
                                        id: this.userInfo.user.id,
                                        name: this.userInfo.user.name,
                                        avatar: this.userInfo.user.avatar,
                                    }]
                                }
                                this.getUserList()
                            } else {
                                formData[field.field_key] = {
                                    value: [],
                                    text: [],
                                }
                            }
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [{
                                    required: true,
                                    trigger: 'onChange',
                                    message: field.placeholder,
                                }]
                            }
                            break
                        case 'department':
                            formData[field.field_key] = {
                                value: [],
                                text: [],
                                titles: [],
                            }
                            if (field.default) {
                                this.getDepartmentList().then(res => {
                                    const data = findObjectById(res, this.userInfo.user.department_id)
                                    data.full_path = getItemByIdInTree(res, this.userInfo.user.department_id)
                                    if (data) {
                                        this.$set(formData[field.field_key], 'value', [data.relate_id])
                                        this.$set(formData[field.field_key], 'text', [{
                                            title: data.relate_name,
                                            id: data.relate_id,
                                            full_path: data.full_path,
                                        }])
                                        this.$set(formData[field.field_key], 'titles', [data.relate_name])
                                        this.checkMeetTheCondition(field, formData, field_data)
                                    }
                                })
                            }
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [{
                                    required: true,
                                    trigger: 'onChange',
                                    message: field.placeholder,
                                }]
                            }
                            break
                        case 'table':
                            formData[field.field_key] = []
                            if (field._child && field._child.length) {
                                const fieldData = this.deepCreateFormData(field._child, field.filling_method === 'horizontal')
                                field._child = fieldData.fieldList
                                field.formRules = fieldData.formDataRules
                                formData[field.field_key].push(fieldData.formData)
                            }
                            break
                        case 'control_group':
                            formData[field.field_key] = []
                            if (field._child && field._child.length) {
                                const fieldData = this.deepCreateFormData(field._child, field)
                                field._child = fieldData.fieldList
                                field.formRules = fieldData.formDataRules
                                formData[field.field_key].push(fieldData.formData)
                            }
                            break
                        case 'goods':
                            formData[field.field_key] = []
                            formDataRules[field.field_key] = [{
                                required: true,
                                trigger: 'onChange',
                                message: '请添加产品',
                                validator: (value) => {
                                    return formData[field.field_key].length > 0
                                }
                            }]
                            break
                        case 'purchase_details':
                            formData[field.field_key] = [
                                {
                                    product_name: "",
                                    sku_id: 0,
                                    sku_key: "",
                                    stock_id: '',
                                    stock_name: '',
                                    num: null,
                                    price: null,
                                    total_price: null,
                                    note: ""
                                }
                            ]
                            if (field._child && field._child.length) {
                                const fieldData = this.deepCreateFormData(field._child, field.filling_method === 'horizontal')
                                field._child = fieldData.fieldList
                                field.formRules = fieldData.formDataRules
                                formData[field.field_key].push(fieldData.formData)
                            }
                            break
                        case 'image':
                            formData[field.field_key] = [
                                /*    {
                                            'file_path': 'https://download.hecoos.com/enlightv/2024-46/fdc98e9591bb7f43f71177680e42eb2c.svg',
                                            'file_name': '对比.svg',
                                            'file_type': 'image/svg+xml',
                                            'file_size': '2.99KB'
                                        },
                                        {
                                            'file_path': 'https://download.hecoos.com/enlightv/2024-46/a2ace1b9d6679c800ead0cc29a0b34e8.svg',
                                            'file_name': '疑问.svg',
                                            'file_type': 'image/svg+xml',
                                            'file_size': '5.14KB'
                                        },
                                        {
                                            'file_path': 'https://download.hecoos.com/enlightv/2024-46/47bfbb877fd1022830bb10ee67d2236a.jfif',
                                            'file_name': '4172e0181t882763b6e5a2dc4b0648a7.jfif',
                                            'file_type': 'image/jpeg',
                                            'file_size': '159.19KB'
                                        },
                                        {
                                            'file_path': 'https://download.hecoos.com/enlightv/2024-46/51b741e71dd7668bd53cf78e4e954393.jpg',
                                            'file_name': '12619.jpg',
                                            'file_type': 'image/jpeg',
                                            'file_size': '244.87KB'
                                        },
                                        {
                                            'file_path': 'https://download.hecoos.com/enlightv/2024-46/d006ad2ef5e4a8f0b2181729b4ea193d.jpeg',
                                            'file_name': '3302e.jpeg',
                                            'file_type': 'image/jpeg',
                                            'file_size': '124.49KB'
                                        },
                                        {
                                            'file_path': 'https://download.hecoos.com/enlightv/2024-46/7578600553c8771560c28b0deef24195.jpg',
                                            'file_name': '14696.jpg',
                                            'file_type': 'image/jpeg',
                                            'file_size': '137.36KB'
                                        },
                                        {
                                            'file_path': 'https://download.hecoos.com/enlightv/2024-46/d414c1fa9c4fa588164582a8c84dbce6.jfif',
                                            'file_name': '3c5465418md32f589a02e913fb9f8632.jfif',
                                            'file_type': 'image/jpeg',
                                            'file_size': '175.63KB'
                                        }*/
                            ]
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [{
                                    required: true,
                                    trigger: 'onChange',
                                    message: field.placeholder,
                                    validator: (value) => {
                                        return formData[field.field_key].length > 0
                                    }
                                }]
                            }
                            break
                        case 'file':
                            formData[field.field_key] = [
                                /*  {
                                          'file_path': 'https://download.hecoos.com/enlightv/2024-46/fdc98e9591bb7f43f71177680e42eb2c.svg',
                                          'file_name': '对比.svg',
                                          'file_type': 'image/svg+xml',
                                          'file_size': '2.99KB'
                                      },
                                      {
                                          'file_path': 'https://download.hecoos.com/enlightv/2024-46/a2ace1b9d6679c800ead0cc29a0b34e8.svg',
                                          'file_name': '疑问.svg',
                                          'file_type': 'image/svg+xml',
                                          'file_size': '5.14KB'
                                      },
                                      {
                                          'file_path': 'https://download.hecoos.com/enlightv/2024-46/47bfbb877fd1022830bb10ee67d2236a.jfif',
                                          'file_name': '4172e0181t882763b6e5a2dc4b0648a7.jfif',
                                          'file_type': 'image/jpeg',
                                          'file_size': '159.19KB'
                                      },
                                      {
                                          'file_path': 'https://download.hecoos.com/enlightv/2024-46/51b741e71dd7668bd53cf78e4e954393.jpg',
                                          'file_name': '12619.jpg',
                                          'file_type': 'image/jpeg',
                                          'file_size': '244.87KB'
                                      },
                                      {
                                          'file_path': 'https://download.hecoos.com/enlightv/2024-46/d006ad2ef5e4a8f0b2181729b4ea193d.jpeg',
                                          'file_name': '3302e.jpeg',
                                          'file_type': 'image/jpeg',
                                          'file_size': '124.49KB'
                                      },
                                      {
                                          'file_path': 'https://download.hecoos.com/enlightv/2024-46/7578600553c8771560c28b0deef24195.jpg',
                                          'file_name': '14696.jpg',
                                          'file_type': 'image/jpeg',
                                          'file_size': '137.36KB'
                                      },
                                      {
                                          'file_path': 'https://download.hecoos.com/enlightv/2024-46/d414c1fa9c4fa588164582a8c84dbce6.jfif',
                                          'file_name': '3c5465418md32f589a02e913fb9f8632.jfif',
                                          'file_type': 'image/jpeg',
                                          'file_size': '175.63KB'
                                      }*/
                            ]
                            if (field.file_type) {
                                field.file_type = field.file_type.split('、').map(type => type.toLowerCase())
                            }
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [{
                                    required: true,
                                    trigger: 'onChange',
                                    message: field.placeholder,
                                    validator: (value) => {
                                        return formData[field.field_key].length > 0
                                    }
                                }]
                            }
                            break
                        case 'checkbox_approval':
                            formData[field.field_key] = {
                                value: [],
                                text: []
                            }
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [{
                                    required: true,
                                    trigger: 'onChange',
                                    message: '请选择' + field.field_name,
                                    validator: (value) => {
                                        return value.length > 0
                                    }
                                }]
                            }
                            break
                        case 'checkbox_check_record':
                            formData[field.field_key] = {
                                value: [],
                                text: []
                            }
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [{
                                    required: true,
                                    trigger: 'onChange',
                                    message: '请选择打卡记录',
                                    validator: (value) => {
                                        return value.length > 0
                                    }
                                }]
                            }
                            break
                        case 'id_card':
                            formData[field.field_key] = {
                                value: '',
                            }
                            const idCardFormRules = {}
                            if (field.upload_recognition) {
                                formData[field.field_key].name = ''
                                formData[field.field_key].birthday = ''
                                formData[field.field_key].address = ''
                                idCardFormRules.value = {
                                    required: field.is_required === 1,
                                    trigger: 'onBlur',
                                    validator: (value) => {
                                    }
                                }
                                if (field.upload_recognition) {
                                    if (field.name_is_show && field.name_is_required) {
                                        idCardFormRules.name = {
                                            required: true,
                                            trigger: 'onBlur',
                                            message: '请输入姓名'
                                        }
                                    }
                                    if (field.birthday_is_show && field.birthday_is_required) {
                                        idCardFormRules.birthday = {
                                            required: true,
                                            trigger: 'onChange',
                                            message: '请选择出生日期'
                                        }
                                    }
                                    if (field.address_is_show && field.address_is_required) {
                                        idCardFormRules.address = {
                                            required: true,
                                            trigger: 'onBlur',
                                            message: '请输入家庭住址'
                                        }
                                    }
                                }
                            }
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [{
                                    required: field.is_required === 1,
                                    trigger: 'onBlur',
                                    message: field.placeholder,
                                }]
                            }
                            this.$set(field, 'idCardFormRules', idCardFormRules)
                            break
                        case 'rate':
                            formData[field.field_key] = {
                                value: 0,
                                text: '0分'
                            }
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [{
                                    required: true,
                                    trigger: 'onChange',
                                    message: field.placeholder,
                                }]
                            }
                            break
                        case 'paying_teller':
                            formData[field.field_key] = {
                                value: '',
                                text: ''
                            }
                            formDataRules[field.field_key] = [{
                                required: field.is_required === 1,
                                trigger: 'onBlur',
                                validator: (value) => {
                                }
                            }]
                            break
                        case 'invoice':
                            formData[field.field_key] = [
                                /*   {
                                           'op': 'invoice',
                                           'invoice_type': '数电普通发票',
                                           'invoice_code': '',
                                           'invoice_number': '24112000000033990251',
                                           'printed_invoice_code': '',
                                           'printed_invoice_number': '',
                                           'check_code': '',
                                           'invoice_date': '2024年05月06日',
                                           'title': '电子发票(普通发票)',
                                           'form_type': '',
                                           'purchaser_name': '北京澜景科技有限公司',
                                           'purchaser_tax_number': '91110108351312831B',
                                           'purchaser_contact_info': '',
                                           'purchaser_bank_account_info': '',
                                           'total_amount': '36.10',
                                           'file_type': 'pdf',
                                           'file_path': 'https://download.hecoos.com/enlightv/2024-48/7eac20103a9920a9f529924b847a08c4.pdf'
                                       },
                                       {
                                           'op': 'invoice',
                                           'invoice_type': '电子普通发票',
                                           'invoice_code': '011002301711',
                                           'invoice_number': '29276154',
                                           'printed_invoice_code': '',
                                           'printed_invoice_number': '',
                                           'check_code': '85453022992728593554',
                                           'invoice_date': '2024年04月30日',
                                           'title': '北京增值税电子普通发票',
                                           'form_type': '',
                                           'purchaser_name': '北京澜景科技有限公司',
                                           'purchaser_tax_number': '91110108351312831B',
                                           'purchaser_contact_info': '',
                                           'purchaser_bank_account_info': '',
                                           'total_amount': '26.63',
                                           'file_type': 'pdf',
                                           'file_path': 'https://download.hecoos.com/enlightv/2024-48/9c0ba0d1bc9b791f461e9a88f765190b.pdf'
                                       },
                                       {
                                           'op': 'invoice',
                                           'invoice_type': '电子普通发票',
                                           'invoice_code': '011002301711',
                                           'invoice_number': '29276154',
                                           'printed_invoice_code': '',
                                           'printed_invoice_number': '',
                                           'check_code': '85453022992728593554',
                                           'invoice_date': '2024年04月30日',
                                           'title': '北京增值税电子普通发票',
                                           'form_type': '',
                                           'purchaser_name': '北京澜景科技有限公司',
                                           'purchaser_tax_number': '91110108351312831B',
                                           'purchaser_contact_info': '',
                                           'purchaser_bank_account_info': '',
                                           'total_amount': '26.63',
                                           'file_type': 'image',
                                           'file_path': 'https://download.hecoos.com/enlightv/2024-46/d006ad2ef5e4a8f0b2181729b4ea193d.jpeg'
                                       },*/
                            ]
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [{
                                    required: true,
                                    trigger: 'onChange',
                                    message: field.placeholder,
                                    validator: (value) => {
                                        return formData[field.field_key].length > 0
                                    }
                                }]
                            }
                            break
                        case 'customer_contact':
                            formData[field.field_key] = {
                                value: [],
                                text: []
                            }
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [{
                                    required: true,
                                    trigger: 'onChange',
                                    message: field.placeholder,
                                    validator: (value) => {
                                        return formData[field.field_key].value.length > 0
                                    }
                                }]
                            }
                            break
                        case 'location':
                            formData[field.field_key] = {
                                value: '',
                            }
                            this.getCurrentPosition()
                            this.$nextTick(() => {
                                formData[field.field_key].value = this.locationName
                            })
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [
                                    {
                                        required: true,
                                        trigger: 'onChange',
                                        message: field.placeholder,
                                    },
                                ]
                            }
                            break
                    }
                    fieldList.push(field)
                }
            })
            fieldList = fieldList.filter(field => field.field_type !== 'serial_number')
            if (this.is_filter_field) {
                fieldList = fieldList.filter(field => !field.hasOwnProperty('is_form_show') || field.is_form_show)
            }
            return {
                fieldList,
                formData,
                formDataRules,
            }
        },

        //递归显示详情的值
        deepSiteDetailValue(field_list, formData, details) {
            field_list.forEach(field => {
                if (details.hasOwnProperty(field.field_key)) {
                    if (field.field_type === 'table') {
                        formData[field.field_key].forEach(row => {
                            this.deepSiteDetailValue(field._child, row, row)
                        })
                    } else {
                        this.$set(formData, field.field_key, details[field.field_key])
                        if (field.field_type === 'department') {
                            this.$set(formData[field.field_key], 'titles', details[field.field_key].text.map(item => item.department_name))
                        } else if (field.field_type === 'money') {
                            if (field.field_key === 'purchase_price') {
                                if (Number(formData[field.field_key].value) > 0) {
                                    this.order_procurement_show = true
                                }
                            }
                        } else if (field.field_type === 'order_amount_compute_mode') {
                            if (formData[field.field_key].value !== '') {
                                field.initial_display = false
                            }
                        } else if (field.field_type === 'goods') {
                            formData[field.field_key].forEach(goods => {
                                if (this.is_release === 0) {
                                    if (goods.goods_type === 'bundle') {
                                        goods.sale_guide_price = goods._child.reduce((total, child) => {
                                            return total + child.sale_guide_price * child.num;
                                        }, 0);
                                        goods.lease_guide_price = goods._child.reduce((total, child) => {
                                            return total + child.lease_guide_price * child.num;
                                        }, 0);
                                        goods.is_virtual = goods._child.some(child => child.can_in_out_stock === 1) ? 1 : 0
                                    } else {
                                        goods.is_virtual = goods.can_in_out_stock
                                    }
                                }
                                if (goods.goods_status === 0 || goods.goods_deleted_at) {
                                    goods.max_num = goods.num
                                }
                            })
                        } else if (field.field_type === 'radio_project_stage') {
                            this.old_project_group_id = details.project_group_id
                            this.$set(this.customForm, 'project_group_id', details.project_group_id)
                        }
                    }
                }
            })
            // 请假控件规则详情
            if (details.rest_rule_json) {
                this.rest_rule_json = details.rest_rule_json
            }
            // 加班控件规则详情
            if (details.overtime_rule_json) {
                this.overtime_rule_json = details.overtime_rule_json
            }
        },

        //获取用户列表
        getUserList(keyword) {
            GetUserList({keyword}).then(res => {
                if (res.code === 200) {
                    this.userList = res.data || []
                    if (this.selectContacts.length && this.currentFieldData.field_type === 'contact' && this.currentFieldData.select_range && this.currentFieldData.select_range.includes('1')) {
                        this.userList.forEach(item => {
                            if (this.selectContacts.findIndex(sel => sel.id === item.uid) > -1) {
                                this.$set(item, 'checked', true)
                            }
                        })
                    }
                } else {
                    this.$toast(res.message)
                }
            })
        },

        //获取部门列表
        getDepartmentList() {
            return new Promise((resolve, reject) => {
                GetDepartmentList().then(res => {
                    if (res.code === 200) {
                        this.departmentList = res.data || []
                        resolve(this.departmentList)
                    } else {
                        this.$toast(res.message)
                        reject(res.message)
                    }
                })
            })
        },

        //判断所有以当前字段作为条件的字段是否符合条件
        checkMeetTheCondition(item, formData, fieldList) {
            this.$emit('send-form-data', this.customForm)
            fieldList.forEach(field => {
                if (field.rules && field.rules.length > 0) {
                    if (field.rules.some(ruleSet => {
                        return ruleSet.some(rule => rule.field_key === item.field_key)
                    })) {
                        if (this.testConditions(field.rules, fieldList, formData)) {
                            this.$set(field, 'initial_display', false)
                            this.checkMeetTheCondition(field, formData, fieldList)
                        } else {
                            this.$set(field, 'initial_display', true)
                            this.checkMeetTheCondition(field, formData, fieldList)
                        }
                    }
                }
            })
        },

        //判断条件
        testConditions(conditions, fieldList, formData) {
            return conditions.some(condition => {
                return condition.every(field => {
                    let field_data = fieldList.find(item => item.field_key === field.field_key)
                    if (!field_data) return false
                    if (field_data.hasOwnProperty('initial_display') && field_data.initial_display) return false
                    const {
                        field_type,
                        field_key,
                        date_type,
                    } = field_data
                    let field_value = ''
                    if (field_type === 'date_range') {

                    } else if (field_type === 'date') {
                        if (field.field_value.value === '1') {
                            field_value = getNowDate(date_type)
                        } else {
                            field_value = field.field_value.date
                        }
                    } else {
                        field_value = formData[field_key].value ? formData[field_key].value : undefined
                    }
                    if (!field_value) return false
                    switch (field.operator) {
                        case 'gt':
                            if (field_type === 'date') {
                                if (date_type === 'time') {
                                    return formData[field_key].value > field_value
                                } else {
                                    return Date.parse(formData[field_key].value) > Date.parse(field_value)
                                }
                            } else {
                                return field_value > field.field_value
                            }
                        case 'egt':
                            return field_value >= field.field_value
                        case 'eq':
                            if (field_type === 'date') {
                                if (date_type === 'time') {
                                    return formData[field_key].value === field_value
                                } else {
                                    return Date.parse(formData[field_key].value) === Date.parse(field_value)
                                }
                            } else if (field_type === 'department') {
                                var set1 = new Set(field_value)
                                var set2 = new Set(field.field_value.dids)
                                return set1.size === set2.size && [...set1].every(value => set2.has(value))
                            } else if (field_type === 'computed_money') {
                                return field_value === field.field_value
                            } else if (field_type === 'compute_mode') {
                                return field_value === field.field_value
                            } else {
                                var set1 = new Set(field_value)
                                var set2 = new Set(field.field_value)
                                return set1.size === set2.size && [...set1].every(value => set2.has(value))
                                return JSON.stringify(field_value) === JSON.stringify(field.field_value)
                            }
                        case 'elt':
                            return field_value <= field.field_value
                        case 'lt':
                            if (field_type === 'date') {
                                if (date_type === 'time') {
                                    return formData[field_key].value < field_value
                                } else {
                                    return Date.parse(formData[field_key].value) < Date.parse(field_value)
                                }
                            } else {
                                return field_value < field.field_value
                            }
                        case 'in':
                            return field_value == field.field_value
                        case 'not_in':
                            return field_value != field.field_value
                        case 'between':
                            if (field_type === 'department') {
                                return field_value.some(item => field.field_value.dids.includes(item))
                            } else {
                                return field_value.some(item => field.field_value.includes(item))
                            }
                        case 'not_between':
                            if (field_type === 'department') {
                                return field_value.every(item => !field.field_value.dids.includes(item))
                            } else {
                                return field_value.every(item => !field.field_value.includes(item))
                            }
                        default:
                            return false
                    }
                })
            })
        },

        //数字组件失焦事件
        handleNumberInputBlur(field, formData, fieldList) {
            let value = formData[field.field_key].value
            //只能输入整数
            if (field.other_site.includes('1')) {
                value = Math.floor(value)
            }
            //只能输入正数
            if (field.other_site.includes('2')) {
                value = Math.abs(value)
            }
            formData[field.field_key].value = Number(value)
            formData[field.field_key].text = Number(value)
            this.formulaComputedFun(field, formData, fieldList)
            this.checkMeetTheCondition(field, formData, fieldList)
        },

        //金额组件失焦事件
        handlePriceInputBlur(field, formData, fieldList) {
            let value = formData[field.field_key].text.replace(/[^\d.\-]/g, '')
            if (field.min && value < field.min) {
                value = field.min.toString()
            }
            if (field.max && value > field.max) {
                value = field.max.toString()
            }
            //传给后端的value是数字，不需要格式化
            formData[field.field_key].value = Number(this.formatAmount(value, field, false))
            //前端展示的text是字符串，需要格式化
            formData[field.field_key].text = this.formatAmount(value, field, true)
            if (field.format.includes('1') && formData[field.field_key].currency === 'CNY') {
                formData[field.field_key].chinese_text = numberPriceToChinese(value, true)
            }
            this.formulaComputedFun(field, formData, fieldList)
            this.checkMeetTheCondition(field, formData, fieldList)
        },

        //输入的金额格式限制
        formatAmount(val, item, format) {
            if (val) {
                // 判断是否为负数
                const isNegative = val.startsWith('-')
                let amount = Math.abs(parseFloat(val))
                let result
                // 格式化为千位分隔符形式
                let some = item.format.includes('3') && item.some ? item.some : 0
                const parts = amount.toFixed(some).split('.')
                const integerPart = item.format.includes('2') && format ? parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,') : parts[0]
                const decimalPart = some > 0 ? parts[1] ? parts[1] : '0'.repeat(some) : ''
                // 拼接成完整的金额格式
                result = some > 0 ? `${integerPart}.${decimalPart}` : integerPart
                if (isNegative) {
                    result = '-' + result
                }
                return result
            } else {
                return ''
            }
        },

        //将数字金额转换为大写中文金额
        numberPriceToChinese(money, has_unit) {
            //汉字的数字
            const cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
            //基本单位
            const cnIntRadice = ['', '拾', '佰', '仟']
            //对应整数部分扩展单位
            const cnIntUnits = ['', '万', '亿', '兆']
            //对应小数部分单位
            const cnDecUnits = ['角', '分', '毫', '厘']
            //整数金额时后面跟的字符
            const cnInteger = '整'
            //整型完以后的单位
            const cnIntLast = has_unit ? '元' : ''
            //最大处理的数字
            const maxNum = 999999999999999.9999
            //金额整数部分
            let integerNum
            //金额小数部分
            let decimalNum
            //输出的中文金额字符串
            let chineseStr = ''
            //分离金额后用的数组，预定义
            let parts
            if (money === '') {
                return ''
            }
            money = parseFloat(money)
            if (money >= maxNum) {
                //超出最大处理数字
                return ''
            }
            if (money < 0) {
                chineseStr += '负'
                money = Math.abs(money)
            }
            if (money === 0) {
                chineseStr = cnNums[0] + cnIntLast + cnInteger
                return chineseStr
            }
            //转换为字符串
            money = money.toString()
            if (money.indexOf('.') === -1) {
                integerNum = money
                decimalNum = ''
            } else {
                parts = money.split('.')
                integerNum = parts[0]
                decimalNum = parts[1].substr(0, 4)
            }
            //获取整型部分转换
            if (parseInt(integerNum, 10) > 0) {
                let zeroCount = 0
                const IntLen = integerNum.length
                for (let i = 0; i < IntLen; i++) {
                    let n = integerNum.substr(i, 1)
                    let p = IntLen - i - 1
                    let q = p / 4
                    let m = p % 4
                    if (n === '0') {
                        zeroCount++
                    } else {
                        if (zeroCount > 0) {
                            chineseStr += cnNums[0]
                        }
                        //归零
                        zeroCount = 0
                        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
                    }
                    if (m === 0 && zeroCount < 4) {
                        chineseStr += cnIntUnits[q]
                    }
                }
                chineseStr += cnIntLast
            }
            //小数部分
            if (decimalNum !== '') {
                var decLen = decimalNum.length
                for (let i = 0; i < decLen; i++) {
                    let n = decimalNum.substr(i, 1)
                    if (n !== '0') {
                        chineseStr += cnNums[Number(n)] + cnDecUnits[i]
                    }
                }
            }
            if (chineseStr === '') {
                chineseStr += cnNums[0] + cnIntLast + cnInteger
            } else if (decimalNum === '') {
                chineseStr += cnInteger
            }
            return chineseStr
        },

        //计算公式计算结果
        formulaComputedFun(item, formData, fieldList) {
            this.compute_mode_field_list.forEach(field => {
                //接口需要的数据
                const formulaValue = {}
                //拿出公式列表所有type为component的组件
                const components = field.formula_list.filter(formula => formula.type === 'component')
                if (field.p_field_key && field.p_field_type !== 'form_module') {
                    //明细内计算
                    components.forEach(component => {
                        //判断组件的字段类型，如果是money，取出字段值的price
                        if (component.field_type === 'date_range') {
                            formulaValue[component.field_key] = formData[component.field_key] && formData[component.field_key].duration ? parseFloat(formData[component.field_key].duration) : 0
                        } else {
                            formulaValue[component.field_key] = parseFloat(formData[component.field_key].value) || 0
                        }
                    })
                } else {
                    //明细外计算
                    components.forEach(component => {
                        if (component.field_type === 'date_range') {
                            if (component.p_field_key) {
                                //如果公式字段是明细内的。则需要计算总和
                                formulaValue[component.field_key] = this.customForm[component.p_field_key].reduce((sum, obj) => {
                                    return sum + parseFloat(obj[component.field_key].duration)
                                }, 0)
                            } else {
                                formulaValue[component.field_key] = formData[component.field_key] && formData[component.field_key].duration ? parseFloat(formData[component.field_key].duration) : 0
                            }
                        } else {
                            if (component.p_field_key) {
                                //如果公式字段是明细内的。则需要计算总和
                                formulaValue[component.field_key] = this.customForm[component.p_field_key].reduce((sum, obj) => {
                                    return sum + parseFloat(obj[component.field_key].value)
                                }, 0)
                            } else {
                                formulaValue[component.field_key] = parseFloat(formData[component.field_key].value) || 0
                            }
                        }
                    })
                }
                if (Object.values(formulaValue).length > 0) {
                    const res = calculate(field.field_formula, formulaValue)
                    const value = this.formatAmount(res.toString(), field, false)
                    this.$set(formData[field.field_key], 'value', value)
                    this.$set(formData[field.field_key], 'text', this.formatAmount(res.toString(), field, true))
                    this.checkMeetTheCondition(field, formData, fieldList)
                    if (field.format.includes('1')) {
                        this.$set(formData[field.field_key], 'chinese_text', numberPriceToChinese(value, false))
                    }
                }
            })
        },

        //电话类型切换事件
        handleTelPhoneTypeChange(val, formData, field_key) {
            if (val === '1') {
                formData[field_key].prefix = '+86'
            } else {
                formData[field_key].prefix = ''
            }
            formData[field_key].value = ''
            formData[field_key].phone_type = val
        },

        //点击单选组件弹出弹窗
        handleClickRadioFieldLink(field, formData, fieldList) {
            if (field.field_disabled) return false
            this.currentFieldData = field
            this.currentFieldFormData = formData
            this.nowFieldsList = fieldList
            this.showRadioPicker = true
        },

        //单选选择器确定事件
        handleClickRadioOption(data) {
            this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'value', data.value)
            this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'text', data.label)
            this.showRadioPicker = false
            this.checkMeetTheCondition(this.currentFieldData, this.currentFieldFormData, this.nowFieldsList)
            this.getBusinessGroup()
        },

        //商机阶段弹出弹窗
        handleClickRadioProjectStageFieldLink(field, formData) {
            if (field.field_disabled) return false
            this.currentFieldData = field
            this.currentFieldFormData = formData
            this.showRadioProjectStagePicker = true
        },

        //单选选择器确定事件
        handleClickRadioProjectStageOption(data) {
            this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'value', data.project_stage_id)
            this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'text', data.name)
            this.showRadioProjectStagePicker = false
            const tasks = this.currentFieldData.options.filter(item => item.sort < data.sort).flatMap(item => item.tasks)
            const phase_task_fields = this.formInfoList.filter(item => item.field_key === 'phase_task_field' || item.p_field_key === 'phase_task_field')
            this.formInfoList = this.formInfoList.filter(item => item.field_key !== 'phase_task_field' && item.p_field_key !== 'phase_task_field')
            if (phase_task_fields.length > 0) {
                phase_task_fields.forEach(field => {
                    if (this.customForm.hasOwnProperty(field.field_key)) {
                        delete this.customForm[field.field_key]
                    }
                    if (this.customFormRules.hasOwnProperty(field.field_key)) {
                        delete this.customFormRules[field.field_key]
                    }
                })
            }
            if (tasks.length > 0) {
                let field_list = [{
                    field_id: 1234567,
                    company_id: 0,
                    field_form: "project",
                    field_key: "phase_task_field",
                    field_name: "阶段任务字段",
                    field_type: "form_module",
                    col_span: '24'
                }]
                tasks.forEach(item => {
                    item.p_field_key = 'phase_task_field'
                })
                field_list = [...field_list, ...tasks]
                const {fieldList, formData, formDataRules} = this.deepCreateFormData(field_list)
                if (Object.keys(this.form_detail).length > 0) {
                    for (let formDataKey in formData) {
                        if (this.form_detail.hasOwnProperty(formDataKey)) {
                            this.$set(formData, formDataKey, this.form_detail[formDataKey])
                        }
                    }
                }
                this.formInfoList = [...this.formInfoList, ...fieldList]
                this.customForm = {...this.customForm, ...formData}
                this.customFormRules = {...this.customFormRules, ...formDataRules}
            }
        },

        //商机表单中根据商机内容获取属商机组
        getBusinessGroup() {
            if (this.field_form === 'projects' || this.relate_field_form === 'projects') {
                getProjectGroup({
                    form_info: this.customForm
                }).then(res => {
                    if (res.code === 200) {
                        const {project_group_id, project_stages} = res.data
                        const project_stage = this.formInfoList.find(item => item.field_key === 'project_stage')
                        this.$set(project_stage, 'options', project_stages)
                        if (project_stages.length > 0 && this.customForm.project_group_id !== project_group_id) {
                            this.$set(this.customForm, 'project_group_id', project_group_id)
                            this.$set(this.customForm[project_stage.field_key], 'value', project_stages[0].project_stage_id)
                            this.$set(this.customForm[project_stage.field_key], 'text', project_stages[0].name)
                            const phase_task_fields = this.formInfoList.filter(item => item.field_key === 'phase_task_field' || item.p_field_key === 'phase_task_field')
                            this.formInfoList = this.formInfoList.filter(item => item.field_key !== 'phase_task_field' && item.p_field_key !== 'phase_task_field')
                            if (phase_task_fields.length > 0) {
                                phase_task_fields.forEach(field => {
                                    if (this.customForm.hasOwnProperty(field.field_key)) {
                                        delete this.customForm[field.field_key]
                                    }
                                    if (this.customFormRules.hasOwnProperty(field.field_key)) {
                                        delete this.customFormRules[field.field_key]
                                    }
                                })
                            }
                        }
                    }
                })
            }
        },

        //点击多选组件弹出弹窗
        handleClickCheckboxFieldLink(field, formData, fieldList) {
            if (field.field_disabled) return false
            this.currentFieldData = field
            this.currentFieldFormData = formData
            this.nowFieldsList = fieldList
            if (field.field_type === 'checkbox') {
                this.showCheckboxPicker = true
                this.checkboxOptionsList = field.options.map(item => {
                    return {
                        label: item.label,
                        value: item.value,
                        checked: formData[field.field_key].value.includes(item.value)
                    }
                })
                this.checkboxCheckedList = this.checkboxOptionsList.filter(item => item.checked)
            } else {
                if (!field.hasOwnProperty('options') || field.options.length === 0) {
                    this.getPersonTagAllList(field)
                } else {
                    this.checkboxOptionsList = field.options.map(item => {
                        return {
                            name: item.name,
                            id: item.id,
                            checked: formData[field.field_key].value.includes(item.value)
                        }
                    })
                }
                this.showCheckboxTagPicker = true
            }
        },

        //获取人员标签列表
        getPersonTagAllList(field, keyword) {
            PersonTagAllList({
                keyword
            }).then(res => {
                if (res.code === 200) {
                    this.$set(field, 'options', res.data)
                }
            })
        },

        //点击选择多选选项
        handleClickCheckboxItem(item) {
            if (item.hasOwnProperty('checked')) {
                item.checked = !item.checked
            } else {
                this.$set(item, 'checked', true)
            }
        },

        //多选选项复选框切换事件
        handleCheckboxItemChange(item) {
            if (item.checked) {
                if (this.currentFieldData.field_type === 'checkbox') {
                    if (this.checkboxCheckedList.findIndex(obj => obj.value === item.value) < 0) {
                        this.checkboxCheckedList.push(item)
                    }
                } else {
                    if (this.checkboxCheckedList.findIndex(obj => obj.id === item.id) < 0) {
                        this.checkboxCheckedList.push(item)
                    }
                }
            } else {
                if (this.currentFieldData.field_type === 'checkbox') {
                    this.checkboxCheckedList.splice(this.checkboxCheckedList.findIndex(obj => obj.value === item.value), 1)
                } else {
                    this.checkboxCheckedList.splice(this.checkboxCheckedList.findIndex(obj => obj.id === item.id), 1)
                }
            }
        },

        //多选组件弹出弹窗关闭事件
        handleClickCheckboxPickerClose() {
            this.showCheckboxPicker = false
            this.showCheckboxTagPicker = false
            this.checkboxOptionsList = []
            this.checkboxCheckedList = []
        },

        //多选组件弹出弹窗确定事件
        handleClickCheckboxPickerConfirm() {
            if (this.checkboxCheckedList.length === 0) return this.$toast(this.currentFieldData.placeholder)
            if (this.currentFieldData.field_type === 'checkbox') {
                this.currentFieldFormData[this.currentFieldData.field_key].text = this.checkboxCheckedList.map(item => item.label)
                this.currentFieldFormData[this.currentFieldData.field_key].value = this.checkboxCheckedList.map(item => item.value)
                this.checkMeetTheCondition(this.currentFieldData, this.currentFieldFormData, this.nowFieldsList)
                this.getBusinessGroup()
            } else {
                this.currentFieldFormData[this.currentFieldData.field_key].text = this.checkboxCheckedList.map(item => item.name)
                this.currentFieldFormData[this.currentFieldData.field_key].value = this.checkboxCheckedList.map(item => item.id)
            }
            this.handleClickCheckboxPickerClose()
        },

        //点击日期组件
        handleClickDateFieldLink(field, formData, fieldList) {
            if (this.is_preview_mode) return this.$toast('当前控件不允许在预览中操作')
            if (field.field_disabled) return false
            this.currentFieldData = field
            this.currentFieldFormData = formData
            this.nowFieldsList = fieldList
            if (field.field_type === 'date') {
                if (field.default) return false
                const currentDate = new Date()
                if (field.time_range === 'any') {
                    if (field.date_type === 'time') {
                        this.timeCalendarScope = {
                            min_hour: 0,
                            max_hour: 23,
                            min_minute: 0,
                            max_minute: 59,
                        }
                    } else {
                        this.dateCalendarMin = new Date('1970-01-01')
                        this.dateCalendarMax = new Date('2070-01-01')
                    }
                } else if (field.time_range === 'before') {
                    if (field.date_type === 'time') {
                        this.timeCalendarScope = {
                            min_hour: 0,
                            max_hour: currentDate.getHours(),
                            min_minute: 0,
                            max_minute: currentDate.getMinutes(),
                        }
                    } else {
                        this.dateCalendarMin = new Date('1970-01-01')
                        this.dateCalendarMax = new Date()
                    }
                } else if (field.time_range === 'after') {
                    if (field.date_type === 'time') {
                        this.timeCalendarScope = {
                            min_hour: currentDate.getHours(),
                            max_hour: 23,
                            min_minute: currentDate.getMinutes(),
                            max_minute: 59,
                        }
                    } else {
                        this.dateCalendarMin = new Date()
                        this.dateCalendarMax = new Date('2070-01-01')
                    }
                }
                if (field.date_type === 'date') {
                    this.showDateCalendar = true
                } else {
                    this.showDatePopupShow = true
                }
            } else if (field.field_type === 'id_card') {
                this.dateCalendarMin = new Date('1970-01-01')
                this.dateCalendarMax = new Date('2070-01-01')
                this.showDateCalendar = true
            }
        },

        //点击日期选择器确定事件
        handleDateCalenderConfirm(date) {
            if (this.currentFieldData.field_type === 'date') {
                if (this.currentFieldData.date_type === 'time') {
                    this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'value', date)
                    this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'text', date)
                } else {
                    this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'value', formatDate(date, this.currentFieldData.date_type))
                    this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'text', formatDate(date, this.currentFieldData.date_type))
                }
                this.checkMeetTheCondition(this.currentFieldData, this.currentFieldFormData, this.nowFieldsList)
                this.getBusinessGroup()
            } else if (this.currentFieldData.field_type === 'id_card') {
                this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'birthday', formatDate(date, 'date'))
            }
            this.showDatePopupShow = false
            this.showDateCalendar = false
        },

        //点击日期区间组件
        handleClickDateRangeFieldLink(field, formData) {
            if (this.is_preview_mode) return this.$toast('当前控件不允许在预览中操作')
            if (field.field_disabled) return false
            this.dateCalendarMin = new Date('1970-01-01')
            this.dateCalendarMax = new Date('2070-01-01')
            this.currentFieldData = field
            this.currentFieldFormData = formData
            this.showDateRangePicker = true
        },

        //点击日期区间选择器确定事件
        async handleClickRangeCalendarConfirm(range) {
            const [start, end] = range
            let value = [formatDate(start, 'date'), formatDate(end, 'date')]
            if (this.relateProjectVisible) {
                this.relate_created_at = value
                this.relatePagination.pageNum = 1
                this.relateProjectList = []
                this.getRelateProjectList()
            } else if (this.importQuotationVisible) {
                this.relate_created_at = value
                this.relatePagination.pageNum = 1
                this.quotationData = []
                this.getQuotationList()
            } else {
                this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'value', value)
                this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'text', value.join('～').replace(/-/g, '/'))
                if (this.currentFieldData.auto_computed) {
                    const duration = await this.calculateDuration(this.currentFieldFormData[this.currentFieldData.field_key].value, this.currentFieldData)
                    this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'duration', duration)
                }
            }
            this.showDateRangePicker = false
        },

        //计算日期区间的时长
        async calculateDuration(date_range, item) {
            let str
            if (date_range && date_range.length > 1) {
                const timeDiff = Math.abs(new Date(date_range[1]) - new Date(date_range[0]))
                if (item.compute_mode === '1') {
                    //自然时长
                    if (item.date_type === 'daterange') {
                        str = Math.ceil(timeDiff / (1000 * 60 * 60 * 24)) + 1
                    } else if (item.date_type === 'datetimerange') {
                        const start = new Date(date_range[0]).getTime()
                        const end = new Date(date_range[1]).getTime()
                        const diff = end - start
                        const days = diff / (1000 * 60 * 60 * 24)
                        if (days % 1 === 0) {
                            str = days.toFixed(0)
                        } else {
                            str = days.toFixed(2)
                        }
                    } else {
                        const [startTime, endTime] = date_range
                        // 获取当前日期
                        const currentDate = new Date()
                        // 获取开始时间的小时和分钟
                        const [startHour, startMinute] = startTime.split(':')
                        // 设置开始时间的小时和分钟
                        currentDate.setHours(startHour, startMinute, 0, 0)
                        const startTimeStamp = currentDate.getTime()
                        // 获取结束时间的小时和分钟
                        const [endHour, endMinute] = endTime.split(':')
                        // 设置结束时间的小时和分钟
                        currentDate.setHours(endHour, endMinute, 0, 0)
                        const endTimeStamp = currentDate.getTime()
                        // 计算时间段的毫秒数差值
                        const timeDifference = endTimeStamp - startTimeStamp
                        // 将毫秒数转换为小时数
                        const hours = timeDifference / (1000 * 60 * 60)
                        // 将小时数转换为天数的小数
                        const days = hours / 24
                        if (days % 1 === 0) {
                            str = days.toFixed(0)
                        } else {
                            str = days.toFixed(2)
                        }
                    }
                } else {
                    if (item.date_type === 'datetimerange' || item.date_type === 'daterange') {
                        try {
                            const res = await getHoliday({
                                date: date_range,
                                type: [0]
                            })
                            if (res.code === 200) {
                                str = res.data.days
                            } else {
                                this.$toast(res.message)
                            }
                        } catch (error) {
                            console.log(error)
                        }
                    } else {
                        const [startTime, endTime] = date_range
                        // 获取当前日期
                        const currentDate = new Date()
                        // 获取开始时间的小时和分钟
                        const [startHour, startMinute] = startTime.split(':')
                        // 设置开始时间的小时和分钟
                        currentDate.setHours(startHour, startMinute, 0, 0)
                        const startTimeStamp = currentDate.getTime()
                        // 获取结束时间的小时和分钟
                        const [endHour, endMinute] = endTime.split(':')
                        // 设置结束时间的小时和分钟
                        currentDate.setHours(endHour, endMinute, 0, 0)
                        const endTimeStamp = currentDate.getTime()
                        // 计算时间段的毫秒数差值
                        const timeDifference = endTimeStamp - startTimeStamp
                        // 将毫秒数转换为小时数
                        const hours = timeDifference / (1000 * 60 * 60)
                        // 将小时数转换为天数的小数
                        const days = hours / 24
                        if (days % 1 === 0) {
                            str = days.toFixed(0)
                        } else {
                            str = days.toFixed(2)
                        }
                    }
                }
            }
            return str
        },

        //点击级联选择或者地址选择选择组件
        handleClickCascaderFieldLink(field, formData) {
            if (this.is_preview_mode) return this.$toast('当前控件不允许在预览中操作')
            if (field.field_disabled) return false
            this.currentFieldData = field
            this.currentFieldFormData = formData
            if (field.field_type === 'cascader') {
                this.cascaderOptions = field.options
                this.cascaderFieldNames = {
                    text: 'label',
                    value: 'value',
                    children: '_child',
                }
                this.showCascaderPicker = true
            } else if (field.field_type === 'address') {
                this.cascaderOptions = getWorldArea(field.area_accuracy)
                this.cascaderFieldNames = {
                    text: 'label',
                    value: 'value',
                    children: 'children',
                }
                this.showCascaderPicker = true
            } else if (field.field_type === 'department') {
                this.cascaderFieldNames = {
                    text: 'relate_name',
                    value: 'relate_id',
                    children: 'children',
                }
                if (this.departmentList.length === 0) {
                    this.getDepartmentList().then(res => {
                        this.cascaderOptions = res
                        this.departmentList = res
                        this.showCascaderPicker = true
                    })
                } else {
                    this.cascaderOptions = this.departmentList
                    this.showCascaderPicker = true
                }
            }
        },

        //点击级联选择或者地址选择选择组件完成
        handleClickCascaderFinish({selectedOptions}) {
            const last = selectedOptions[selectedOptions.length - 1]
            if (this.currentFieldData.field_type === 'cascader') {
                this.currentFieldFormData[this.currentFieldData.field_key].text = selectedOptions.map(option => option.label).join('/')
                this.currentFieldFormData[this.currentFieldData.field_key].value = selectedOptions.map(option => option.value)
            } else if (this.currentFieldData.field_type === 'address') {
                this.currentFieldFormData[this.currentFieldData.field_key].text = selectedOptions.map(option => option.label).join('/')
                this.currentFieldFormData[this.currentFieldData.field_key].value = selectedOptions.map(option => option.value)
            } else if (this.currentFieldData.field_type === 'department') {
                if (this.currentFieldData.select_range === '1') {
                    this.currentFieldFormData[this.currentFieldData.field_key].text = [{
                        full_path: selectedOptions.map(option => option.relate_name).join('/'),
                        id: last.relate_id,
                        department_name: last.relate_name,
                    }]
                    this.currentFieldFormData[this.currentFieldData.field_key].value = [last.relate_id]
                    this.currentFieldFormData[this.currentFieldData.field_key].titles = [last.relate_name]
                } else {

                }
                this.getBusinessGroup()
            }
            this.showCascaderPicker = false
        },

        //点击联系人选择组件
        handleClickContactFieldLink(field, formData) {
            if (this.is_preview_mode) return this.$toast('当前控件不允许在预览中操作')
            if (field.field_disabled) return false
            this.currentFieldData = field
            this.currentFieldFormData = formData
            this.selectContacts = JSON.parse(JSON.stringify(formData[field.field_key].text))
            this.getUserList()
            this.showContactPicker = true
        },

        //点击选择联系人
        handleClickContactItem(item) {
            if (!this.currentFieldData.select_range.includes('2') && item.uid === this.userInfo.user.id) return this.$toast('管理员设置了不可选自己')
            if (this.currentFieldData.select_range.includes('1')) {
                //人员多选
                if (item.hasOwnProperty('checked')) {
                    item.checked = !item.checked
                } else {
                    this.$set(item, 'checked', true)
                }
            } else {
                //人员单选
                this.currentFieldFormData[this.currentFieldData.field_key].value = [item.uid]
                this.currentFieldFormData[this.currentFieldData.field_key].text = [{
                    id: item.uid,
                    name: item.name,
                    avatar: item.avatar,
                }]
                this.handleClickContactPickerClose()
                this.getBusinessGroup()
                if (this.field_form === 'orders') {
                    if (this.currentFieldData.field_key === 'salesperson') {
                        const salesperson_ids = this.customForm?.salesperson?.value || [];
                        if (this.pk_id !== 0 && Object.keys(this.form_detail).length) {
                            if (salesperson_ids !== this.form_detail.salesperson.value) {
                                this.$dialog.confirm({
                                    title: '变更负责人',
                                    message: '变更负责人后，原负责人若无权限则无法查看',
                                    confirmButtonColor: '#E44144',
                                }).then(() => {

                                }).catch(() => {
                                    formData[field.field_key] = this.form_detail.salesperson
                                })
                            }
                        }
                        const user_id = this.userInfo?.user?.id;
                        if (this.order_amount_compute_mode.length) {
                            this.order_amount_compute_mode.forEach(field => {
                                if (field.visible_person_range && field.visible_person_range.length) {
                                    const user_id = this.userInfo?.user?.id;
                                    let arr = []
                                    field.visible_person_range.forEach(item => {
                                        if (item.relate_type == "order_approver") {

                                        } else if (item.relate_type == "order_creator") {
                                            arr = arr.concat(salesperson_ids)
                                        } else {
                                            arr.push(item.uid)
                                        }
                                    })
                                    this.$set(field, 'initial_display', !arr.includes(user_id));
                                }
                            })
                        }
                    }
                }
            }
        },

        //联系人复选框状态变化事件
        handleContactCheckboxChange(item) {
            if (item.checked) {
                if (this.selectContacts.findIndex(contact => contact.id === item.uid) < 0) {
                    this.selectContacts.push({
                        id: item.uid,
                        name: item.name,
                        avatar: item.avatar,
                    })
                }
            } else {
                this.selectContacts.splice(this.selectContacts.findIndex(contact => contact.id === item.uid), 1)
            }
        },

        //联系人选择弹窗关闭事件
        handleClickContactPickerClose() {
            this.contactName = ''
            this.showContactPicker = false
            this.selectContacts = []
        },

        //联系人选择弹窗确定事件
        handleClickContactPickerConfirm() {
            if (this.selectContacts.length === 0) return this.$toast(this.currentFieldData.placeholder)
            this.currentFieldFormData[this.currentFieldData.field_key].value = this.selectContacts.map(contact => contact.id)
            this.currentFieldFormData[this.currentFieldData.field_key].text = JSON.parse(JSON.stringify(this.selectContacts))
            this.handleClickContactPickerClose()
            this.getBusinessGroup()
        },

        //点击选择关联商机
        handleClickRelateProject(field, formData) {
            this.relateProjectVisible = true
            this.currentFieldData = field
            this.currentFieldFormData = formData
            if (this.relateProjectList.length === 0) {
                this.relatePagination.pageNum = 1
                this.relateTableKeyword = ''
                this.relate_created_at = []
                this.getRelateProjectList()
            }
        },

        //获取关联商机
        getRelateProjectList() {
            getProjectList({
                keyword: this.relateTableKeyword,
                created_at: this.relate_created_at,
                page: this.relatePagination.pageNum,
                pageSize: this.relatePagination.pageSize
            }).then(res => {
                if (res.code === 200) {
                    this.relateProjectList = this.relateProjectList.concat(res.data.data)
                    this.relatePagination.total = res.data.total
                }
            }).catch(() => {

            })
        },

        handleSearchRelateTable() {
            this.relatePagination.pageNum = 1
            this.relateProjectList = []
            if (this.importQuotationVisible) {
                this.getQuotationList()
            } else {
                this.getRelateProjectList()
            }
        },

        //滚动加载关联商机
        scrollLoadRelateProjectList() {
            if (this.relatePagination.pageNum * this.relatePagination.pageSize < this.relatePagination.total) {
                this.relatePagination.pageNum++
                this.getRelateProjectList()
            }
        },

        //点击选择商机
        handleClickRelateProjectItem(item) {
            this.currentFieldFormData[this.currentFieldData.field_key].text = item.name
            this.customForm.customer_id = {
                value: item.customer_id,
                text: item.customer_name,
            }
            const customer_contact_field = this.formInfoList.find(item => item.field_type === 'customer_contact')
            if (customer_contact_field && customer_contact_field.handle_type === 'select') {
                this.getRelateContactList('', customer_contact_field, true)
            }
            this.relateProjectVisible = false
        },

        //点击选择关联订单
        handleClickRelateOrder() {

        },

        //获取关联客户列表
        handleClickRelateCustom(field, formData) {
            this.currentFieldData = field
            this.currentFieldFormData = formData
            if (this.relateCustomList.length === 0) {
                this.getCustomerList('', field)
            }
            this.showContactPicker = true
        },

        //获取客户列表
        getCustomerList(keyword, field, type) {
            GetCustomerPrivateList({
                keyword: keyword
            }).then(res => {
                if (res.code === 200) {
                    this.relateCustomList = res.data.data
                    if (type && type === 'add_feedback') {
                        // 新增之后就回显到页面中
                        this.currentFieldFormData[this.currentFieldData.field_key].value = field.options.length && field.options[0].id;
                        this.currentFieldFormData[this.currentFieldData.field_key].text = field.options.length && field.options[0].name.value;
                        const customer_contact_field = this.formInfoList.find(item => item.field_type === 'customer_contact')
                        if (customer_contact_field && customer_contact_field.handle_type === 'select') {
                            this.getRelateContactList('', customer_contact_field, true)
                        }
                    }
                }
            }).catch(() => {
                return false
            })
        },

        //选择关联客户事件
        handleClickCustomerItem(item) {
            this.currentFieldFormData[this.currentFieldData.field_key].text = item.name.value
            this.currentFieldFormData[this.currentFieldData.field_key].value = item.id
            const customer_contact_field = this.formInfoList.find(item => item.field_type === 'customer_contact')
            if (customer_contact_field && customer_contact_field.handle_type === 'select') {
                this.getRelateContactList('', customer_contact_field, true)
            }
            this.showContactPicker = false
        },

        //获取关联联系人列表
        getRelateContactList(name, field, auto_fill) {
            if ((this.customForm.customer_id && this.customForm.customer_id.value) || this.relate_customer_id !== 0) {
                GetContactList({
                    customer_id: this.customForm.customer_id ? this.customForm.customer_id.value : this.relate_customer_id,
                    name: name
                }).then(res => {
                    if (res.code === 200) {
                        if (res.data.list.length) {
                            this.relateCustomContactList = res.data.list
                            if (auto_fill) {
                                this.$set(this.currentFieldFormData[field.field_key], 'value', [res.data.list[0].id])
                                this.$set(this.currentFieldFormData[field.field_key], 'text', [res.data.list[0]])
                            }
                        } else {
                            this.$set(this.currentFieldFormData[field.field_key], 'value', [])
                            this.$set(this.currentFieldFormData[field.field_key], 'text', [])
                        }
                    }
                })
            }
        },

        //选择关联联系人
        handleClickRelateCustomContact(field, formData) {
            if (this.customForm.customer_id && this.customForm.customer_id.value === '') return this.$toast.fail('请先选择关联客户')
            this.currentFieldData = field
            this.currentFieldFormData = formData
            this.showContactPicker = true
        },

        //选择关联客户联系人事件
        handleClickCustomerContactItem(item) {
            this.currentFieldFormData[this.currentFieldData.field_key].value = [item.id]
            this.currentFieldFormData[this.currentFieldData.field_key].text = this.relateCustomContactList.filter(item => this.currentFieldFormData[this.currentFieldData.field_key].value.includes(item.id))
            this.showContactPicker = false
        },

        //点击导入报价单
        handleClickImportQuotation() {
            this.importQuotationVisible = true
            if (this.quotationData.length === 0) {
                this.relatePagination.pageNum = 1
                this.relateTableKeyword = ''
                this.relate_created_at = []
                this.getQuotationList()
            }
        },

        getQuotationList() {
            projectQuotationOrderList({
                keyword: this.relateTableKeyword = '',
                quotation_status: 4,
                quotation_at: this.relate_created_at ? this.relate_created_at.join(' - ') : '',
                page: this.relatePagination.pageNum,
                pageSize: this.relatePagination.pageSize,
            }).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    this.quotationData = data
                    this.relatePagination.total = total
                }
            })
        },

        //滚动加载关联报价单
        scrollLoadRelateQuotationList() {
            if (this.relatePagination.pageNum * this.relatePagination.pageSize < this.relatePagination.total) {
                this.relatePagination.pageNum++
                this.getQuotationList()
            }
        },

        //选择报价单
        handleClickRelateQuotationItem(item) {
            orderImportDetails({
                project_quotation_id: item.project_quotation_id
            }).then(res => {
                if (res.code === 200) {
                    if (res.data.project_id && res.data.project_id.value && res.data.project_id.value.length) {
                        this.$set(this.customForm, 'project_id', res.data.project_id)
                    }
                    this.$set(this.customForm, 'customer_id', res.data.customer_id)
                    this.$set(this.customForm, 'contact_id', res.data.contact_id)
                    const customer_contact_field = this.formInfoList.find(item => item.field_type === 'customer_contact')
                    const order_goods = res.data.order_goods
                    if (order_goods && order_goods.length) {
                        order_goods.forEach(goods => {
                            if (goods.goods_type === 'bundle') {
                                const childItems = goods._child || [];
                                const calculateTotal = (property) => {
                                    return childItems.reduce((total, child) => {
                                        const value = parseFloat(child[property]) || 0;
                                        const num = parseFloat(child.num) || 0;
                                        return total + value * num;
                                    }, 0);
                                };
                                goods.cost_price = calculateTotal('cost_price').toFixed(2);
                                goods.guide_price = calculateTotal('guide_price').toFixed(2);
                                goods.sale_guide_price = calculateTotal('sale_guide_price').toFixed(2);
                                goods.lease_guide_price = calculateTotal('lease_guide_price').toFixed(2);
                                goods.is_virtual = childItems.some(child => child.can_in_out_stock === 1) ? 1 : 0;
                            } else {
                                goods.is_virtual = goods.can_in_out_stock;
                            }
                        });
                        this.$set(this.customForm, 'order_goods', order_goods)
                        this.computeTotalAmountForTheOrderList()
                    }
                    this.customForm.project_quotation_id = item.project_quotation_id
                    this.importQuotationVisible = false
                }
            })
        },

        //点击进行ocr识别
        handleClickOcrRecognition(field, formData) {
            if (this.is_preview_mode) return this.$toast('当前控件不允许在预览中操作')
            if (field.field_disabled) return false
            this.currentFieldData = field
            this.currentFieldFormData = formData
            this.ocrRecognizeVisible = true
        },

        //ocr上传事件
        handleOcrUploadChange(event) {
            const file = event.target.files[0]
            if (file) {
                if (file.size > 10 * 1024 * 1024) return vant.Toast.fail('图片大小不能超过10m')
                uploadImg(file).then(res => {
                    if (res.file_path) {
                        this.ocrImgUrl = res.file_path
                        ocrRecognize({
                            type: this.currentFieldData.field_type === 'id_card' ? 'idcard' : 'bankCard',
                            url: this.ocrImgUrl,
                        }).then(res => {
                            if (res.code === 200) {
                                this.$toast('识别成功')
                                if (this.currentFieldData.field_type === 'id_card') {
                                    const {
                                        idNumber,
                                        name,
                                        birthDate,
                                        address
                                    } = res.data
                                    this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'value', idNumber)
                                    if (this.currentFieldData.name_is_show) {
                                        this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'name', name)
                                    }
                                    if (this.currentFieldData.birthday_is_show) {
                                        if (birthDate) {
                                            const date = new Date(birthDate.replace(/年|月/g, '-').replace(/日/g, ''))
                                            const year = date.getFullYear()
                                            const month = (date.getMonth() + 1).toString().padStart(2, '0')
                                            const day = date.getDate().toString().padStart(2, '0')
                                            this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'birthday', year + '-' + month + '-' + day)
                                        }
                                    }
                                    if (this.currentFieldData.address_is_show) {
                                        this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'address', address)
                                    }
                                } else {
                                    const {
                                        bankName,
                                        cardNumber
                                    } = res.data
                                    this.payingTellerForm.bank_name = bankName
                                    this.payingTellerForm.card_number = cardNumber ? cardNumber.replace(/\s/g, '').replace(/(\d{4})(?=\d)/g, '$1 ') : ''
                                    this.addTellerVisible = true
                                }
                                this.handleClickOcrRecognizeClose()
                            } else {
                                this.$toast(res.message)
                            }
                        })
                    }
                }).catch(() => {

                })
            }
        },

        //ocr识别弹窗关闭事件
        handleClickOcrRecognizeClose() {
            this.ocrRecognizeVisible = false
            this.ocrImgUrl = ''
        },

        //点击选择银行卡
        handleClickPayingTellerFieldLink(field, formData) {
            if (this.is_preview_mode) return this.$toast('当前控件不允许在预览中操作')
            if (field.field_disabled) return false
            if (!field.options || !field.options.length) {
                getBankCardList().then(res => {
                    if (res.code === 200) {
                        if (res.data.length) {
                            res.data.forEach(item => item.card_number = item.card_number.replace(/\s/g, '').replace(/(\d{4})(?=\d)/g, '$1 '))
                        }
                        this.$set(field, 'options', res.data)
                        this.currentFieldData = field
                        this.currentFieldFormData = formData
                        this.showTellerSelectPopup = true
                    } else {
                        this.$toast(res.message)
                    }
                })
            } else {
                this.currentFieldData = field
                this.currentFieldFormData = formData
                this.showTellerSelectPopup = true
            }
        },

        //取消选择银行卡
        handleSelectTellerCancel() {
            this.showTellerSelectPopup = false
        },

        //选择银行卡事件
        handleClickSelectBankCard(card) {
            this.currentFieldData.options.forEach(item => {
                this.$set(item, 'checked', false)
            })
            this.$set(card, 'checked', true)
            this.currentFieldFormData[this.currentFieldData.field_key] = JSON.parse(JSON.stringify(card))
            this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'value', card.card_number.replace(/\s/g, ''))
            this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'text', card.card_number)
            this.showTellerSelectPopup = false
        },

        //点击编辑银行卡
        handleClickEditPayingTeller(bank) {
            this.payingTellerForm.bank_card_id = bank.bank_card_id
            this.payingTellerForm.account_type = bank.account_type
            this.payingTellerForm.account_name = bank.account_name
            this.payingTellerForm.card_number = bank.card_number
            this.payingTellerForm.bank_branch = bank.bank_branch
            this.payingTellerForm.bank_name = bank.bank_name
            this.addTellerVisible = true
        },

        //添加账户取消
        handleClickAddTellerCancel() {
            this.addTellerVisible = false
            this.$refs.payingTellerForm.resetValidation()
            this.payingTellerForm.bank_card_id = ''
            this.payingTellerForm.account_type = '1'
            this.payingTellerForm.account_name = ''
            this.payingTellerForm.card_number = ''
            this.payingTellerForm.bank_name = ''
            this.payingTellerForm.bank_branch = ''
            this.ocrImgUrl = ''
        },

        //添加账户确定
        handleClickAddTellerConfirm() {
            this.$refs.payingTellerForm.validate().then(() => {
                this.payingTellerForm.card_number = this.payingTellerForm.card_number.replace(/\s/g, '')
                if (this.payingTellerForm.bank_card_id) {
                    bankCardEdit(this.payingTellerForm).then(res => {
                        if (res.code === 200) {
                            if (this.isEditSelected) {
                                this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'value', this.payingTellerForm.card_number)
                                this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'text', this.payingTellerForm.card_number.replace(/\s/g, '').replace(/(\d{4})(?=\d)/g, '$1 '))
                                this.isEditSelected = false
                            }
                            this.handleClickAddTellerCancel()
                            this.$toast('编辑成功')
                            this.currentFieldData.options = []
                            getBankCardList().then(res => {
                                if (res.data.length) {
                                    res.data.forEach(item => item.card_number = item.card_number.replace(/\s/g, '').replace(/(\d{4})(?=\d)/g, '$1 '))
                                }
                                this.$set(this.currentFieldData, 'options', res)
                            })
                        } else {
                            this.$toast(res.message)
                        }
                    })
                } else {
                    bankCardAdd(this.payingTellerForm).then(res => {
                        if (res.code === 200) {
                            this.currentFieldData.options = []
                            getBankCardList().then(res => {
                                if (res.data.length) {
                                    res.data.forEach(item => item.card_number = item.card_number.replace(/\s/g, '').replace(/(\d{4})(?=\d)/g, '$1 '))
                                }
                                this.$set(this.currentFieldData, 'options', res)
                            })
                            this.currentFieldFormData[this.currentFieldData.field_key] = JSON.parse(JSON.stringify(this.payingTellerForm))
                            this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'value', this.payingTellerForm.card_number)
                            this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'text', this.payingTellerForm.card_number.replace(/\s/g, '').replace(/(\d{4})(?=\d)/g, '$1 '))
                            this.handleClickAddTellerCancel()
                            this.$toast('添加成功')
                        } else {
                            this.$toast(res.message)
                        }
                    })
                }
            }).catch(error => {

            })
        },

        //删除银行账户
        handleClickDelPayingTeller() {
            this.$dialog.confirm({
                title: '删除提示',
                message: '确定删除当前账户吗？',
                confirmButtonColor: '#2990ff'
            }).then(() => {
                bankCardDel({
                    bank_card_id: this.payingTellerForm.bank_card_id
                }).then(res => {
                    if (res.code === 200) {
                        this.$toast('删除成功')
                        this.currentFieldData.options = []
                        getBankCardList().then(res => {
                            if (res.code === 200) {
                                if (res.data.length) {
                                    res.data.forEach(item => item.card_number = item.card_number.replace(/\s/g, '').replace(/(\d{4})(?=\d)/g, '$1 '))
                                }
                                this.$set(this.currentFieldData, 'options', res)
                            } else {
                                this.$toast(res.message)
                            }
                        })
                        if (this.currentFieldFormData[this.currentFieldData.field_key].value === this.payingTellerForm.card_number.replace(/\s/g, '')) {
                            this.currentFieldFormData[this.currentFieldData.field_key].value = ''
                            this.currentFieldFormData[this.currentFieldData.field_key].text = ''
                        }
                    } else {
                        this.$toast(res.message)
                    }
                })
            }).catch(() => {
                // on cancel
            });
        },

        //预览模式下点击操作提示
        handleClickPreviewModeBtn() {
            this.$toast('当前控件不允许在预览中操作')
        },

        //上传图片
        handleClickUploadImg(e, field, formData) {
            if (field.field_disabled) e.preventDefault()
            if (formData[field.field_key].length === 10) return this.$toast.fail('最多只能上传10张图片')
            const files = Array.from(e.target.files)
            if (files.length > 10) return this.$toast.fail('最多只能上传10张，请重新选择图片')
            if (files.some(file => !file.type.includes('image'))) this.$toast.fail('只能上传图片格式，请重新选择')
            files.forEach(file => {
                if (file.size > 50 * 1024 * 1024) {
                    return this.$toast.fail('图片大小不能超过50m')
                } else {
                    uploadImg(file, file.size).then(res => {
                        if (res.file_path) {
                            res.file_size = formatFileSize(file.size)
                            formData[field.field_key].push(res)
                            e.target.value = ''
                        }
                    }).catch(error => {
                        e.target.value = ''
                    })
                }
            })
        },

        //附件上传事件
        handleUploadFileChange(e, field, formData) {
            if (field.field_disabled) e.preventDefault()
            const files = e.target.files
            const that = this
            Array.from(files).forEach(file => {
                if (file.size > 50 * 1024 * 1024) return that.$toast.fail('附件大小不能超过50m')
                if (field.file_type !== '') {
                    const fileType = file.type.split('/')[1] // 获取文件类型的后缀名
                    if (!field.file_type.includes(fileType.toLowerCase())) return that.$toast('上传文件类型不在管理员设置的范围内，请重新上传')
                }
                uploadImg(file, file.size).then(res => {
                    if (res.file_path) {
                        res.file_size = formatFileSize(file.size)
                        formData[field.field_key].push(res)
                        e.target.value = ''
                    }
                    e.target.value = ''
                }).catch(error => {
                    e.target.value = ''
                })
            })
        },

        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes('image')) {
                this.previewImgList = [file.file_path]
                this.previewImgSrc = file.file_path
                this.$refs.preview_img.showViewer = true
            } else {
                if (file.file_type.includes('pdf')) {
                    window.open(file.file_path)
                } else {
                    this.$toast('当前文件格式不支持预览，请下载后查看')
                }
            }
        },

        //评分组件切换事件
        handleRateFieldChange(field, formData) {
            if (field.point_system === '5') {
                formData[field.field_key].text = formData[field.field_key].value + '分'
            } else {
                formData[field.field_key].text = formData[field.field_key].value * 2 + '分'
            }
        },

        //点击上传发票
        handleClickUploadInvoice(field, formData) {
            if (field.field_disabled) return false
            if (this.is_preview_mode) return this.$toast('当前控件不允许在预览中操作')
            if (field.field_disabled) return false
            this.currentFieldData = field
            this.currentFieldFormData = formData
            this.invoiceUploadVisible = true
            /*this.invoiceFilesList = [
                    {
                        'op': 'invoice',
                        'invoice_type': '数电普通发票',
                        'invoice_code': '',
                        'invoice_number': '24112000000033990251',
                        'printed_invoice_code': '',
                        'printed_invoice_number': '',
                        'check_code': '',
                        'invoice_date': '2024年05月06日',
                        'title': '电子发票(普通发票)',
                        'form_type': '',
                        'purchaser_name': '北京澜景科技有限公司',
                        'purchaser_tax_number': '91110108351312831B',
                        'purchaser_contact_info': '',
                        'purchaser_bank_account_info': '',
                        'total_amount': '36.10',
                        'file_type': 'pdf',
                        'file_path': 'https://download.hecoos.com/enlightv/2024-48/7eac20103a9920a9f529924b847a08c4.pdf'
                    },
                    {
                        'op': 'invoice',
                        'invoice_type': '电子普通发票',
                        'invoice_code': '011002301711',
                        'invoice_number': '29276154',
                        'printed_invoice_code': '',
                        'printed_invoice_number': '',
                        'check_code': '85453022992728593554',
                        'invoice_date': '2024年04月30日',
                        'title': '北京增值税电子普通发票',
                        'form_type': '',
                        'purchaser_name': '北京澜景科技有限公司',
                        'purchaser_tax_number': '91110108351312831B',
                        'purchaser_contact_info': '',
                        'purchaser_bank_account_info': '',
                        'total_amount': '26.63',
                        'file_type': 'pdf',
                        'file_path': 'https://download.hecoos.com/enlightv/2024-48/9c0ba0d1bc9b791f461e9a88f765190b.pdf'
                    },
                    {
                        'op': 'invoice',
                        'invoice_type': '电子普通发票',
                        'invoice_code': '011002301711',
                        'invoice_number': '29276154',
                        'printed_invoice_code': '',
                        'printed_invoice_number': '',
                        'check_code': '85453022992728593554',
                        'invoice_date': '2024年04月30日',
                        'title': '北京增值税电子普通发票',
                        'form_type': '',
                        'purchaser_name': '北京澜景科技有限公司',
                        'purchaser_tax_number': '91110108351312831B',
                        'purchaser_contact_info': '',
                        'purchaser_bank_account_info': '',
                        'total_amount': '26.63',
                        'file_type': 'image',
                        'file_path': 'https://download.hecoos.com/enlightv/2024-46/d006ad2ef5e4a8f0b2181729b4ea193d.jpeg'
                    },
                ]*/
            this.invoiceDetailDialogVisible = true
        },

        //上传发票文件事件
        handleUploadInvoiceChange(event, file_type) {
            const files = Array.from(event.target.files)
            files.forEach((file, file_index) => {
                if (file.type.indexOf('image') < 0 && file.type.indexOf('pdf') < 0) return this.$toast.fail('请上传正确的pdf文件或者图片格式')
                if (file.size > 10 * 1024 * 1024) return this.$toast.fail('文件大小不能超过10m')
                uploadImg(file).then(res => {
                    if (res.file_path) {
                        const file_path = res.file_path
                        ocrRecognize({
                            type: 'mixedInvoices',
                            url: file_path
                        }).then(res => {
                            if (res.code !== 200) return this.$toast.fail(res.message)
                            res.data.forEach(item => {
                                this.invoiceFilesList.push({
                                    ...item,
                                    file_type,
                                    file_path
                                })
                            })
                            if (file_index === files.length - 1) {
                                this.invoiceDetailDialogVisible = true
                            }
                        })
                    }
                    event.target.value = ''
                }).catch(() => {
                    event.target.value = ''
                })
            })
        },

        //pdf类型的发票预览
        handleClickInvoicePdfReview(file_path) {
            window.open(file_path)
        },

        //发票类型转文字
        invoiceOptionText(op) {
            let str = '其它'
            if (op === 'invoice') {
                str = '增值税普通发票'
            }
            return str
        },

        //发票明细的取消事件
        handleClickInvoiceInfoDialogCancel() {
            this.invoiceInfoPreview = false
            this.invoiceDetailDialogVisible = false
        },

        //发票明细的确定事件
        handleClickInvoiceInfoDialogConfirm() {
            if (this.invoiceInfoPreview) {
                this.handleClickInvoiceInfoDialogCancel()
            } else {
                if (this.currentFieldData.comparison_info_setting.length > 0) {
                    this.currentFieldData.comparison_info_setting.forEach(rule => {
                        let flag = true
                        this.invoiceFilesList.forEach(invoice => {
                            flag = invoice.purchaser_name === rule.purchaser_name && invoice.purchaser_tax_number === rule.purchaser_tax_number &&
                                    (invoice.purchaser_contact_info === '' || invoice.purchaser_contact_info === rule.purchaser_contact_info) &&
                                    (invoice.purchaser_bank_account_info === '' || invoice.purchaser_bank_account_info === rule.purchaser_bank_account_info)
                        })
                        if (!flag) return this.$toast.fail('发票购货方信息不正确，请重新上传其他发票')
                    })
                }
                this.invoiceDetailDialogVisible = false
                this.$set(this.currentFieldFormData, this.currentFieldData.field_key, this.invoiceFilesList)
                this.invoiceInfoPreview = false
            }
        },

        //预览发票文件
        handleClickPreviewInvoiceFile(invoice) {
            this.invoiceFilesList = [invoice]
            this.invoiceInfoPreview = true
            this.invoiceDetailDialogVisible = true
        },

        //删除上传的发票文件
        handleClickDeleteInvoiceFile(index) {
            this.invoiceFilesList.splice(index, 1)
        },

        //取消上传发票
        handleClickCancelUploadInvoice() {
            this.uploadInvoiceVisible = false
            this.invoiceFilesList = []
        },

        //点击新增关联表单数据
        handleClickAddRelateForm(field, formData, field_form) {
            if (this.is_preview_mode) return this.$toast('当前控件不允许在预览中操作')
            if (field.field_disabled) return false
            if (field.field_disabled) return false
            if (field_form === 'customer_contacts' && field.handle_type === 'select' && formData.customer_id && formData.customer_id.value === '') return this.$toast.fail('请先选择关联客户')
            this.currentFieldData = field
            this.currentFieldFormData = formData
            this.relateFieldForm = field_form
            this.relate_pk_id = 0
            getFormFields({
                field_form
            }).then(res => {
                if (res.code === 200) {
                    this.relateCustomFormFields = res.data
                    this.relateCustomFormVisible = true
                    if (field_form === 'orders') {
                        this.relateCustomFormIsFormModule = true
                        getBusinessIsApproval('order_add').then(res => {
                            this.relateCustomFormIsApprove = res
                            if (this.relateCustomFormIsApprove === 1) {
                                getApprovalNodes({
                                    approval_type: 'order_add',
                                }).then(res => {
                                    if (res.code === 200) {
                                        this.approval_node_list = res.data
                                        this.$refs.approveProcessSelectRef.set_approval_node_list(res.data)
                                    } else {

                                    }
                                    this.loading = false
                                }).catch(() => {
                                    this.loading = false
                                })
                            }
                        })
                    } else {
                        this.relateCustomFormIsFormModule = false
                    }
                } else {

                }
            }).catch(() => {

            })
        },

        //点击编辑客户联系人
        handleClickEditCrmContact(field, formData, contact) {
            this.currentFieldData = field
            this.currentFieldFormData = formData
            this.relate_pk_id = contact.id
            getFormFields({
                field_form: 'customer_contacts'
            }).then(res => {
                if (res.code === 200) {
                    this.relateCustomFormFields = res.data
                    contactDetail(contact.id).then(res => {
                        this.relateCustomFormData = res.data
                        this.relateCustomFormVisible = true
                    })
                } else {

                }
            }).catch(() => {
                this.loading = false
            })
        },

        //客户联系人删除事件
        handleClickCloseCrmContactTag(field_key, contact, index) {
            this.$dialog.confirm({
                title: '删除',
                message: '确定删除联系人吗？',
                confirmButtonColor: '#2990ff'
            }).then(() => {
                this.customForm[field_key].text.splice(index, 1)
                this.customForm[field_key].id.splice(index, 1)
            })
        },

        //新增关联表单取消事件
        handleClickRelateFormCancel() {
            this.relateCustomFormVisible = false
            this.relate_form_id = 0
        },

        //新增关联表单确认事件
        handleClickCrmContactConfirm(is_release) {
            if (this.relateFieldForm === 'orders') {
                this.order_is_release = is_release;
            }
            this.$refs.relateCustomForm.handleClickPublish()
        },

        //提交关联表单数据
        submitRelateFormData(customForm) {
            this.btnDisabled = true
            if (this.relate_pk_id) {
                //编辑
                if (this.relateFieldForm === 'customer_contacts') {
                    editContact(this.relate_pk_id, customForm).then(res => {
                        if (res.code === 200) {
                            this.$toast.success(res.message)
                            this.currentFieldFormData[this.currentFieldData.field_key].text.find(user => user.id === this.relate_pk_id).name = customForm.name.value
                            this.btnDisabled = false
                            this.handleClickRelateFormCancel()
                        } else {

                        }
                    })
                } else if (this.relateFieldForm === 'customers') {
                    CustomerPrivateEdit(this.relate_pk_id, customForm).then(res => {
                        if (res.code === 200) {
                            this.$toast.success(res.message)
                            this.handleClickRelateFormCancel()
                            this.getCustomerList('', this.currentFieldData)
                            this.btnDisabled = false
                        } else {

                        }
                    })
                }
            } else {
                //新增
                if (this.relateFieldForm === 'customer_contacts') {
                    if (this.customForm.customer_id && this.customForm.customer_id.value) {
                        customForm.customer_id = this.customForm.customer_id.value
                    }
                    if (this.relate_customer_id !== 0) {
                        customForm.customer_id = this.relate_customer_id
                    }
                    addContact(customForm).then(res => {
                        if (res.code === 200) {
                            this.$toast.success(res.message)
                            this.handleClickRelateFormCancel()
                            if (this.currentFieldData.handle_type === 'select') {
                                this.getRelateContactList('', this.currentFieldData)
                            } else {
                                this.currentFieldFormData[this.currentFieldData.field_key].text.push({
                                    name: customForm.name.value,
                                    id: res.data.id,
                                })
                                this.currentFieldFormData[this.currentFieldData.field_key].value.push(res.data.id)
                                this.$refs.customForm.clearValidate(this.currentFieldData.field_key)
                            }
                            this.btnDisabled = false
                        } else {

                        }
                    }).catch(() => {
                    })
                } else if (this.relateFieldForm === 'customers') {
                    CustomerPrivateAdd(customForm).then(res => {
                        if (res.code === 200) {
                            this.$toast.success(res.message)
                            this.handleClickRelateFormCancel()
                            this.getCustomerList('', this.currentFieldData, 'add_feedback')
                            this.btnDisabled = false
                        } else {

                        }
                    })
                } else if (this.relateFieldForm === 'orders') {
                    if (this.relateCustomFormIsApprove === 1 && !this.$refs.approveProcessSelectRef.handleClickPublish()) return false
                    orderAdd({
                        ...customForm,
                        is_release: this.order_is_release,
                        node_list: this.approval_node_list,
                        goods_cost_price: 0
                    }).then(res => {
                        if (res.code === 200) {
                            this.$toast.success('新增成功')
                            this.handleClickRelateFormCancel()
                        } else {

                        }
                    })
                }
            }
        },

        getContainerPurchaseDetails() {
            return document.querySelector('.purchase_details_wrap')
        },

        getSearchProducts(item) {
            searchProducts({
                keyword: item.product_name
            }).then(res => {
                if (res.code === 200) {
                    this.productList = res.data ? res.data : []
                    let info = this.productList.find(find => find.name == item.product_name)
                    if (item.product_name) {
                        this.$set(item, 'productPopoverShow', true)
                    }
                    if (info) {
                        this.$set(item, 'sku_id', info.sku_id)
                        this.$set(item, 'sku_key', info.sku_key)
                    } else {
                        this.$set(item, 'sku_id', '')
                        this.$set(item, 'sku_key', '')
                    }
                }
            })
        },

        //添加明细
        handleClickAddTableRow(field) {
            if (field.field_disabled) return false
            const {formData} = this.deepCreateFormData(field._child)
            const first = this.customForm[field.field_key][0]
            field._child.forEach(child => {
                if (child.field_type === 'department' && child.default && first) {
                    formData[child.field_key] = first[child.field_key]
                }
            })
            this.customForm[field.field_key].push(formData)
        },

        //删除明细
        handleClickDelTableRow(field, index) {
            if (this.customForm[field.field_key].length === 1) return this.$toast.fail('请至少保留一条明细')
            this.customForm[field.field_key].splice(index, 1)
            const compute_mode_fields = ['money', 'number', 'compute_mode', 'date_range']
            field._child.forEach(child => {
                if (compute_mode_fields.includes(child.field_type)) {
                    this.compute_mode_field_list.forEach(field => {
                        if (field.field_formula.includes(child.field_key) && !field.p_field_key) {
                            //接口需要的数据
                            const formulaValue = {}
                            //拿出公式列表所有type为component的组件
                            const components = field.formula_list.filter(formula => formula.type === 'component')
                            //明细外计算
                            components.forEach(component => {
                                if (component.field_type === 'date_range') {
                                    if (component.p_field_key) {
                                        //如果公式字段是明细内的。则需要计算总和
                                        formulaValue[component.field_key] = this.customForm[component.p_field_key].reduce((sum, obj) => {
                                            return sum + parseFloat(obj[component.field_key].duration)
                                        }, 0)
                                    } else {
                                        formulaValue[component.field_key] = this.customForm[component.field_key] && this.customForm[component.field_key].duration ? parseFloat(this.customForm[component.field_key].duration) : 0
                                    }
                                } else {
                                    if (component.p_field_key && component.p_field_type !== 'control') {
                                        //如果公式字段是明细内的。则需要计算总和
                                        formulaValue[component.field_key] = this.customForm[component.p_field_key].reduce((sum, obj) => {
                                            return sum + (obj[component.field_key] ? parseFloat(obj[component.field_key].value) : 0)
                                        }, 0)
                                    } else {
                                        formulaValue[component.field_key] = this.customForm[component.field_key] && this.customForm[component.field_key].value ? parseFloat(this.customForm[component.field_key].value) : 0
                                    }
                                }
                            })
                            if (Object.values(formulaValue).length > 0) {
                                let res = calculate(field.field_formula, formulaValue)
                                res = isNaN(res) || !isFinite(res) ? 0 : res
                                const value = this.formatAmount(res.toString(), field, false)
                                this.$set(this.customForm[field.field_key], 'value', value)
                                this.$set(this.customForm[field.field_key], 'text', this.formatAmount(res.toString(), field, true))
                                this.$set(this.customForm[field.field_key], 'value_converted', this.customForm[field.field_key].value)
                                if (field.format.includes('1') && this.customForm[field.field_key].currency === 'CNY') {
                                    this.$set(this.customForm[field.field_key], 'chinese_text', numberPriceToChinese(value, false))
                                }
                                this.formulaComputedFun(field, this.customForm, this.formInfoList)
                                this.checkMeetTheCondition(field, this.customForm, this.formInfoList)
                            }
                        }
                    })
                }
            })
        },

        //点击关联审批单
        handleClickRelateApprove(field, formData) {
            if (this.is_preview_mode) return this.$toast('当前控件不允许在预览中操作')
            if (field.field_disabled) return false
            this.currentFieldData = field
            this.currentFieldFormData = formData
            if (formData[field.field_key].text && formData[field.field_key].text.length) {
                this.selectRelateApproveList = JSON.parse(JSON.stringify(formData[field.field_key].text))
            }
            this.relateApproveFormVisible = true
            this.relateApproveSetIds = this.currentFieldData.approve_form_scope
            if (this.relateApproveList.length === 0) {
                this.getRelateApproveList()
            }
            if (this.relateApproveTypeList.length === 0) {
                this.getRelateApproveTypeList(this.currentFieldData.approve_form_scope)
            }
        },

        getRelateApproveTypeList(approval_set_ids) {
            getApprovalType({
                approval_set_ids
            }).then(res => {
                this.relateApproveTypeList = res.data
            })
        },

        //获取关联审批单列表
        getRelateApproveList() {
            this.relateApproveLoading = true
            getRelateApproval({
                approval_set_ids: this.relateApproveSetIds,
                keyword: this.relateApproveKeyword,
                action: this.relateApproveAction,
                page: this.relateApprovePage.pageNum,
                pageSize: this.relateApprovePage.pageSize,
            }).then(res => {
                this.relateApproveList.push(...res.data.data)
                this.relateApprovePage.total = res.data.total
                this.relateApproveLoading = false
            })
        },

        //滚动加载关联审批单
        scrollLoadRelateApprove() {
            if (this.relateApprovePage.pageNum * this.relateApprovePage.pageSize < this.relateApprovePage.total) {
                this.relateApprovePage.pageNum++
                this.getRelateApproveList()
            }
        },

        //关键词回车事件
        handleRelateApproveInputSearch() {
            this.relateApprovePage.pageNum = 1
            this.relateApproveList = []
            this.getRelateApproveList()
        },

        //选择审批单
        handleClickRelateApproveItem(approve) {
            if (this.selectRelateApproveList.findIndex(item => item.id === approve.id) > -1) {
                this.selectRelateApproveList = this.selectRelateApproveList.filter(item => item.id !== approve.id)
            } else {
                this.selectRelateApproveList.push(approve)
            }
        },

        //关联审批单取消事件
        handleClickRelateApproveCancel() {
            this.selectRelateApproveList = []
            this.relateApproveFormVisible = false
            this.relateApproveKeyword = ''
            this.relateApproveSetIds = []
        },

        //关联审批单确定事件
        handleClickRelateApproveConfirm() {
            if (this.selectRelateApproveList.length === 0) return this.$toast.fail('请选择审批单')
            this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'text', this.selectRelateApproveList)
            this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'value', this.selectRelateApproveList.map(item => item.id))
            this.handleClickRelateApproveCancel()
        },

        //点击删除关联审批单
        handleClickDeleteRelatedApproval(formData, field, item, index) {
            formData[field.field_key].text.splice(index, 1)
            formData[field.field_key].value = formData[field.field_key].text.map(item => item.id)
        },

        //关联审批单详情
        handleClickRelatedApprovalDetail(item) {
            this.$showApprovalDetail({
                approval_id: item.id,
            }).then((res) => {

            });
        },

        //关联审批单展开事件
        handleApproveOverViewField(item) {
            if (item.hasOwnProperty('is_pack_up')) {
                item.is_pack_up = !item.is_pack_up
            } else {
                this.$set(item, 'is_pack_up', true)
            }
        },

        //点击关联打卡记录
        handleClickRelateCheckRecord(field, formData) {
            this.currentFieldData = field
            this.currentFieldFormData = formData
            this.relateCheckRecord = []
            this._getRelateCheckRecord(true)
            this.relateCheckRecordVisible = true
        },

        //获取关联打卡记录
        _getRelateCheckRecord(set_checked) {
            this.relateCheckRecordLoading = true
            getRelateCheckRecord({
                keyword: this.relateCheckRecordSearch.keyword,
                check_in_date: this.relateCheckRecordSearch.check_in_date,
                page: this.relateCheckRecordPagination.pageNum,
                pageSize: this.relateCheckRecordPagination.pageSize
            }).then(res => {
                if (res.code === 200) {
                    this.relateCheckRecord = this.relateCheckRecord.concat(res.data.data)
                    this.relateCheckRecordPagination.total = res.data.total
                    if (set_checked && this.currentFieldFormData[this.currentFieldData.field_key].value.length > 0) {
                        this.relateCheckRecord.forEach(item => {
                            if (this.currentFieldFormData[this.currentFieldData.field_key].value.includes(item.id)) {
                                this.$set(item, 'is_checked', true)
                            }
                        })
                    }
                }
                this.relateCheckRecordLoading = false
            })
        },

        //滚动加载关联打卡记录
        scrollLoadRelateRecordsList() {
            if (this.relateCheckRecordPagination.pageNum * this.relateCheckRecordPagination.pageSize < this.relateCheckRecordPagination.total) {
                this.relateCheckRecordPagination.pageNum++
                this._getRelateCheckRecord()
            }
        },

        //关联打卡记录搜索事件
        handleCheckRecordInputSearch() {
            this.relateCheckRecordPagination.pageNum = 1
            this.relateCheckRecord = []
            this._getRelateCheckRecord()
        },

        //点击选择打卡记录
        handleClickRelateCheckRecordItem(item) {
            if (!this.currentFieldData.addition_of_multiple) {
                this.relateCheckRecord.forEach(item => {
                    this.$set(item, 'is_checked', false)
                })
            }
            if (item.hasOwnProperty('is_checked')) {
                this.$set(item, 'is_checked', !item.is_checked)
            } else {
                this.$set(item, 'is_checked', true)
            }
        },

        //点击查看关联记录详情
        handleClickRelateCheckRecordDetail(row) {
            this.check_record_id = row.id
            this.relateCheckRecordDetailVisible = true
        },

        //关联打卡记录确定事件
        handleClickRelateCheckRecordConfirm() {
            const selectRecord = this.relateCheckRecord.filter(item => item.is_checked)
            if (selectRecord.length === 0) return this.$toast.fail('请选择打卡记录')
            this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'text', selectRecord)
            this.$set(this.currentFieldFormData[this.currentFieldData.field_key], 'value', selectRecord.map(item => item.id))
            this.handleClickRelateCheckRecordCancel()
        },

        //关联打卡记录取消事件
        handleClickRelateCheckRecordCancel() {
            this.relateCheckRecordVisible = false
            this.relateCheckRecordSearch.keyword = ''
            this.relateCheckRecordSearch.check_in_date = []
            this.relateCheckRecordPagination.pageNum = 1
        },

        //删除选择的打卡记录
        handleClickDeleteCheckRecord(record, field, formData) {
            formData[field.field_key].value = formData[field.field_key].value.filter(item => item !== record.id)
            formData[field.field_key].text = formData[field.field_key].text.filter(item => item.id !== record.id)
        },

        //点击去打卡
        handleClickGoCheckRecord(field, formData) {
            this.currentFieldData = field
            this.currentFieldFormData = formData
            this.clockInVisible = true
            this.clockInTimer = setInterval(() => {
                this.currentClockInTime = new Date();
            }, 1000);
            this.getCurrentPosition();
        },

        // 初始化地理位置
        getCurrentPosition() {
            let that = this;
            AMap.plugin("AMap.Geolocation", function () {
                var geolocation = new AMap.Geolocation({
                    enableHighAccuracy: true, //是否使用高精度定位，默认:true
                    timeout: 100000, //超过10秒后停止定位，默认：无穷大
                    buttonOffset: new AMap.Pixel(1, 2), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                    zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
                });
                // map.addControl(geolocation);
                geolocation.getCurrentPosition(function (status, result) {
                    if (status === "complete") {
                        that.onComplete(result);
                    } else {
                        that.onError(result);
                    }
                });
            });
        },

        onComplete(data) {
            // 定位成功回调函数
            let lng = data.position.lng;
            let lat = data.position.lat;
            this.selectedPosition = [lng, lat];
            this.location = this.selectedPosition.join(",");
            this.convertToAddress(lng, lat).then((res) => {
                this.locationName = res;
                if (this.updateClockPopup) {
                    this.updateClockForm.locationName = this.locationName;
                }
            });
        },

        // 将经纬度转换为详细的地址
        async convertToAddress(longitude, latitude) {
            try {
                //这里的key修改为自己申请的key
                var response = await fetch(`https://restapi.amap.com/v3/geocode/regeo?key=fc197e0057f33f3d1c6cfb50f33b9e3d&location=${longitude},${latitude}`);
                var data = await response.json();
                // 返回详细地址方法
                // if (data && data.regeocode && data.regeocode.formatted_address) {
                //     return data.regeocode.formatted_address; // 返回具体地址
                // } else {
                //     return "地址获取失败";
                // }
                // 返回指定信息
                if (data && data.regeocode && data.regeocode.addressComponent) {
                    const addressComponentInfo = data.regeocode.addressComponent;
                    // ${addressComponentInfo.district}
                    return `${addressComponentInfo.township}${
                            addressComponentInfo.streetNumber && addressComponentInfo.streetNumber.street
                    }${addressComponentInfo.streetNumber && addressComponentInfo.streetNumber.number}`;
                } else {
                    return "地址获取失败";
                }
            } catch (error) {
                return "地址获取发生错误";
            }
        },

        // 获取当前定位位置
        onError(result) {
            this.$toast("定位当前位置失败");
        },

        //点击关闭打卡
        handleClickCloseCloseIn() {
            clearInterval(this.clockInTimer)
            this.clockInVisible = false
        },

        //点击确定打卡
        handleClickClockIn() {
            this.clockInForm.punch_at = this.clock_in_formatted_time;
            this.clockInForm.locationName = this.locationName;
            CreateAttendanceCheck({
                punch_type: 'SINGLE',
                location: this.location,
                address: this.locationName,
                is_skip: 0,
                remark: [],
                images: [],
            }).then((res) => {
                if (res.code === 200) {
                    this.currentClockId = res.data.id;
                    this.clockInSuccessPopup = true;
                }
            });
        },

        handleClockInSuccessPopupClose() {
            this.clockInSuccessPopup = false;
            this.clockInForm.images = [];
            this.clockInForm.remark = "";
        },

        // 更新本次打卡记录数据
        handleUpdateAttendanceCheck() {
            const params = {
                id: this.currentClockId,
                remark: this.clockInForm.remark ? [this.clockInForm.remark] : [],
                images: this.clockInForm.images,
            };
            UpdateAttendanceCheck(params).then((res) => {
                if (res.code === 200) {
                    // this.$toast(res.message);
                    // this.getIndividualDailyAttendanceCheck()
                }
            });
        },

        // 选择上传图片方式
        handleClickSelectUploadType() {
            this.imageActionSheetShow = true;
        },

        // 预览图片
        handleClickPreviewImg(index, images) {
            ImagePreview({
                images,
                startPosition: index,
            });
        },

        // 删除图片
        handleClickImgDelete(index) {
            if (this.updateClockPopup) {
                this.updateClockForm.images.splice(index, 1);
            } else {
                this.clockInForm.images.splice(index, 1);
                this.$nextTick(() => {
                    this.handleUpdateAttendanceCheck();
                });
            }
        },

        // 上传照片
        handleClickUploadFile(e) {
            e.preventDefault();
            this.imageActionSheetShow = false;
            let that = this;
            const file = e.target.files[0];
            if (file) {
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function () {
                    const _data = this.result;
                    let blob = that.dataURItoBlob(_data);
                    let file = new window.File([blob], "照片.jpg", {type: "image/jpeg"});
                    uploadImg(file).then((res) => {
                        if (that.updateClockPopup) {
                            // 更改定位弹框
                            that.updateClockForm.images.push(res.file_path);
                        } else {
                            that.clockInForm.images.push(res.file_path);
                            that.$nextTick(() => {
                                that.handleUpdateAttendanceCheck();
                            });
                        }
                    }).catch(() => {
                    });
                };
            }
        },

        // base64转换为Blob
        dataURItoBlob(base64Data) {
            let byteString;
            if (base64Data.split(",")[0].indexOf("base64") >= 0) {
                byteString = atob(base64Data.split(",")[1]);
            } else {
                byteString = unescape(base64Data.split(",")[1]);
            }
            let mimeString = base64Data.split(",")[0].split(":")[1].split(";")[0];
            let ia = new Uint8Array(byteString.length);
            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ia], {type: mimeString});
        },

        // 更改定位
        handleClickUpdateClock() {
            this.updateClockForm.location = this.selectedPosition.join(",");
            this.updateClockPopup = true;
            this.$nextTick(() => {
                this.initMap();
            });
        },

        // 初始化地图
        async initMap() {
            // 初始化地图
            this.map = new AMap.Map("mapBox", {
                resizeEnable: true,
                zoom: 18, // 缩放级别
                center: this.selectedPosition || [116.397428, 39.90923], // 默认中心点（北京）
            });
            let that = this;
            // 获取用户当前位置
            AMap.plugin("AMap.Geolocation", function () {
                var geolocation = new AMap.Geolocation({
                    enableHighAccuracy: true, //是否使用高精度定位，默认:true
                    timeout: 100000, //超过10秒后停止定位，默认：无穷大
                    buttonOffset: new AMap.Pixel(1, 2), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                    zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
                });
                // map.addControl(geolocation);
                geolocation.getCurrentPosition(function (status, result) {
                    if (status === "complete") {
                        that.onComplete(result);
                    } else {
                        that.onError(result);
                    }
                    setTimeout(() => {
                        that.marker = new AMap.Marker({
                            position: that.selectedPosition,
                            map: that.map,
                            draggable: true, // 允许拖拽
                        });
                        // 监听标记拖拽事件
                        that.marker.on("dragend", (event) => {
                            const {lng, lat} = event.lnglat;
                            that.selectedPosition = [lng, lat];
                            that.updateClockForm.location = this.selectedPosition.join(",");
                            that.onComplete({position: {lng, lat}});
                        });
                    });
                });
            });
        },

        // 更改定位提交
        handleClickUpdateClockSubmit() {
            let params = {
                punch_type: 'SINGLE',
                location: this.updateClockForm.location,
                address: this.updateClockForm.locationName,
                is_skip: this.updateClockForm.is_skip,
                remark: this.updateClockForm.remark ? [this.updateClockForm.remark] : [],
                images: this.updateClockForm.images,
            };
            CreateAttendanceCheck(params).then((res) => {
                if (res.code === 200) {
                    this.$toast("打卡成功");
                    this.updateClockPopup = false;
                }
            });
        },

        // 输入时
        handleInputProduct(item) {
            this.getSearchProducts(item)
        },

        // 选中产品
        handleClickSelectProduct(item, list) {
            this.$set(item, 'product_name', list.name)
            this.$set(item, 'sku_id', list.sku_id)
            this.$set(item, 'sku_key', list.sku_key)
            this.$set(item, 'productPopoverShow', false)
        },

        // 采购计算金额
        handleCountPurchaseTotalPrice(item) {
            if (!item.price) {
                this.$set(item, 'price', 0.00)
            }
            this.$set(item, 'total_price', (Number(item.num) * Number(item.price)).toFixed(2))
            let total_price = 0
            this.customForm.purchase_details.forEach(list => {
                total_price += Number(list.total_price)
            })
            this.$set(this.customForm.total_price, 'value', total_price)
            this.$set(this.customForm.total_price, 'text', Number(total_price).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }))
            const total_price_field = this.formInfoList.find(find => find.field_key == 'total_price')
            this.formulaComputedFun(total_price_field, this.customForm, this.formInfoList)

        },

        // 选择采购仓库
        handleChangePurchaseStock(item) {
            this.purchaseDetailInfo = item
            this.selectStockPopupShow = true
        },

        // 选择仓库后回调
        selectStockSuccess(data) {
            this.$set(this.purchaseDetailInfo, 'stock_id', data.id)
            this.$set(this.purchaseDetailInfo, 'stock_name', data.name)
            this.purchaseDetailInfo = null
        },

        // 采购新增行
        handleClickPurchaseAdd(field, formData) {
            let json = {
                product_name: "",
                sku_id: 0,
                sku_key: "",
                stock_id: '',
                stock_name: '',
                num: null,
                price: null,
                total_price: null,
                note: ""
            }
            formData[field.field_key].push(json)
        },

        // 选择订单关联导入
        handleClickRelatedOrder(field, formData) {
            this.currentFieldData = field
            this.currentFieldFormData = formData
            this.selectOrderPopupShow = true
        },

        // 选择订单后回调
        successSelectOrderRefresh(data) {
            this.getPurchaseOrderGetProducts(data)
        },

        // 获取订单导入采购的物品详情
        getPurchaseOrderGetProducts(orderList) {
            this.loading = true
            let order_ids = orderList.map(item => item.order_id)
            PurchaseOrderGetProducts({order_ids: order_ids}).then(res => {
                if (res.code == 200) {
                    let {data} = res
                    let pushData = []
                    data.forEach(item => {
                        let json = {
                            product_name: item.product_name,
                            sku_id: item.sku_id,
                            sku_key: item.sku_key,
                            stock_id: '',
                            stock_name: '',
                            num: null,
                            price: null,
                            total_price: null,
                            note: ""
                        }
                        pushData.push(json)
                    })
                    let defaultData = JSON.parse(JSON.stringify(this.currentFieldFormData[this.currentFieldData.field_key]))
                    this.currentFieldFormData[this.currentFieldData.field_key] = []
                    this.currentFieldFormData[this.currentFieldData.field_key] = [...defaultData, ...pushData]
                }
                this.loading = false
            })
        },

        // 选择采购供应商名称
        handleClickSelectSupplierName(field, customForm, list) {
            customForm[field.field_key].value = list.name
            this.supplierNamePopoverShow = false
        },

        // 输入采购供应商名称筛选
        handleInputSupplierName(keyword) {
            PurchaseGetSupplier({
                keyword: keyword,
            }).then(res => {
                if (res.code === 200) {
                    let data = res.data.map((map) => {
                        return {name: map}
                    }) || []
                    this.supplierList = data
                }
            })
        },

        handleClickShowFormula(formula) {
            this.$dialog.alert({
                title: '订单金额公式',
                message: formula,
                confirmButtonColor: '#2990ff'
            }).then(() => {
                return false
            }).catch(() => {
                return false
            })
        },

        //订单代采金额输入框失焦事件
        handlePurchasePriceInputBlur() {
            let value = this.customForm.purchase_price.text.replace(/[^\d.\-]/g, '')
            this.$set(this.customForm.purchase_price, 'value', Number(Number(value).toFixed(2)))
            this.orderAmountInfoComputedMethod('purchase_price')
            this.$set(this.customForm.purchase_price, 'text', Number(value).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }))
            this.customForm.purchase_price.currency = 'CNY'
            this.computeTotalAmountForTheOrderList()
        },

        //删除已输入的订单代采金额
        handleClickDeletePurchasePrice() {
            this.$set(this.customForm.purchase_price, 'value', 0)
            this.$set(this.customForm.purchase_price, 'text', '')
            this.customForm.purchase_price.currency = 'CNY'
            this.order_procurement_show = false
            this.orderAmountInfoComputedMethod('purchase_price')
            this.computeTotalAmountForTheOrderList()
        },

        //订单添加产品
        handleClickAddProduct() {
            if (this.is_preview_mode) return this.$toast('当前控件不允许在预览中操作')
            this.selectProductsDialog = true
            if (this.customForm.order_goods.length > 0) {
                this.$nextTick(() => {
                    this.$refs.selectOrderProducts.selectedProductList = JSON.parse(JSON.stringify(this.customForm.order_goods))
                })
            }

            /* this.customForm.order_goods = [
                 {
                     "type": 1,
                     "goods_id": 65,
                     "goods_name": "买小米汽车送手机",
                     "goods_type": "bundle",
                     "goods_sku_id": 0,
                     "sku_key": "",
                     "goods_sku_name": "买小米汽车送手机",
                     "start_at": null,
                     "end_at": null,
                     "cost_price": "322020.00",
                     "guide_price": "523619.00",
                     "sale_guide_price": "523619.00",
                     "lease_guide_price": "860.00",
                     "price": {
                         "value": "523619.00",
                         "text": "523619.00",
                         "currency": "CNY",
                         "value_converted": "523619.00"
                     },
                     "num": 1,
                     "subtotal_price": {
                         "value": 523619,
                         "text": "523,619.00",
                         "currency": "CNY",
                         "value_converted": 523619
                     },
                     "unit": "",
                     "is_virtual": 1,
                     "goods_image": "https://download.hecoos.com/enlightv/2025-09/9e58548653c52ae5226d393dc24baa77.jpg",
                     "is_sale": 1,
                     "is_lease": 1,
                     "description": "性能比肩保时捷、科技紧追特斯拉、豪华媲美BBA",
                     "category_id": 9,
                     "_child": [
                         {
                             "type": 1,
                             "goods_id": 65,
                             "goods_name": "汽车",
                             "goods_sku_id": 75,
                             "sku_key": "270,275,277",
                             "goods_sku_name": "闪电黄-碳纤维车顶-经典拉花",
                             "part_id": 47,
                             "part_name": "汽车",
                             "start_at": null,
                             "end_at": null,
                             "cost_price": "320000.00",
                             "guide_price": "520000.00",
                             "num": 1,
                             "price": {
                                 "value": 0,
                                 "text": 0,
                                 "currency": "CNY",
                                 "value_converted": 0
                             },
                             "subtotal_price": {
                                 "value": 0,
                                 "text": 0,
                                 "currency": "CNY",
                                 "value_converted": 0
                             },
                             "unit": "台",
                             "is_virtual": 1
                         },
                         {
                             "type": 1,
                             "goods_id": 65,
                             "goods_name": "手机",
                             "goods_sku_id": 116,
                             "sku_key": "281,284",
                             "goods_sku_name": "小米手机-黑色-64G",
                             "part_id": 48,
                             "part_name": "手机",
                             "start_at": null,
                             "end_at": null,
                             "cost_price": "2000.00",
                             "guide_price": "3499.00",
                             "num": 1,
                             "price": {
                                 "value": 0,
                                 "text": 0,
                                 "currency": "CNY",
                                 "value_converted": 0
                             },
                             "subtotal_price": {
                                 "value": 0,
                                 "text": 0,
                                 "currency": "CNY",
                                 "value_converted": 0
                             },
                             "unit": "台",
                             "is_virtual": 1
                         },
                         {
                             "type": 1,
                             "goods_id": 65,
                             "goods_name": "苹果手机",
                             "goods_sku_id": 36,
                             "sku_key": "9,12",
                             "goods_sku_name": "苹果手机32G红色",
                             "part_id": 52,
                             "part_name": "苹果手机",
                             "start_at": null,
                             "end_at": null,
                             "cost_price": "20.00",
                             "guide_price": "120.00",
                             "num": 1,
                             "price": {
                                 "value": 0,
                                 "text": 0,
                                 "currency": "CNY",
                                 "value_converted": 0
                             },
                             "subtotal_price": {
                                 "value": 0,
                                 "text": 0,
                                 "currency": "CNY",
                                 "value_converted": 0
                             },
                             "unit": "台",
                             "is_virtual": 1
                         }
                     ],
                     "_X_ROW_KEY": "row_179"
                 },
                 {
                     "type": 2,
                     "goods_id": 63,
                     "goods_name": "小米su7 ultra",
                     "goods_type": "basic",
                     "goods_sku_id": 76,
                     "sku_key": "270,275,278",
                     "goods_sku_name": "闪电黄-经典拉花-碳纤维尾翼",
                     "start_at": "2025-03-01",
                     "end_at": "2025-03-29",
                     "cost_price": "320000.00",
                     "guide_price": "0.00",
                     "lease_guide_price": "",
                     "sale_guide_price": "520000.00",
                     "price": {
                         "value": "520000.00",
                         "text": "520000.00",
                         "currency": "CNY",
                         "value_converted": "520000.00"
                     },
                     "num": 1,
                     "subtotal_price": {
                         "value": 520000,
                         "text": "520,000.00",
                         "currency": "CNY",
                         "value_converted": 520000
                     },
                     "unit": "台",
                     "is_virtual": 1,
                     "goods_image": "https://download.hecoos.com/enlightv/2025-09/c7073f8b35d52f7e5bc055366307e37b.jpg",
                     "is_sale": 1,
                     "is_lease": 1,
                     "description": "",
                     "category_id": 6,
                     "_X_ROW_KEY": "row_180"
                 },
                 {
                     "type": 1,
                     "goods_id": 64,
                     "goods_name": "小米手机",
                     "goods_type": "basic",
                     "goods_sku_id": 116,
                     "sku_key": "281,284",
                     "goods_sku_name": "小米手机-黑色-64G",
                     "start_at": null,
                     "end_at": null,
                     "cost_price": "2000.00",
                     "guide_price": "3499.00",
                     "lease_guide_price": "",
                     "sale_guide_price": "3499.00",
                     "price": {
                         "value": "3499.00",
                         "text": "3499.00",
                         "currency": "CNY",
                         "value_converted": "3499.00"
                     },
                     "num": 1,
                     "subtotal_price": {
                         "value": 3499,
                         "text": "3,499.00",
                         "currency": "CNY",
                         "value_converted": 3499
                     },
                     "unit": "台",
                     "is_virtual": 1,
                     "goods_image": "https://download.hecoos.com/enlightv/2025-09/ed89cd116b0e6454c3e7a83d5c1706ea.jpg",
                     "is_sale": 1,
                     "is_lease": 0,
                     "description": "",
                     "category_id": 6,
                     "_X_ROW_KEY": "row_181"
                 }
             ]
             this.computeTotalAmountForTheOrderList()*/
        },

        //点击打开组合产品的配置
        handleClickExpandConfig(row) {
            if (row.hasOwnProperty('is_expand')) {
                row.is_expand = !row.is_expand
            } else {
                this.$set(row, 'is_expand', true)
            }
        },

        //订单商品类型切换
        handleGoodsTypeChange(row) {
            row.guide_price = row.type === 1 ? Number(row.sale_guide_price).toFixed(2) : Number(row.lease_guide_price).toFixed(2);
            if (row.type === 1) {
                row.start_at = ''
                row.end_at = ''
            } else {
                row.start_at = getNowDate()
                row.end_at = getNowDate()
            }
            if (row.goods_type === 'bundle') {
                row._child.forEach(item => {
                    item.type = row.type
                })
            }
            this.computeTotalAmountForTheOrderList()
        },

        //订单打开租借时间选择
        handleClickGoodsLeaseTimePicker(index) {
            this.goods_index = index
            this.goodsLeaseTimePickerVisible = true
        },

        //租借时间选择框确认
        handleClickGoodsLeaseTimeConfirm(date) {
            const [start, end] = date
            let value = [formatDate(start, 'date'), formatDate(end, 'date')]
            const goods = this.customForm.order_goods[this.goods_index]
            this.$set(goods, 'start_at', value[0])
            this.$set(goods, 'end_at', value[1])
            this.goodsLeaseTimePickerVisible = false
            this.handleGoodsDateChange(goods)
        },

        //订单租借商品切换时间
        handleGoodsDateChange(row) {
            if (Date.parse(row.end_at) < Date.parse(getNowDate())) {
                return this.$toast(row.order_goods_id ? '结束时间早于当前时间，商品需归还' : '请注意，结束时间早于当前时间')
            }
            this.$emit('getApproveNode')
        },

        //编辑订单商品
        handleClickEditGoods(row, index) {
            if (row.hasOwnProperty('return_num') && row.return_num > 0) return this.$toast.fail(`当前产品已归还${row.return_num}个，不允许修改配置`)
            this.goods_id = row.goods_id
            this.product_type = row.goods_type
            this.goods_detail = row
            this.goods_index = index
            this.productConfigDialogVisible = true
        },

        //获取产品配置信息
        handleGetProductConfig(data) {
            let presentlyGoods = {}
            if (this.goods_detail.order_goods_id) {
                presentlyGoods = this.customForm.order_goods.find(item => item.order_goods_id === this.goods_detail.order_goods_id)
            } else {
                presentlyGoods = this.customForm.order_goods[this.goods_index]
            }
            for (let dataKey in data) {
                this.$set(presentlyGoods, dataKey, data[dataKey])
            }
            this.$toast.success('编辑成功')
            this.computeTotalAmountForTheOrderList()
        },

        // 删除订单商品
        handleClickDeleteGoods(index) {
            this.customForm.order_goods.splice(index, 1)
            this.computeTotalAmountForTheOrderList()
        },

        // 商品优惠信息
        goodsDiscountsTextOrClass(row, key) {
            return goodsPriceDiscountsText(row)[key]
        },

        //获取选择的产品信息
        handleClickSelectProductsConfirm(data) {
            this.customForm.order_goods = data
            this.computeTotalAmountForTheOrderList()
        },

        //订单列表的单价输入框失焦事件
        handleProductPriceInputBlur(row) {
            let value = row.price.value.replace(/[^\d.]/g, '')
            this.$set(row.price, 'value', Number(value).toFixed(2))
            this.$set(row.price, 'text', Number(value).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }))
            row.price.value_converted = row.price.value
            const subtotal_price = row.price.value * row.num
            row.subtotal_price.value = Number(subtotal_price).toFixed(2)
            row.subtotal_price.text = Number(subtotal_price).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })
            row.subtotal_price.value_converted = row.subtotal_price.value
            this.computeTotalAmountForTheOrderList()
        },

        //订单列表的数量输入框失焦事件
        handleProductNumInputBlur(row) {
            if (row.return_num && row.return_num > 0 && row.num < row.return_num) {
                this.$set(row, 'num', row.return_num)
                return this.$toast.fail(`当前产品有${row.return_num}个已归还，无法减少`)
            }
            const subtotal_price = row.price.value * row.num
            this.$set(row.subtotal_price, 'value', Number(subtotal_price))
            this.$set(row.subtotal_price, 'text', Number(subtotal_price).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }))
            row.subtotal_price.value_converted = row.subtotal_price.value
            this.computeTotalAmountForTheOrderList()
        },

        //计算订单列表的订单总金额
        computeTotalAmountForTheOrderList() {
            let total_price = this.customForm.order_goods.reduce((pre, cur) => {
                return pre + Number(cur.subtotal_price.value)
            }, 0)
            if (this.order_procurement_show && this.customForm.purchase_price.value) {
                total_price = total_price + Number(this.customForm.purchase_price.value)
            }
            this.customForm.total_price.value = Number(total_price.toFixed(2))
            this.customForm.total_price.text = this.customForm.total_price.value.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })
            this.customForm.total_price.value_converted = this.customForm.total_price.value
            this.orderAmountInfoComputedMethod('total_price')
            this.orderAmountInfoComputedMethod('product_cost')
            this.orderAmountInfoComputedMethod('product_total_price')
            this.orderAmountInfoComputedMethod('purchase_price')
            this.$emit('getApproveNode')
        },

        //订单金额信息计算方法
        orderAmountInfoComputedMethod(field_key) {
            if (this.order_amount_compute_mode.length) {
                this.order_amount_compute_mode.forEach(field => {
                    if (field.field_formula.includes(field_key)) {
                        //拿出公式列表所有type为component的组件
                        const components = field.formula_list.filter(formula => formula.type === 'component' || formula.type === 'product_cost' || formula.type === 'product_total_price' || formula.type === 'purchase_price')
                        if (components.length) {
                            //接口需要的数据
                            const formulaValue = {}
                            components.forEach(component => {
                                if (component.type === 'component') {
                                    if (['order_amount_compute_mode', 'money_compute_mode'].includes(component.field_type)) {
                                        const value = this.customForm[component.field_key]?.value;
                                        formulaValue[component.field_key] = !isNaN(value) ? Number(value) : 0;
                                    }
                                } else if (component.type === 'product_cost' || component.type === 'product_total_price') {
                                    let filteredGoods = []
                                    if (!component.commodity_value_config || component.commodity_value_config.length === 0) {
                                        filteredGoods = this.customForm.order_goods;
                                    } else {
                                        component.commodity_value_config.forEach(config => {
                                            if (config.type === 'category') {
                                                this.customForm.order_goods.forEach(good => {
                                                    if (good.category_id === config.id) {
                                                        filteredGoods.push(good)
                                                    }
                                                })
                                            } else if (config.type === 'goods') {
                                                this.customForm.order_goods.forEach(good => {
                                                    if (good.goods_id === config.id) {
                                                        filteredGoods.push(good)
                                                    }
                                                })
                                            }
                                        })
                                    }
                                    if (field.applicable_products !== 'all') {
                                        const typeMap = {sale: 1, lease: 2};
                                        const productType = typeMap[field.applicable_products];
                                        filteredGoods = filteredGoods.filter(item => item.type === productType);
                                    }
                                    const sumFunc = (sum, item) => sum + (component.type === 'product_cost' ? parseFloat(item.cost_price) * item.num : Number(item.subtotal_price.value));
                                    formulaValue[component.field_key] = filteredGoods.reduce(sumFunc, 0);
                                } else if (component.type === 'purchase_price') {
                                    formulaValue[component.field_key] = this.customForm.purchase_cost_price ? Number(this.customForm.purchase_cost_price) : 0;
                                }
                            });
                            if (Object.values(formulaValue).length > 0) {
                                let res = calculate(field.field_formula, formulaValue)
                                res = isNaN(res) || !isFinite(res) ? 0 : res
                                if (field.num_display_style === '1') {
                                    this.$set(this.customForm[field.field_key], 'value', Number(res.toFixed(2)))
                                    this.$set(this.customForm[field.field_key], 'text', this.customForm[field.field_key].value.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    }))
                                    this.$set(this.customForm[field.field_key], 'value_converted', Number(res.toFixed(2)))
                                } else {
                                    this.$set(this.customForm[field.field_key], 'value', Number(res.toFixed(4)))
                                    this.$set(this.customForm[field.field_key], 'text', (Math.floor(this.customForm[field.field_key].value * 10000) / 100).toFixed(2))
                                    this.$set(this.customForm[field.field_key], 'value_converted', Number(res.toFixed(4)))
                                }
                                if (field.visible_person_range && field.visible_person_range.length) {
                                    const user_id = this.userInfo?.user?.id;
                                    const salesperson_ids = this.customForm?.salesperson?.value || [];
                                    let arr = []
                                    field.visible_person_range.forEach(item => {
                                        if (item.relate_type == "order_approver") {

                                        } else if (item.relate_type == "order_creator") {
                                            arr = arr.concat(salesperson_ids)
                                        } else {
                                            arr.push(item.uid)
                                        }
                                    })
                                    this.$set(field, 'initial_display', !arr.includes(user_id));
                                } else {
                                    // 如果 visible_person_range 为空或无效，隐藏字段
                                    this.$set(field, 'initial_display', false);
                                }
                                const amount_information = this.formInfoList.find(item => item.field_key === 'amount_information')
                                this.$set(amount_information, 'initial_display', false)
                                this.orderAmountInfoComputedMethod(field.field_key)
                                this.$emit('getApproveNode')
                            }
                        }
                    }
                })
            }
        },

        //粘贴信息识别
        handleClickParseInfo() {
            this.parseInfoVisible = true
        },

        //粘贴信息识别取消事件
        handleClickParseInfoCancel() {
            this.parseInfoVisible = false
            this.parseInfo = ''
        },

        //粘贴信息识别确定事件
        handleClickParseInfoConfirm() {
            if (!this.parseInfo) return this.$toast.fail('请输入或粘贴信息')
            addressParse({
                address: this.parseInfo
            }).then(res => {
                if (res.code === 200) {
                    this.customForm.receive_phone.value = res.data.mobile
                    this.customForm.receive_addr.value = res.data.addr
                    this.customForm.receive_name.value = res.data.name
                    this.$toast.success('识别成功')
                    this.handleClickParseInfoCancel()
                } else {
                    this.$toast.fail(res.message)
                }
            })
        },

        //发布
        handleClickPublish(is_validate = true) {
            if (is_validate) {
                let newArr = []
                let arrForm = []//哪些表单需要做校验
                arrForm.push('customForm')
                this.formInfoList.forEach(field => {
                    if (field.initial_display && !field.quote_field_key && !field.hasOwnProperty('initial_display_delete')) {
                        delete this.customForm[field.field_key]
                    }
                    if (!field.initial_display) {
                        if (field.field_type === 'date' && field.default) {
                            this.customForm[field.field_key].value = getNowDate(field.date_type)
                        } else if (field.field_type === 'table') {
                            this.customForm[field.field_key].forEach((row, index) => {
                                arrForm.push(`table_item_form_${field.field_key}_${index}`)
                                field._child.forEach(child => {
                                    if (!child.initial_display && child.field_type === 'date' && child.default) {
                                        row[child.field_key].value = getNowDate(child.date_type)
                                    }
                                })
                            })
                        } else if (field.field_type === 'control_group') {
                            this.customForm[field.field_key].forEach((row, index) => {
                                arrForm.push(`control_group_item_form_${field.field_key}_${index}`)
                            })
                        }
                    }
                })
                arrForm.forEach(item => {
                    let res = this.deepFormValidate(item)
                    newArr.push(res)
                })
                Promise.all(newArr).then(() => {
                    this.$emit('submit-form', this.customForm)
                }).catch(error => {
                    this.$toast(error[0].message || '请输入必填项')
                })
            } else {
                this.$emit('submit-form', this.customForm)
            }
        },

        //表单校验
        deepFormValidate(name) {
            const that = this
            return new Promise(function (resolve, reject) {
                if (that.$refs[name]) {
                    if (Array.isArray(that.$refs[name])) {
                        that.$refs[name][0].validate().then(() => {
                            resolve();
                        }).catch(error => {
                            reject(error)
                        })
                    } else {
                        that.$refs[name].validate().then(() => {
                            resolve();
                        }).catch(error => {
                            reject(error)
                        })
                    }
                } else {
                    resolve()
                }
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.custom_form_wrap {
    width: 100%;
    height: 100%;
    background-color: #F7F8FA;
    position: relative;
    overflow-y: auto;

    &.overflow_hidden {
        overflow-y: hidden;
    }

    .form_module_title {
        color: #333333;
        padding: 10px 16px 10px 28px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;

        &::before {
            content: '';
            width: 4px;
            height: 24px;
            opacity: 1;
            border-radius: 20px;
            background: #2990FF;
            position: absolute;
            left: 16px;
        }

        .field_name {
            font-weight: 700;
            font-size: 16px;
            line-height: 24px;
        }
    }

    ::v-deep .van-cell {
        line-height: 22px;
        color: #333333;

        .van-field__label {
            color: #333333;
            white-space: nowrap;
        }

        .van-field__control--custom {
            min-height: 22px;
        }

        &.van-field--disabled {
            background-color: #F5F7FA;
        }

        .van-field__control:disabled {
            color: #333333;
            -webkit-text-fill-color: #333333;
        }

        .van-field__control::placeholder {
            color: #999999;
        }

        &.van-field--error {
            color: #ee0a24 !important;

            .van-field__control::placeholder {
                color: #ee0a24;
            }
        }
    }

    /*::v-deep .van-cell--required::before {
            left: 8px;
        }*/

    .field_outer_wrap {
        margin-bottom: 1px;
    }

    .explain_wrap {
        padding: 10px 16px;
        background: #EDF0F4;
        line-height: 22px;
        color: #666666;
    }

    .radio_option_wrap {
        width: 100%;
        height: 100%;
        padding: 0 16px 35px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;

        .radio_option_list {
            max-height: calc(100% - 90px);
            overflow-y: auto;

            .radio_option_item {
                background-color: #FFFFFF;
                text-align: center;
                font-size: 16px;
                font-weight: 400;
                line-height: 24px;
                padding: 10px 0;
                color: #666666;
                border-bottom: 1px solid #DEDEDE;

                &:first-child {
                    border-radius: 8px 8px 0 0;
                }

                &:last-child {
                    border-bottom: none;
                    border-radius: 0 0 8px 8px;
                }
            }
        }

        .cancel_btn {
            background-color: #FFFFFF;
            text-align: center;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            padding: 10px 0;
            color: #666666;
            border-radius: 8px;
            box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.08);
            margin-top: 10px;
        }
    }

    ::v-deep .van-cascader__title {
        flex: 1;
        text-align: center;
        font-size: 16px;
        font-weight: 700;
        color: #333333;
        line-height: 24px;
    }

    .contact_select_wrap {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        background-color: #FFFFFF;
        position: absolute;
        bottom: 0;
        border-radius: 8px 8px 0 0;
        padding: 12px 16px;

        .contact_select_header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 12px;

            .van-icon-arrow-left {
                font-size: 24px;
            }

            .title {
                font-size: 16px;
                font-weight: 700;
                line-height: 24px;
                color: #333333;
            }
        }

        .contact_select_list {
            overflow-y: auto;
            flex: 1;
            margin-top: 10px;
            max-height: calc(100% - 78px);

            .contact_select_item {
                padding: 8px 0;
                display: flex;
                align-items: center;
                gap: 12px;

                .avatar_wrap {
                    display: inline-block;
                    width: 28px;
                    height: 28px;
                    border-radius: 50%;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 50%;
                    }
                }
            }
        }
    }

    .checkbox_select_wrap {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        background-color: #FFFFFF;
        position: absolute;
        bottom: 0;
        border-radius: 8px 8px 0 0;

        .checkbox_select_header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 12px;
            padding: 10px 16px;

            .van-icon-arrow-left {
                font-size: 24px;
            }

            .title {
                font-size: 16px;
                font-weight: 700;
                line-height: 24px;
                color: #333333;
            }
        }

        .checkbox_select_content {
            width: 100%;
            flex: 1;
            overflow-y: auto;
            border-top: 1px solid #F7F8FA;

            .checkbox_select_list {
                .checkbox_select_item {
                    padding: 10px 16px;
                    font-size: 14px;
                    line-height: 22px;
                    color: #333333;
                    display: flex;
                    gap: 8px;
                    border-bottom: 1px solid #F7F8FA;
                }
            }
        }
    }

    .field_name_wrap {
        padding: 0 16px;
        background: #FFFFFF;

        .field_name_inner {
            padding: 10px 0;
            border-bottom: 1px solid rgba(0, 0, 0, 0.04);
            font-weight: 700;
            line-height: 22px;
        }
    }

    .ocr_upload_wrap {
        width: 120px;
        height: 120px;
        border-radius: 2px;
        border: 1px dashed #D9D9D9;
        margin: 0 auto;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .el-icon-error {
            position: absolute;
            right: -8px;
            top: -8px;
            cursor: pointer;
        }

        input {
            opacity: 0;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            cursor: pointer;
        }

        .ocr_upload_inner_wrap {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            .el-icon-plus {
                color: #666666;
                font-size: 24px;
                font-weight: bold;
            }

            .upload_text {
                line-height: 22px;
                color: #333333;
                margin-top: 12px;
            }
        }
    }

    .ocr_upload_hint {
        color: #999999;
        font-size: 12px;
        line-height: 26px;
        text-align: center;
    }

    .select_bank_card_wrap {
        width: 100%;
        height: 100%;
        background-color: #F7F8FA;
        display: flex;
        flex-direction: column;

        .select_bank_card_body {
            padding: 10px 16px;
            flex: 1;

            .select_bank_card_list {
                padding: 10px;
                border-radius: 2px;
                background: #FFFFFF;
                height: 100%;
                overflow-y: auto;

                .select_bank_card_item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    border-bottom: 1px solid #F3F3F3;
                    padding: 10px 0;
                    gap: 4px;

                    &:last-child {
                        border-bottom: none;
                    }

                    .left_info_wrap {
                        flex: 1;
                        display: flex;
                        align-items: center;
                        max-width: calc(100% - 26px);

                        .bank_logo {
                            display: block;
                            margin: 0 10px;
                            width: 44px;
                            height: 37px;
                        }

                        .account_name {
                            color: #333333;
                            font-weight: 500;
                            margin-right: 4px;
                        }

                        .bank_name {
                            color: #666666;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            line-height: 22px;
                        }
                    }
                }
            }
        }
    }

    .select_bank_card_header {
        padding: 12px 16px;
        line-height: 22px;
        color: #222222;
        font-size: 18px;
        font-weight: 500;
        background-color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .van-icon-arrow-left {
            margin-right: 4px;
            vertical-align: middle;
        }

        span {
            vertical-align: middle;
        }
    }

    .add_teller_wrap {
        padding: 10px 16px;
        height: calc(100% - 50px);
        position: relative;
        background: #F7F8FA;

        ::v-deep .van-cell {
            border-bottom: 1px solid #F3F3F3;
            margin-bottom: 10px;
        }

        .submit_btn_wrap {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 16px;
            padding: 0 16px;
        }
    }

    .image_outer_wrap {
        .image_upload_wrap {
            width: 44px;
            height: 44px;
            opacity: 1;
            border-radius: 4px;
            background: #EDF0F4;
            text-align: center;
            line-height: 44px;
            margin-bottom: 2px;
            cursor: pointer;
            position: relative;

            .upload_input {
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                opacity: 0;
                cursor: pointer;
            }
        }

        .upload_image_list {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;

            .upload_image_item {
                width: 44px;
                height: 44px;
                opacity: 1;
                border-radius: 4px;
                text-align: center;
                line-height: 44px;
                position: relative;

                .el-image {
                    width: 100%;
                    height: 100%;
                    border-radius: 4px;
                }

                .el-icon-error {
                    position: absolute;
                    right: -8px;
                    top: -8px;
                    color: #999999;
                    font-size: 16px;
                    cursor: pointer;
                }
            }
        }

        .image_hint {
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 18px;
            color: #999999;
        }
    }

    .upload_btn_outer_wrap {
        display: flex;
        gap: 8px;
        align-items: center;
        justify-content: center;
        color: #2990FF;
    }

    .invoice_list {
        width: 100%;

        .invoice_item {
            width: 100%;
            padding: 8px 12px;
            border-radius: 2px;
            background: #EDF0F4;
            margin-bottom: 8px;

            .invoice_title_wrap {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 4px;
                line-height: 22px;

                .purchaser_name {
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 22px;
                    color: #666666;
                }
            }

            .invoice_total_amount {
                font-weight: 700;
                line-height: 22px;
                color: #333333;
            }
        }
    }

    .purchase_details_wrap {
        width: 100%;
        padding: 10px 16px 0;
        box-sizing: border-box;
        background: #fff;

        .purchase_details_title {
            line-height: 22px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .purchase_details_title_name {
                color: rgba(153, 153, 153, 1);
                font-size: 14px;
            }
        }

        .purchase_details_list {
            width: 100%;

            .purchase_details_list_item {
                width: 100%;
                border-radius: 8px;
                margin-top: 8px;
                padding: 0 10px;
                box-sizing: border-box;
                background: rgba(247, 248, 250, 1);
                position: relative;

                .field_wrap {
                    border-bottom: 1px solid rgba(232, 232, 232, 1);
                    box-sizing: border-box;

                    &:last-child {
                        border-bottom: 0;
                    }
                }

                .van-cell {
                    padding-left: 0;
                    padding-right: 0;
                    background: rgba(247, 248, 250, 1);
                }

                ::v-deep .van-cell--required::before {
                    left: -6px;
                }

                .el-icon-error {
                    position: absolute;
                    right: 0;
                    top: -3px;
                    z-index: 10;
                    color: rgba(153, 153, 153, 1);
                }
            }
        }

        .purchase_details_add {
            text-align: center;
            line-height: 22px;
            padding: 10px;
            box-sizing: border-box;
            color: rgba(25, 144, 255, 1);

            i {
                margin-right: 4px;
            }
        }
    }

    .table_field_title {
        font-size: 14px;
        font-weight: 700;
        line-height: 22px;
        color: #333333;
        padding-bottom: 10px;
        border-bottom: 1px solid #F7F8FA;
    }

    .vertical_table_list {
        .vertical_table_item {
            padding: 10px;
            background-color: #F7F8FA;
            border-radius: 4px;
            margin-bottom: 10px;

            .vertical_table_item_title {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 8px;
            }

            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    .related_check_record_list {
        background: #ffffff;
        padding: 10px 16px;
        margin-bottom: 0;
    }

    .related_approval_list {
        background: #ffffff;
        padding: 10px 16px;
        margin-bottom: 0;
    }

    .check_record_btn {
        background-color: #FFFFFF;
        text-align: center;
        padding: 10px 0;
        border-bottom: 1px solid #E8E8E8;
    }

    .placeholder {
        color: #999999;
    }
}

::v-deep .van-dialog__header {
    padding-top: 16px;
    font-weight: 700;
    color: #333333;
}

::v-deep .van-dialog__content {
    padding: 16px;
}

.purchase_details_wrap ::v-deep .van-popover[data-popper-placement="bottom-start"] .van-popover__arrow {
    display: none !important;
}

.productItemBox {
    width: calc(100vw - 56px);
    padding: 8px 2px;
    box-sizing: border-box;
    max-height: 220px;
    overflow-y: auto;

    .product_item {
        width: 100%;
        line-height: 30px;
        padding: 0 12px;
        color: rgba(102, 102, 102, 1);

        &:active {
            color: rgba(102, 102, 102, 1);
            background: rgba(0, 0, 0, 0.04);
        }

        .product_name {
            display: block;
            width: calc(100% - 50px);
        }

        .product_tag {
            width: 40px;
            height: 22px;
            opacity: 1;
            border-radius: 4px;
            background: rgba(240, 170, 50, 0.1);
            line-height: 22px;
            font-size: 12px;
            color: rgba(240, 170, 50, 1);
            text-align: center;
        }
    }

}

.total_price_wrap {
    line-height: 22px;
    padding: 12px 16px;
    background: #EDF0F4;

    .money_compute_mode_text {
        font-weight: 700;
        line-height: 22px;
        color: #333333;
    }
}

.purchase_price_wrap {
    padding: 10px 16px;
    background: #FFFFFF;
    border-bottom: 1px solid #E8E8E8;
}

.order_goods_list {
    .order_goods_item {
        padding: 12px 0 0;
        border-bottom: 1px solid #E8E8E8;

        .goods_info_wrap {
            align-items: start;

            .goods_image_wrap {
                margin-right: 4px;

                img {
                    width: 44px;
                    height: 44px;
                    opacity: 1;
                    border-radius: 4px;
                }
            }

            .goods_name_wrap {
                flex: 1;
                max-width: calc(100% - 50px);

                .goods_name {
                    flex: 1;
                    font-weight: 700;
                    line-height: 22px;
                    color: #333333;

                }

                .goods_price {
                    .goods_price_label {
                        font-size: 12px;
                        font-weight: 700;
                        line-height: 18px;
                        color: #999999;
                    }

                    .goods_price_value {
                        font-size: 12px;
                        line-height: 18px;
                        color: #E44144;
                    }
                }

                .goods_num {
                    font-size: 12px;
                    font-weight: 700;
                    line-height: 18px;
                    color: #333333;
                }
            }
        }

        .goods_spec_wrap {
            display: flex;
            align-items: start;
            gap: 4px;

            .handle_expand_btn {
                line-height: 18px;
            }

            .goods_spec_list {
                max-width: calc(100% - 62px);
            }
        }

        .goods_amount_wrap {
            display: flex;
            align-items: start;
            justify-content: space-between;
            margin-top: 8px;
            border-bottom: 1px solid #E8E8E8;
            padding-bottom: 12px;

            .iconfont {
                color: #E8E8E8;
            }

            .subtotal_price {
                font-weight: 700;
                line-height: 22px;
                color: #333333;
            }

            .cost_guide_price_wrap {
                img {
                    vertical-align: middle;
                }

                span {
                    line-height: 22px;
                    color: #333333;
                    vertical-align: middle;
                    margin-right: 4px;
                }
            }
        }

        ::v-deep .van-cell::after {
            left: 0;
            right: 0;
            transform: scale(1);
            border-bottom: 1px solid #E8E8E8;
        }

        ::v-deep .van-field {
            padding: 12px 0;

            .van-cell__value .van-field__control--right {
                text-align: right;
            }
        }
    }
}

.relate_table_search {
    position: relative;

    .van-search {
        padding: 6px 16px;
    }

    .handle_icon_wrap {
        position: absolute;
        right: 40px;
        top: 12px;
    }
}

.detail_wrap_container {
    background-color: #F7F8FA;
    height: calc(100% - 98px);
    padding-top: 10px;

    .relate_project_list {

        .relate_project_item {
            margin-bottom: 4px;
            background-color: #FFFFFF;
            padding: 12px 16px;

            .relate_project_title {
                padding-bottom: 8px;
                border-bottom: 1px solid #E8E8E8;
                margin-bottom: 8px;
            }

            .relate_project_content {
                .field_label {
                    color: #999999;
                }
            }
        }
    }

    .relate_check_record_list {
        padding: 0 16px;

        .relate_check_record_item {
            padding: 8px 12px;
            border-radius: 6px;
            background: #FFFFFF;
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            gap: 8px;

            &:last-child {
                margin-bottom: 0;
            }
        }
    }
}

.relate_approve_wrap {
    padding: 10px 16px;
    background-color: #FFFFFF;

    .relate_approve_list {
        max-height: calc(100% - 66px);
    }
}

.clock_in_container {
    width: 100%;
    height: calc(100% - 70px);
    background-color: #FAFAFA;
    padding: 16px;

    h4 {
        flex: 1;
        text-align: center;
    }

    .clock_in_time_wrap {
        padding: 10px;
        border-radius: 8px;
        background: #FFFFFF;
        margin-top: 24px;
        margin-bottom: 10px;

        .clock_in_formatted_time {
            font-size: 36px;
            font-weight: 700;
            line-height: 52px;
            color: #333333;
            margin-bottom: 10px;
        }

        .clock_in_formatted_date, .clock_in_formatted_week_day {
            color: #999999;
            font-weight: 500;
            line-height: 22px;
        }

        .clock_in_formatted_date {
            margin-bottom: 10px;
        }
    }
}

.clock_in_btn {
    margin: 0 auto;
    text-align: center;
    background-color: #FAFAFA;
    padding: 16px 0;

    .van-button {
        width: 112px;
        height: 38px;
        border-radius: 8px;
        font-size: 16px;
        font-weight: 700;
        background-color: rgba(41, 144, 255, 0.8);
        border: none;

        &:active {
            background-color: rgba(41, 144, 255, 0.6);
        }
    }
}

.clockIn_success_wrap {
    width: 100%;
    height: 100%;
    border-radius: 8px 8px 0 0;
    background: rgba(250, 250, 250, 1);
    box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.08);
    padding: 30px 16px 10px;

    .clockIn_success_icon {
        text-align: center;

        img {
            width: 74px;
            height: auto;
        }

        p {
            margin-top: 14px;
            font-size: 16px;
            font-weight: 700;
            letter-spacing: 0px;
            line-height: 24px;
            color: rgba(51, 51, 51, 1);
        }
    }
}

.van-action-sheet__item {
    position: relative;

    input {
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
    }
}

.upload_img_wrap {
    display: flex;
    gap: 10px;

    .item_img_wrap {
        width: 30px;
        height: 30px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .upload_icon {
        position: relative;
        width: 30px;
        height: 30px;
        opacity: 1;
        border-radius: 4px;
        background: rgba(247, 248, 250, 1);
        display: flex;
        justify-content: center;
        align-items: center;

        .iconfont {
            color: rgba(102, 102, 102, 1);
            font-size: 16px;
        }

        input {
            position: absolute;
            width: 100%;
            height: 100%;
            opacity: 0;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
        }
    }

    .item_img {
        width: 30px;
        height: 30px;
        position: relative;

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

        .iconfont {
            position: absolute;
            top: -5px;
            right: -5px;
            font-size: 16px;
            color: rgba(153, 153, 153, 1);
            background-color: #ffffff;
            border-radius: 50%;
        }
    }
}

.update_clock_popup_content {
    padding: 0 20px;

    .map_tip {
        padding: 0 0 10px 0;
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        text-align: center;
        line-height: 18px;
        color: rgba(153, 153, 153, 1);
    }

    .cell_group_wrap {
        & > div {
            padding: 12px 0;
        }

        ::v-deep {
            .van-cell {
                padding: 0;
            }
        }
    }

    .update_clock_btn {
        padding: 10px 0;

        .van-button {
            width: 100%;
            height: 38px;
            border-radius: 8px;
            background: rgba(25, 144, 255, 1);
        }
    }
}

::v-deep .van-overlay {
    z-index: 15;
}

.project_group_id_change {
    font-size: 12px;
    line-height: 18px;
    color: #e44144;
    text-align: right;
    padding: 0 16px;
}
</style>